<template>
  <div class="p_resource_module1 p_resource_sign">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <el-form-item label="项目名称:" v-if="activeName != '在职' && activeName != '离职'">
            <el-select ref="mySelected" v-model="listQuery.strProjectName" filterable clearable size="small" placeholder="" @change="proSearChange" style="width:180px">
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="项目名称:" v-if="activeName == '在职' || activeName == '离职'">
            <el-select ref="mySelected" v-model="listQuery.strProjectName" filterable clearable size="small" placeholder="" @change="proSearChange" style="width:180px">
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="姓名:">
            <el-input v-model="listQuery.strUserName" size="small" clearable @keyup.enter.native="searchHandle" style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="联系方式:">
            <el-input v-model="listQuery.strMobile" size="small" clearable @keyup.enter.native="searchHandle" style="width:180px"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="screenInput">
              <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                <i class="i_txt" @click="dropDownScreen">更多<i class="el-icon-caret-bottom"></i></i>
              </el-tooltip>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form eleForm" label-width="100px">
          <el-form-item label="招聘岗位:" v-if="activeName != '在职' && activeName != '离职'">
            <el-select v-model="listQuery.strJobInf" filterable clearable size="small" placeholder="" style="width:180px">
              <el-option v-for="(item, index) in searPostList" :key="index" :label="item.CustomerJobName" :value="item.CustomerJobName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="招聘岗位:" v-if="activeName == '在职' || activeName == '离职'">
            <el-input v-model="listQuery.strJobInf" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="招聘渠道:">
            <el-select v-model="listQuery.strSource" clearable placeholder="" size="small" style="width:180px">
              <el-option value="社招">社招</el-option>
              <el-option value="公司渠道">公司渠道</el-option>
              <el-option value="外部渠道">外部渠道</el-option>
              <el-option value="企业转移">企业转移</el-option>
              <el-option value="内荐">内荐</el-option>
              <el-option value="独立招聘">独立招聘</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="招聘顾问:" v-if="userLabel!='K'">
            <el-select size="small" placeholder="" v-model="listQuery.strreuser" filterable clearable style="width:180px">
              <el-option v-for="(item, index) in memberSearchList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客服:" v-if="userLabel!='K'">
            <el-select size="small" placeholder="" v-model="listQuery.strUserkf" filterable clearable style="width:180px">
              <el-option v-for="(item, index) in memberSearchList" :key="index" :label="item.Username" :value="item.Userid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="简历来源:">
            <el-select v-model="listQuery.strSourcejl" clearable placeholder="" size="small" filterable style="width:180px">
              <el-option v-for="item in originList" :key="item.Id + 'w'" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否在保:" v-if="activeName == '在职' || activeName == '离职'">
            <el-select v-model="listQuery.isInsure" clearable placeholder="" size="small" filterable style="width:180px">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否扫码入职:">
            <el-select v-model="listQuery.StrOtherSource" clearable placeholder="" size="small" filterable style="width:180px">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用工之日:" v-if="activeName == '在职' && listQuery.SignatureStatus != '4'">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtBDate" type="date" style="width:180px" placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用工之日:" v-if="activeName == '在职' && listQuery.SignatureStatus != '4'">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtEDate" type="date" style="width:180px" placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="到期提醒:" v-if="activeName == '在职' && listQuery.SignatureStatus != '4'">
            <el-select v-model="listQuery.expireWarn" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option value="cardid" label="身份证到期">
              </el-option>
              <el-option value="test" label="试用期到期">
              </el-option>
              <el-option value="cont" label="合同到期">
              </el-option>
              <el-option value="age16" label="16周岁以下">
              </el-option>
              <el-option value="age18" label="16~18周岁">
              </el-option>
              <el-option value="oldman" label="退休男">
              </el-option>
              <el-option value="oldwoman" label="退休女">
              </el-option>
              <el-option value="hurt" label="工伤纠纷">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同协议类型:" v-if="activeName == '在职' && listQuery.SignatureStatus != '4'">
            <el-select v-model="listQuery.StrContractType " size="small" style="width: 180px;" placeholder="" filterable>
              <el-option value="劳动合同"></el-option>
              <el-option value="实习管理协议"></el-option>
              <el-option value="退休返聘协议"></el-option>
              <el-option value="兼职协议"></el-option>
              <el-option value="非全日制用工协议"></el-option>
              <el-option value="自由职业者服务协议"></el-option>
              <el-option value="无"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>

    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/signupList' }">面试入职流程</el-breadcrumb-item>
          <el-breadcrumb-item>{{ pageCrumb }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <ResourceComTabs ref="child" :active="activeName" :btnAuth="permissionLists" :listQuerys="listQuery" @change="currChange($event)"></ResourceComTabs>
        <div style="padding-left:20px ;">
          <el-tabs v-if="activeName == '在职'" v-model="listQuery.SignatureStatus" @tab-click="handleClick">
            <el-tab-pane label="全部" name="0"></el-tab-pane>
            <el-tab-pane label="未签约" name="1"></el-tab-pane>
            <el-tab-pane label="已签约" name="2"></el-tab-pane>
            <el-tab-pane label="将到期" name="3"></el-tab-pane>
            <el-tab-pane label="流程确认入职" name="4"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="r_act_box">
          <div class="r_act_left">
            <!-- 报名页面按钮 -->
            <div class="r_act_item" v-if="activeName == '报名'">
              <el-button size="small" type="success" v-if="checkPermission(['tab_signUp_register'], permissionLists)" @click="registHandle('报名登记')">报名登记</el-button>
              <el-button size="small" type="success" v-if="checkPermission(['tab_signUp_toInterview'], permissionLists)" @click="surDialogHandle">安排面试</el-button>
              <!-- 客服 -->
              <!-- <el-button v-if="checkPermission(['signupList_notreach'], permissionLists)" size="small" type="primary" @click="revokeHandle('未到面')">放弃面试</el-button> -->
              <el-button size="small" type="primary" v-if="checkPermission(['tab_signUp_notInterview'], permissionLists)" @click="revokeHandle('放弃面试')">放弃面试</el-button>
            </div>
            <!-- <div class="r_act_item" v-if="activeName == '报名'&&checkPermission(['signupList_abandon_employ'],permissionLists)">
              <el-button size="small" type="primary" @click="abadonHandle">放弃入职</el-button>
            </div> -->
            <!-- 待面试页面按钮 -->
            <!-- <div class="r_act_item" v-if="activeName == '待面试' && (checkPermission(['signupList_surface'], permissionLists))">
              <el-button size="small" type="success" @click="registHandle('约面登记')">待面试登记</el-button>
            </div> -->
            <div class="r_act_item" v-if="activeName == '待面试' && (checkPermission(['tab_interview_registration'], permissionLists))">
              <el-button size="small" type="success" @click="signHandle('interView')">待面试登记</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '待面试' && checkPermission(['tab_interview_import'], permissionLists)">
              <el-button size="small" type="success" @click="importHandle('first')">批量导入待面试</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '待面试' && checkPermission(['tab_interview_pass'], permissionLists)">
              <el-button size="small" type="primary" @click="passInterviewHandle">通过</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '待面试' && checkPermission(['tab_interview_notPass'], permissionLists)">
              <el-button size="small" type="primary" @click="failInterHandle">不通过</el-button>
            </div>
            <!-- 待入职页面按钮 -->
            <div class="r_act_item" v-if="activeName == '待入职' && checkPermission(['tab_entry_import'], permissionLists)">
              <el-button size="small" type="success" @click="importHandle('second')">批量导入待入职</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '待入职' && checkPermission(['tab_entry_registration'], permissionLists)">
              <el-button size="small" type="warning" @click="signHandle('entry')">待入职登记</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '待入职' && checkPermission(['tab_entry_batchEntry'], permissionLists)">
              <el-button size="small" type="danger" @click="batchEntry">批量入职</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '待入职'">
              <el-button size="small" type="success" @click="insDialogHandle('报增', '8')" v-if="checkPermission(['tab_entry_insurance'], permissionLists)">商保</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '待入职' && checkPermission(['tab_entry_unemployed'], permissionLists)">
              <el-button size="small" type="primary" @click="unemployedHandle">未入职</el-button>
            </div>
            <!-- 已约面页面按钮 -->
            <div class="r_act_item" v-if="activeName == '已约面' && (checkPermission(['signupList_toFace'], permissionLists))">
              <el-button size="small" type="success" @click="tofaceHandle">到面</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '已约面' && (checkPermission(['signupList_checkin'], permissionLists))">
              <el-button size="small" type="success" @click="registHandle('约面登记')">约面登记</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '已约面'">
              <!-- 客服 -->
              <el-button v-if="checkPermission(['signupList_notreach'], permissionLists)" size="small" type="primary" @click="revokeHandle('放弃面试')">放弃面试</el-button>
              <!-- 招聘 -->
              <el-button v-if="checkPermission(['signupList_cancel'], permissionLists)" size="small" type="primary" @click="revokeHandle('取消约面')">取消约面</el-button>
            </div>
            <!-- 到面页面按钮 招聘不能看 -->
            <div class="r_act_item" v-if="activeName == '到面' && checkPermission(['signupList_interview_pass'], permissionLists)">
              <el-button size="small" type="success" @click="passInterviewHandle">面试通过</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '到面' && (checkPermission(['signupList_faced_register'], permissionLists))">
              <el-button size="small" type="success" @click="checkInterHandle">到面登记</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '到面' && (checkPermission(['signupList_failpass'], permissionLists))">
              <el-button size="small" type="primary" @click="failInterHandle">未通过</el-button>
            </div>
            <!-- 通过页面按钮 招聘不能-->
            <div class="r_act_item" v-if="activeName == '通过' && (checkPermission(['signupList_unemployed'], permissionLists))">
              <el-button size="small" type="primary" @click="unemployedHandle">未入职</el-button>
            </div>
            <el-button v-if="activeName == '待离职' && (checkPermission(['tab_resign_batchQuit'], permissionLists))" type="danger" style="margin-right: 10px;" size="small" @click="quitBatchHandle()">离职确认</el-button>
            <!-- 在职页面按钮 -->
            <!-- 招聘和西南招聘不能 -->
            <!-- <div class="r_act_item" v-if="activeName == '在职'&&(checkPermission(['signupList_entry_check'],permissionLists))&&(listQuery.SignatureStatus != '4')">
              <el-button size="small" type="primary" @click="enrollHandle">入职登记</el-button>
            </div> -->
            <div class="r_act_item" v-if="activeName == '在职' && (listQuery.SignatureStatus != '4')">
              <el-button type="success" size="small" v-if="checkPermission(['tab_onJob_sign'], permissionLists)" @click="entryHandel">入职登记</el-button>
              <el-button size="small" type="primary" v-if="checkPermission(['tab_onJob_eleSign'], permissionLists)" @click="eleSigning">电子签约</el-button>
              <!-- <el-button size="small" type="primary" @click="offSign">线下签约导入</el-button> -->
              <!-- <el-button size="small" type="success" @click="insDialogHandle('报增','9')" v-if="checkPermission(['signupList_insurance'],permissionLists)">商保</el-button> -->
              <el-popconfirm title="请确认是否办理商保报减？" v-if="checkPermission(['tab_onJob_reduction'], permissionLists)" @confirm="reduction('multipleSelection')" style="margin:0 10px">
                <el-button type="info" slot="reference" size="small" v-preventReClick>商保报减</el-button>
              </el-popconfirm>
              <el-button size="small" type="success" v-if="checkPermission(['tab_onJob_recruiting'], permissionLists)" @click="handleInsure">批量商保增员+</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '异常' && (checkPermission(['tab_end_termination'], permissionLists))">
              <el-button size="small" type="primary" @click="endHandle">终止</el-button>
            </div>
            <div class="r_act_item" v-if="activeName == '异常'">
              <el-popconfirm :title="`请确认是否回退选中的${multipleSelection.length}条数据？`" v-if="activeName == '异常' && (checkPermission(['tab_end_back'], permissionLists))" @confirm="backHandle()" style="margin:0 10px">
                <el-button type="info" slot="reference" size="small" v-preventReClick>回退</el-button>
              </el-popconfirm>
            </div>
            <div class="r_act_item" v-if="(activeName == '已约面' || activeName == '通过') && noteNum > 0">
              <el-button size="small" class="com_btn" @click="noticeHandle">通知</el-button>
            </div>
            <!-- &&(checkPermission(['signupList_import_face'],permissionLists)) -->
            <div class="r_act_item" v-if="(activeName == '到面')">
              <el-button size="small" class="com_btn" @click="importHandle('five')">导入</el-button>
            </div>
            <!-- 客服、客服经理、管理员 &&(checkPermission(['signupList_import_entry'],permissionLists)) -->
            <div class="r_act_item" v-if="(activeName == '在职') && (listQuery.SignatureStatus != '4')">
              <el-button size="small" class="com_btn" @click="importHandle('third')" v-if="checkPermission(['tab_onJob_import'], permissionLists)">批量导入入职</el-button>
            </div>
            <div class="r_act_item" v-if="(activeName == '在职') && (listQuery.SignatureStatus != '4')">
              <el-button size="small" class="com_btn" @click="importHandle('four')" v-if="checkPermission(['tab_onJob_importQuit'], permissionLists)">批量导入离职</el-button>
            </div>
            <div class="r_act_item" v-if="(activeName == '在职') && (listQuery.SignatureStatus == '4')">
              <el-button size="small" class="com_btn" @click="employBatchHandle">批量处理流程入职</el-button>
            </div>
            <div class="r_act_item" v-if="(activeName == '离职')">
              <el-popconfirm title="请确认是否办理商保报减？" v-if="checkPermission(['tab_all_reduce'], permissionLists)" @confirm="reduction('multipleSelection')" style="margin:0 10px">
                <el-button type="info" slot="reference" size="small" v-preventReClick>商保报减</el-button>
              </el-popconfirm>
              <el-button size="small" type="primary" @click="eleSigning">电子签约</el-button>
              <el-button size="small" class="com_btn" @click="importHandle('four')" v-if="checkPermission(['tab_onJob_importQuit'], permissionLists)">批量导入离职</el-button>
            </div>
            <div class="r_act_item" v-if="(checkPermission(['tab_signUp_export'], permissionLists)) && (listQuery.SignatureStatus != '4')">
              <el-button size="small" class="com_btn" @click="exportHandle" :loading="btnLoading">导出</el-button>
            </div>

            <el-button size="small" type="primary" class="com_btn" v-if="(checkPermission(['tab_entry_codeEmpExport'], permissionLists)) && activeName == '待入职'" @click="H5OutExcel" :loading="btnLoading">扫码入职人员导出</el-button>

            <el-button size="small" type="danger" v-if="activeName == '待入职'" @click="iulHandle">导出使用人数</el-button>

            <el-button size="small" type="warning" class="com_btn" v-preventReClick v-if="(checkPermission(['print'], permissionLists))" @click="batchPrint">批量打印</el-button>

            <el-button size="small" type="success" @click="openSendNoticeDialog" v-if="(checkPermission(['sendMsg'], permissionLists))">发送通知</el-button>

            <el-button size="small" type="danger" @click="sendModelSet" v-if="(checkPermission(['sendMsgSet'], permissionLists))">通知模板配置</el-button>

          </div>
        </div>
        <div class="qrBox1" v-if="(activeName == '待面试' || activeName == '待入职') && (checkPermission(['tab_interview_generateRQcode'], permissionLists) || checkPermission(['tab_entry_generateRQcode'], permissionLists))">
          <div class="qrItem">
            <div class="r_txt01">{{ activeName }}登记二维码:</div>
            <el-select v-model="qrProQuery.projectid" filterable clearable size="small" placeholder="请选择项目" @change="proQrChange" style="width:180px;margin-right:10px">
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
              </el-option>
            </el-select>
            <el-select class="s_sel_box" v-model="qrProQuery.strVal" filterable clearable style="width:180px" size="small" placeholder="请选择岗位">
              <el-option v-for="(item, index) in searPostList" :key="index" :label="item.CustomerJobName" :value="item.Id">
              </el-option>
            </el-select>
            <el-popover placement="left" width="200" trigger="click" class="img_popover">
              <div class="qrcode_box" v-loading="codeloading" element-loading-text="二维码生成中...">
                <div class="eleTltle">{{this.activeName=='待面试' ? '面试登记' : '入职登记'}}</div>
                <img :src="canvasImg2" class="qrcode_img02" />
              </div>
              <el-button slot="reference" class="qcode_btn" type="text">
                <img src="./../../assets/images/qrcode.png" class="qrcode_img01" @click="cerateQCode" />
              </el-button>
            </el-popover>
          </div>
          <div class="qrItem" style="margin-left:20px">
            <div class="r_txt01">杰小职二维码:</div>
            <el-select v-model="xjzprojectid" filterable clearable size="small" placeholder="请选择项目" style="width:180px;margin-right:10px" @change="xjzProChange">
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
              </el-option>
            </el-select>
            <el-popover placement="left" width="200" trigger="click" class="img_popover">
              <div class="qrcode_box" v-loading="codeloading" element-loading-text="二维码生成中...">
                <div class="eleTltle">杰小职</div>
                <div class="eleTltle2">项目名称： {{ xjzprojectname }}</div>
                <img :src="JXZQCode" class="qrcode_img03" />
              </div>
              <el-button slot="reference" class="qcode_btn" type="text">
                <img src="./../../assets/images/qrcode.png" class="qrcode_img01" @click="cerateJXZQCode" />
              </el-button>
            </el-popover>
          </div>
        </div>
        <el-table ref="multipleTable" class="re_table" :row-class-name="tableRowClassName" border v-loading="tableLoading" :highlight-current-row="true" @selection-change="handleSelectionChange" :max-height="tableHeight < 320 ? 320 : tableHeight - 100" :data="tableData" style="width:100%">
          <el-table-column type="selection" align="center" width="55" v-if="switchBtn" label-class-name="com_Selection"></el-table-column>
          <template v-for="(item, index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index + 'A'" :min-width="item.StrColumName.indexOf('序号') > -1 || item.StrColumName.indexOf('性别') > -1 || item.StrColumName.indexOf('年龄') > -1 || item.StrColumName.indexOf('籍贯') > -1 || item.StrColumName.indexOf('学历') > -1 ? '50px' : item.StrColumName.indexOf('项目名称') > -1 || item.StrColumName.indexOf('客户名称') > -1 || item.StrColumName.indexOf('原因') > -1 || item.StrColumName.indexOf('地') > -1 || item.StrColumName.indexOf('时间') > -1 ? '170px' : '110px'" align="center" :fixed="item.StrColumName == '序号' || item.StrColumName == '姓名'|| item.StrColumName == '身份证'">
              <template slot-scope="{row}">
                <span v-if="item.StrColumId == 'StrUserName' && row.sendtype == '1'" class="send_icon">
                  {{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId] }}
                </span>
                <i v-if="item.StrColumId == 'StrUserName' && row.sendtype == '1'" class="el-icon-s-comment"></i>
                <span v-else-if="item.StrColumName == '入职时间'">{{ isNull(row[item.StrColumId]) ? '' :
                  row[item.StrColumId].replace('T', ' ') }}</span>
                <span v-else-if="(item.StrColumName == '面试时间') && (activeName == '待面试') && (isRangeHandle(row, item)) && (checkPermission(['signupList_edit_interviewtime'], permissionLists))" @click="editViewtime(row)" style="cursor: pointer;color:#333;font-weight: bold;text-decoration: underline;" title="点击可修改面试时间">{{
                    row[item.StrColumId] }}<i class="el-icon-edit" style="font-size: 14px;color: #333;"></i></span>
                <span v-else-if="(item.StrColumName == '预定到岗时间') && (row[item.StrColumId] == '未确定') && (checkPermission(['signupList_edit_dutytime'], permissionLists))" @click="editDtreachtime(row, item)" style="cursor: pointer;color:#333;font-weight: bold;text-decoration: underline;" title="点击可修改到岗时间">{{
                    row[item.StrColumId] }}<i class="el-icon-edit" style="font-size: 14px;color: #333;"></i></span>
                <span v-else-if="item.StrColumName.indexOf('在职天数') > -1">{{ isMinus(row[item.StrColumId]) ? '0' :
                  row[item.StrColumId] }}</span>
                <span v-else>{{ isNull(row[item.StrColumId]) ? '' : row[item.StrColumId] }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column align="center" label="操作" fixed="right" :width="activeName == '待离职' || activeName == '待入职' ? '290px' : '240px'" class-name="re_act_box" v-if="listQuery.SignatureStatus != '4' && activeName != '在职' && activeName != '离职'">
            <template slot-scope="{row}">
              <el-button v-if="checkPermission(['follow_up'], permissionLists)" type="info" size="mini" plain @click="followHandle(row)">跟进</el-button>
              <el-button v-if="checkPermission(['label'], permissionLists)" type="info" size="mini" plain @click="labelHandle(row)">标签</el-button>
              <el-button v-if="checkPermission(['dtl'], permissionLists)" type="info" size="mini" plain @click="dtlHandle(row)">详情</el-button>
              <el-button v-if="checkPermission(['print'], permissionLists)" type="success" size="mini" plain @click="printHandel(row)">打印</el-button>
              <!-- Entrybutton 入职按钮是否显示 1显示0 不显示 -->
              <el-button v-if="(activeName == '待入职') && (row.Entrybutton == 1) && (checkPermission(['tab_entry_entry'], permissionLists))" type="success" size="mini" @click="entryHandle(row)">入职</el-button>
              <el-button v-if="(activeName == '待入职' || activeName == '待离职') && (row.StrSourcejl == '公司渠道') && (checkPermission(['signupList_entry'], permissionLists)) && row.StrprojectName == null" type="success" size="mini" @click="completionInfo(row)">补充信息</el-button>
              <el-button v-if="((activeName == '在职' && row.Quitbutton == 1) || activeName == '待离职') && (checkPermission(['tab_resign_quit'], permissionLists))" type="success" size="mini" @click="quitHandle(row)">离职</el-button>
              <!-- <el-button v-if="((activeName == '异常'||activeName == '离职')&&(allLoginRoleType.indexOf('rec')==-1))||(activeName == '通过')" type="success" size="mini" @click="entryHandle(row)">入职</el-button> -->
              <!-- <el-button v-if="activeName == '在职'" type="success" size="mini" plain @click="entryHandle(row)">入职登记</el-button> -->
              <!-- <el-button type="success" size="mini" plain @click="launchHandle(row)">投放公海</el-button> -->
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" width="170px" class-name="re_act_box" v-if="activeName == '在职' || activeName == '离职'">
            <template slot-scope="{row}">
              <!-- <el-button v-if="checkPermission(['signupList_dtl'], permissionLists) && activeName == '在职'" type="warning" size="mini" plain @click="editPhone(row)">修改联系方式</el-button> -->
              <el-button v-if="checkPermission(['tab_onJob_edit'], permissionLists) && activeName == '在职'" type="success" size="mini" plain @click="dtlHandle(row)">编辑</el-button>
              <el-button v-if="((activeName == '在职' && row.Quitbutton == 1) || activeName == '待离职') && (checkPermission(['tab_resign_quit'], permissionLists))" type="danger" size="mini" @click="quitHandle(row)">离职</el-button>
              <el-button type="primary" v-if="activeName == '在职' && (checkPermission(['print'], permissionLists))" size="mini" plain @click="printHandel(row)">打印</el-button>

              <el-button type="primary" v-if="activeName == '离职' && (checkPermission(['tab_entry_entry'], permissionLists))" size="mini" plain @click="entryAgain(row)">再次入职</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.currpage" :page-size="listQuery.perpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 约面弹框 -->
    <el-dialog title="待面试" :visible.sync="surfaceVisible" width="760px" class="sur_dialog">
      <div class="dia_flex_box">
        <div class="dia_flex_item">
          <p>批量备注：</p>
          <el-input v-model="comFaceQuery.comRemark" size="small" clearable style="width:250px;" @input="comInputChange"></el-input>
        </div>
        <div class="dia_flex_item ml10">
          <p>批量住宿需求：</p>
          <el-select v-model="comFaceQuery.StrAccomreq" placeholder="" style="width:100px;" @change="reqHandle" size="small" clearable>
            <el-option label="需要" value="需要"></el-option>
            <el-option label="不需要" value="不需要"></el-option>
          </el-select>
        </div>
      </div>
      <el-table v-loading="surfaceLoading" :data="surfaceTableData" style="width:100%">
        <el-table-column align="center" fit :show-overflow-tooltip="false" label="*项目" width="200" prop="ProjectName">
          <template slot-scope="{row}">
            <span v-if="activeName == '报名' && row.StrSourcejl != '杰伴'">{{ row.ProjectName }}</span>
            <el-select v-else v-model="row.Projectid" filterable clearable size="mini" placeholder="" @change="surProChange(row)">
              <el-option v-for="(item, index) in resProjectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="*岗位" width="140">
          <template slot-scope="{row}">
            <span v-if="activeName == '报名' && row.StrSourcejl != '杰伴'">{{ row.CustomerJobName }}</span>
            <el-select v-else v-model="row.Jobid" filterable clearable size="mini" placeholder="" @change="surPostChange(row)">
              <el-option v-for="(item, index) in row.resPostList" :key="index" :label="item.JobCategory" :value="item.Id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="缺口提醒" min-width="80px">
          <template slot-scope="{row}">
            <span style="color:#F56C6C;">{{ row.StrNeedAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="姓名" min-width="120px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrName" size="small" clearable style="width:100px;" @input="comInputChange" v-if="activeName == '报名' && row.StrSourcejl == '杰伴'"></el-input>
            <span v-else-if="activeName != '异常'">{{ row.StrName }}</span>
            <span v-else-if="activeName == '异常'">{{ row.StrUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="手机号" min-width="110px">
          <template slot-scope="{row}">
            <span>{{ row.StrMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="*面试日期" min-width="125px">
          <template slot-scope="{row}">
            <el-select v-model="row.appDtviewDate" filterable clearable size="mini" placeholder="" @change="diaSurdateChange(row)">
              <el-option v-for="(item, index) in row.viewDateList" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
            <!-- <el-time-picker v-model="row.Dtviewtime" class="act_time" value-format="HH:mm" format='HH:mm' size="mini" placeholder="面试时间"></el-time-picker> -->
          </template>
        </el-table-column>
        <el-table-column align="center" label="*面试时间" min-width="125px">
          <template slot-scope="{row}">
            <el-select v-model="row.appDtviewTime" filterable clearable size="mini" placeholder="">
              <el-option v-for="(item, index) in row.viewTimesList" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" label="黑名单标签" fit :show-overflow-tooltip="true" width="130px">
          <template slot-scope="{row}">
            <span class="b_txt_com" v-if="!isNull(row.StrBlackReason)">{{ row.StrBlackReason }}</span>
            <span v-if="isNull(row.StrBlackReason)">无</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="住宿需求" width="112px">
          <template slot-scope="{row}">
            <el-select v-model="row.StrAccomreq" placeholder="" size="small" clearable>
              <el-option label="需要" value="需要"></el-option>
              <el-option label="不需要" value="不需要"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="提醒" min-width="110px">
          <template slot-scope="{row}">
            <span>{{ row.Strremind }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="备注" min-width="200px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="surfaceVisible = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="saveSurfaceHandle()" style="margin:0 10px">
          <el-button type="success" :loading="btnLoading01" size="small" class="com_dialog_btn" slot="reference">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
    <!-- 放弃入职弹框 -->
    <el-dialog title="确认如下人员放弃入职" :visible.sync="abandonVisible" width="760px" class="sur_dialog">
      <el-table v-loading="abandonLoading" :data="abandonTableData" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
          <template slot-scope="{$index}">
            <span>{{ Number($index) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="姓名" min-width="90px">
          <template slot-scope="{row}">
            <span>{{ row.StrUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="项目" min-width="100px">
          <template slot-scope="{row}">
            <span>{{ row.StrprojectName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="岗位" min-width="90px">
          <template slot-scope="{row}">
            <span>{{ row.CustomerJobName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="联系方式" min-width="110px">
          <template slot-scope="{row}">
            <span>{{ row.StrMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="*放弃原因" min-width="150px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="黑名单标签" min-width="190px">
          <template slot-scope="{row}">
            <el-select v-model="row.StrBlackReason" placeholder="" @change="reasonHandle" size="mini" clearable>
              <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="abandonVisible = false" size="small">取消</el-button>
        <el-button type="success" :loading="btnLoading02" size="small" class="com_dialog_btn" @click="saveAbadonHandle">确定</el-button>
      </span>
    </el-dialog>
    <!-- 报名登记弹框 -->
    <el-dialog :title="signDialogTitle" :visible.sync="registVisible" width="750px" class="res_dialog enter_dialog">
      <div v-if="!isNull(faceNoteTxt01) || !isNull(faceNoteTxt02)" class="face_txt">
        <p>提示:
          <span v-if="!isNull(faceNoteTxt01)">{{ faceNoteTxt01 + ';' }}</span>
          <span v-if="!isNull(faceNoteTxt02)">{{ faceNoteTxt02 + ';' }}</span>
        </p>
      </div>
      <el-form :inline="true" :rules="registerRules" ref="registForm" :model="appointmentQuery" class="re_down_form" label-width="120px">
        <el-form-item label="姓名:" prop="StrUserName">
          <el-input v-model="appointmentQuery.StrUserName" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="电话:" prop="StrMobile">
          <el-input v-model="appointmentQuery.StrMobile" size="small" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" clearable></el-input>
        </el-form-item>
        <el-form-item label="性别:" prop="BolUserSex">
          <el-select v-model="appointmentQuery.BolUserSex" placeholder="" size="small">
            <el-option label="女" value="女"></el-option>
            <el-option label="男" value="男"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄:" prop="StrUserAge">
          <el-input v-model="appointmentQuery.StrUserAge" size="small" type="number" oninput="value=value.replace(/\D+/g,'')" min="1" clearable></el-input>
        </el-form-item>
        <el-form-item label="民族:" prop="StrUsernation">
          <el-select v-model="appointmentQuery.StrUsernation" filterable placeholder="" size="small">
            <el-option v-for="item in nationList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="简历来源:" prop="StrSource">
          <el-select v-model="appointmentQuery.StrSource" placeholder="" size="small" filterable clearable>
            <el-option v-for="item in originList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="signDialogTitle == '报名登记' ? '报名项目:' : '约面项目'" prop="Projectid">
          <el-select v-model="appointmentQuery.Projectid" filterable clearable size="small" placeholder="" @change="resProChange">
            <el-option v-for="(item, index) in resProjectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="signDialogTitle == '报名登记' ? '报名岗位:' : '约面岗位'" prop="Jobid">
          <el-select v-model="appointmentQuery.Jobid" filterable clearable size="small" placeholder="" @change="resPostChange">
            <el-option v-for="(item, index) in resPostList" :key="index" :label="item.JobCategory" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面试地址:" prop="Strviewadd" v-if="signDialogTitle != '报名登记'">
          <el-select v-model="appointmentQuery.Strviewadd" placeholder="" size="small" @change="viewaddChange">
            <el-option v-for="(item, index) in viewAddressList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
          <!-- <el-cascader :props="propsAddress" ref="cascaderSignArr" placeholder="" size="small" v-model="appointCityVal" :options="provinces" @change="changeSignArea"></el-cascader> -->
        </el-form-item>
        <el-form-item label="面试日期:" prop="appDtviewDate" v-if="signDialogTitle != '报名登记'" class="s_date_box">
          <el-select v-model="appointmentQuery.appDtviewDate" filterable clearable @change="resDateChange" size="small" placeholder="">
            <el-option v-for="(item, index) in viewDateList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面试时间:" prop="appDtviewTime" v-if="signDialogTitle != '报名登记'">
          <el-select v-model="appointmentQuery.appDtviewTime" filterable clearable size="small" placeholder="">
            <el-option v-for="(item, index) in viewTimesList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证:" prop="StrIdCard">
          <el-input v-model="appointmentQuery.StrIdCard" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="住宿需求:">
          <el-select v-model="appointmentQuery.StrAccomreq" placeholder="" size="small">
            <el-option label="需要" value="需要"></el-option>
            <el-option label="不需要" value="不需要"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐渠道:" prop="StrSource">
          <el-select v-model="appointmentQuery.PushName" placeholder="" size="small" filterable clearable>
            <el-option value="宁波网招"></el-option>
            <el-option value="社招推荐人"></el-option>
            <el-option value="网招中心"></el-option>
            <el-option value="公司渠道"></el-option>
            <el-option value="校招部"></el-option>
            <el-option value="业务项目部"></el-option>
            <el-option value="招聘部"></el-option>
            <el-option value="客服部"></el-option>
            <el-option value="小杰门店"></el-option>
            <el-option value="企业转移"></el-option>
            <el-option value="员工内荐"></el-option>
            <el-option value="供应商"></el-option>
            <el-option value="其他情况"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐渠道备注:" prop="PushRemark">
          <el-input v-model="appointmentQuery.PushRemark" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="推荐渠道人员来源:" label-width="130px">
          <el-select v-model="appointmentQuery.ReferralChannels" size="small" placeholder="" filterable>
            <el-option :label="item.name" :value="item.value" v-for="(item,index) in ChannelsList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="StrRemark" class="f_all_width">
          <el-input v-model="appointmentQuery.StrRemark" size="small" type="textarea" rows="2" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="registVisible = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="saveRegistHandle()" style="margin:0 10px">
          <el-button :loading="btnLoading10" type="primary" class="com_dialog_btn" slot="reference" size="small">保存</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
    <!-- 到面弹框 -->
    <el-dialog title="确认如下人员到面" :visible.sync="tofaceVisible" width="800px" class="sur_dialog">
      <el-table v-loading="tofaceLoading" :data="tofaceTableData" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
          <template slot-scope="{$index}">
            <span>{{ Number($index) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="姓名" min-width="100px">
          <template slot-scope="{row}">
            <span>{{ row.StrUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="联系方式" min-width="110px">
          <template slot-scope="{row}">
            <span>{{ row.StrMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="黑名单标签" fit :show-overflow-tooltip="true" width="130px">
          <template slot-scope="{row}">
            <span class="b_txt_com" v-if="!isNull(row.StrBlackReason)">{{ row.StrBlackReason }}</span>
            <span v-if="isNull(row.StrBlackReason)">无</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="项目" min-width="100px">
          <template slot-scope="{row}">
            <span>{{ row.StrprojectName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="岗位" min-width="90px">
          <template slot-scope="{row}">
            <span>{{ row.CustomerJobName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="约面时间" min-width="130px">
          <template slot-scope="{row}">
            <span>{{ row.Dtviewtime }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="*到面时间" min-width="180px">
          <template slot-scope="{row}">
            <el-date-picker type="datetime" v-model="row.Dtfacetime" class="act_date_time" value-format="yyyy-MM-dd HH:mm" format='yyyy-MM-dd HH:mm' size="mini" placeholder="到面时间"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" label="住宿需求" width="112px">
          <template slot-scope="{row}">
            <el-select v-model="row.StrAccomreq" placeholder="" size="small" clearable>
              <el-option label="需要" value="需要"></el-option>
              <el-option label="不需要" value="不需要"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="备注" min-width="200px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tofaceVisible = false" size="small">取消</el-button>
        <el-button type="success" :loading="btnLoading03" size="small" class="com_dialog_btn" @click="saveTofaceHandle">确定</el-button>
      </span>
    </el-dialog>
    <!-- 撤销约面/未到面弹框 -->
    <el-dialog :title="'确认' + revokeTxt" :visible.sync="revokeVisible" width="760px" class="sur_dialog">
      <el-table v-loading="revokeLoading" :data="revokeTableData" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
          <template slot-scope="{$index}">
            <span>{{ Number($index) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="姓名" min-width="90px">
          <template slot-scope="{row}">
            <span>{{ row.StrUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="项目名称" min-width="100px">
          <template slot-scope="{row}">
            <span>{{ row.StrprojectName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="岗位" min-width="110px">
          <template slot-scope="{row}">
            <span>{{ row.CustomerJobName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="联系方式" min-width="110px">
          <template slot-scope="{row}">
            <span>{{ row.StrMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" :label="revokeTxt == '放弃面试' ? '*放弃面试原因' : '*取消原因'" min-width="170px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="黑名单标签" min-width="190px">
          <template slot-scope="{row}">
            <el-select v-model="row.StrBlackReason" placeholder="" size="mini" clearable>
              <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="revokeVisible = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="saveRevokeHandle()" style="margin:0 10px">
          <el-button type="success" size="small" :loading="btnLoading04" class="com_dialog_btn" slot="reference">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
    <!-- 面试通过弹框 -->
    <el-dialog title="人员面试通过确认" :visible.sync="passInterVisible" width="1000px" class="sur_dialog">
      <div class="dia_flex_box">
        <div class="dia_flex_item">
          <p>批量结算岗位：</p>
          <el-input v-model="comFaceQuery.StrJobNamejs" style="width:250px;" size="small" clearable @input="comJsJobChange"></el-input>
        </div>
        <div class="dia_flex_item">
          <p>批量到岗时间：</p>
          <el-checkbox v-model="comFaceQuery.timeChecked" class="pass_check" @change="comTimeChange">未确定</el-checkbox>
          <el-date-picker type="date" style="width:210px;" @change="dateBatchChange" :disabled="comFaceQuery.timeChecked" v-model="comFaceQuery.Dtreachtime" size="small" format='yyyy-MM-dd' value-format="yyyy-MM-dd" class="ml10" placeholder="到岗时间"></el-date-picker>
        </div>
        <div class="dia_flex_item ml10">
          <p>批量住宿需求：</p>
          <el-select v-model="comFaceQuery.StrAccomreq" placeholder="" style="width:100px;" @change="reqHandle" size="small" clearable>
            <el-option label="需要" value="需要"></el-option>
            <el-option label="不需要" value="不需要"></el-option>
          </el-select>
        </div>
        <div class="dia_flex_item ml10">
          <p>批量是否体检：</p>
          <el-checkbox v-model="comFaceQuery.checked" @change="examHandle">体检</el-checkbox>
        </div>
        <div class="dia_flex_item">
          <p>批量体检医院：</p>
          <el-input v-model="comFaceQuery.Strphysicalhos" style="width:250px;" size="small" clearable @input="comPhyChange"></el-input>
        </div>
        <div class="dia_flex_item">
          <p>批量备注：</p>
          <el-input v-model="comFaceQuery.comRemark" size="small" clearable style="width:250px;" @input="comInputChange"></el-input>
        </div>
      </div>
      <el-table v-loading="passInterLoading" :data="passInterTableData" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true" fixed="left">
          <template slot-scope="{$index}">
            <span>{{ Number($index) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="msgerror" fit :show-overflow-tooltip="true" label="报错" min-width="100px" fixed="left">
          <template slot-scope="{row}">
            <span class="msgerror">{{ row.msgerror }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="姓名" min-width="100px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrUserName" size="mini" style="width:80px" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="身份证校验" width="120px">
          <template slot-scope="{row}">
            <el-tag v-if="row.judge!=undefined && row.judge" type="success">通过</el-tag>
            <el-tag v-else type="danger">{{row.StrIdCard.length==0 ? '请填写身份证' : '身份证格式不正确'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="身份证号码" width="180px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrIdCard" @blur="checkIdcard(row)" size="mini" style="width:160px" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="项目名称" min-width="100px">
          <template slot-scope="{row}">
            <span>{{ row.StrprojectName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="岗位" min-width="100px">
          <template slot-scope="{row}">
            <span>{{ row.CustomerJobName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结算岗位" min-width="170px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrJobNamejs" size="mini" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="未确定到岗时间" min-width="120px">
          <template slot-scope="{row}">
            <el-checkbox v-model="row.timeChecked" class="pass_check" @change="dtTimeChange(row)">未确定</el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="*预定到岗时间" min-width="170px">
          <template slot-scope="{row}">
            <el-date-picker type="date" :disabled="row.timeChecked" v-model="row.Dtreachtime" size="mini" format='yyyy-MM-dd' value-format="yyyy-MM-dd" class="act_date" placeholder="到岗时间"></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="入职地点" min-width="140px">
          <template slot-scope="{row}">
            <span>{{ row.WorkAddress }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="住宿需求" width="112px">
          <template slot-scope="{row}">
            <el-select v-model="row.StrAccomreq" placeholder="" size="small" clearable>
              <el-option label="需要" value="需要"></el-option>
              <el-option label="不需要" value="不需要"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" label="是否体检" min-width="80px">
          <template slot-scope="{row}">
            <el-checkbox v-model="row.checked">体检</el-checkbox>
          </template>
        </el-table-column>
        <el-table-column align="center" label="体检医院" min-width="170px">
          <template slot-scope="{row}">
            <el-input v-model="row.Strphysicalhos" size="mini" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="备注" min-width="200px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="80px" fixed="right">
          <template slot-scope="{$index}">
            <div class="injuryTabBtn">
              <el-button type="text" size="small" @click="delRow($index)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passInterVisible = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="beforePass()" style="margin-left:10px">
          <el-button type="success" slot="reference" size="small" :loading="btnLoading05" class="com_dialog_btn">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>

    <!-- 批量入职弹框 -->
    <el-dialog title="批量入职" :visible.sync="entryBatchVisible" width="1000px" class="sur_dialog">
      <el-form :inline="true" class="eleForm" label-width="120px">
        <el-form-item label="批量用工之日：">
          <el-date-picker type="date" @change="changeDtEntry" v-model="entryBatchData.DtEntryBdate" size="small" format='yyyy-MM-dd' value-format="yyyy-MM-dd" class="ml10" placeholder=""></el-date-picker>
        </el-form-item>
        <el-form-item label="批量在/离职状态：" label-width="140px">
          <el-select v-model="entryBatchData.StrWorkState" placeholder="" style="width:140px;" @change="changeWorkState" size="small" clearable>
            <el-option value="在职"></el-option>
            <el-option value="离职"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批量开票公司全称：" label-width="140px">
          <el-select v-model="entryBatchData.StrBlCmp" placeholder="" style="width:200px;" @change="changeStrBlCmp" size="small" clearable filterable>
            <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批量岗位：">
          <el-input v-model="entryBatchData.CustomerJobName" size="small" clearable style="width:140px" @blur="changebJob(entryBatchData.CustomerJobName)"></el-input>
        </el-form-item>
        <el-form-item label="批量招聘渠道：" label-width="140px">
          <el-select v-model="entryBatchData.Recruitdep" placeholder="" size="small" filterable clearable style="width:140px;" @change="changeRecruitdep">
            <el-option value="宁波网招"></el-option>
            <el-option value="社招推荐人"></el-option>
            <el-option value="网招中心"></el-option>
            <el-option value="公司渠道"></el-option>
            <el-option value="校招部"></el-option>
            <el-option value="业务项目部"></el-option>
            <el-option value="招聘部"></el-option>
            <el-option value="客服部"></el-option>
            <el-option value="小杰门店"></el-option>
            <el-option value="企业转移"></el-option>
            <el-option value="员工内荐"></el-option>
            <el-option value="供应商"></el-option>
            <el-option value="其他情况"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="entryTable">
        <el-table v-loading="passInterLoading" :data="passInterTableData" style="width:100%">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true" fixed="left">
            <template slot-scope="{$index}">
              <span>{{ Number($index) + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="msgerror" fit :show-overflow-tooltip="true" label="报错" min-width="100px" fixed="left">
          </el-table-column>
          <el-table-column align="center" prop="msgerror" fit :show-overflow-tooltip="true" label="是否黑名单" min-width="100px" fixed="left">
            <template slot-scope="{row}">
              <el-tag v-if="row.StrIsBlack" type="danger">是</el-tag>
              <el-tag v-else type="success">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" fit prop="StrUserName" :show-overflow-tooltip="true" label="姓名" min-width="120px" fixed="left">
            <template slot-scope="{row}">
              <el-input v-model="row.StrUserName" size="mini" style="width:100px" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="身份证校验" width="120px" fixed="left">
            <template slot-scope="{row}">
              <el-tag v-if="row.judge!=undefined && row.judge" type="success">通过</el-tag>
              <el-tag v-else type="danger">{{row.StrIdCard.length==0 ? '请填写身份证' : '身份证格式不正确'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="*身份证号码" width="180px">
            <template slot-scope="{row}">
              <el-input v-model="row.StrIdCard" @blur="checkIdcard(row)" size="mini" style="width:160px" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="*联系方式" width="150px">
            <template slot-scope="{row}">
              <el-input v-model="row.StrMobile" size="mini" style="width:140px" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="StrprojectName" fit :show-overflow-tooltip="true" label="项目名称" min-width="140px">
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="岗位" min-width="100px">
            <template slot-scope="{row}">
              <el-input v-model="row.CustomerJobName" size="mini" style="width:80px" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="*用工之日" min-width="160px">
            <template slot-scope="{row}">
              <el-date-picker type="date" style="width:140px;" v-model="row.DtEntryBdate" size="mini" format='yyyy-MM-dd' value-format="yyyy-MM-dd" class="ml10" placeholder=""></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column align="center" label="*在/离职状态" min-width="100px">
            <template slot-scope="{row}">
              <el-select v-model="row.StrWorkState" placeholder="" style="width:80px;" size="mini" clearable>
                <el-option value="在职"></el-option>
                <el-option value="离职"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" label="*开票公司全称" min-width="170px">
            <template slot-scope="{row}">
              <el-select v-model="row.StrBlCmp" placeholder="" style="width:150px;" size="mini" clearable>
                <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" label="*推荐渠道" min-width="120px">
            <template slot-scope="{row}">
              <el-select v-model="row.Recruitdep" placeholder="" size="mini" filterable clearable style="width:100px;">
                <el-option value="宁波网招"></el-option>
                <el-option value="社招推荐人"></el-option>
                <el-option value="网招中心"></el-option>
                <el-option value="公司渠道"></el-option>
                <el-option value="校招部"></el-option>
                <el-option value="业务项目部"></el-option>
                <el-option value="招聘部"></el-option>
                <el-option value="客服部"></el-option>
                <el-option value="小杰门店"></el-option>
                <el-option value="企业转移"></el-option>
                <el-option value="员工内荐"></el-option>
                <el-option value="供应商"></el-option>
                <el-option value="其他情况"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="*推荐渠道备注" min-width="120px">
            <template slot-scope="{row}">
              <el-input v-model="row.Recruitname" size="mini" clearable style="width:100px"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="备注" min-width="200px">
            <template slot-scope="{row}">
              <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="80px" fixed="right">
            <template slot-scope="{$index}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="delRow($index)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="entryBatchVisible = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="beforeEntry()" style="margin-left:10px">
          <el-button type="success" slot="reference" size="small" :loading="btnLoading05">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
    <!-- 面试未通过弹框 -->
    <el-dialog title="人员面试未通过确认" :visible.sync="failInterVisible" width="760px" class="sur_dialog">
      <div class="dia_flex_box">
        <div class="dia_flex_item">
          <p>批量未通过原因：</p>
          <el-input v-model="comFaceQuery.comRemark" size="small" clearable style="width:250px;" @input="comInputChange"></el-input>
        </div>
        <div class="dia_flex_item ml10">
          <p>批量黑名单标签：</p>
          <el-select v-model="comFaceQuery.StrBlackReason" placeholder="" @change="reasonComHandle" size="small" style="width:180px;" clearable>
            <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </div>
      </div>
      <el-table v-loading="failInterLoading" :data="failInterTableData" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
          <template slot-scope="{$index}">
            <span>{{ Number($index) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="姓名" min-width="90px">
          <template slot-scope="{row}">
            <span>{{ row.StrUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="联系方式" min-width="110px">
          <template slot-scope="{row}">
            <span>{{ row.StrMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="项目" min-width="100px">
          <template slot-scope="{row}">
            <span>{{ row.StrprojectName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="岗位" min-width="120px">
          <template slot-scope="{row}">
            <span>{{ row.CustomerJobName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="*未通过原因" min-width="170px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" fit :show-overflow-tooltip="true" label="是否黑名单" min-width="100px">
          <template slot-scope="{row}">
              <el-checkbox v-model="row.checked">黑名单</el-checkbox>
            </template>
        </el-table-column> -->
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="黑名单标签" min-width="200px">
          <template slot-scope="{row}">
            <div class="flex_cen">
              <el-select v-model="row.StrBlackReason" placeholder="" @change="reasonHandle" size="mini" clearable>
                <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                <!-- <el-option value="其他">其他</el-option> -->
              </el-select>
              <!-- <el-input v-model="reasonQuery.remark" v-if="row.StrBlackReason == '其他'" placeholder="请输入黑名单原因" size="mini" clearable></el-input> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="failInterVisible = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="saveFailHandle()" style="margin-left:10px">
          <el-button type="success" slot="reference" size="small" :loading="btnLoading06" class="com_dialog_btn">确定</el-button>
        </el-popconfirm>

      </span>
    </el-dialog>
    <!-- 到面登记弹框 -->
    <el-dialog title="到面登记" :visible.sync="toFaceVisible" width="700px" class="res_dialog enter_dialog">
      <div v-if="!isNull(tofaceNoteTxt01) || !isNull(tofaceNoteTxt02)" class="face_txt">
        <p>提示:
          <span v-if="!isNull(tofaceNoteTxt01)">{{ tofaceNoteTxt01 + ';' }}</span>
          <span v-if="!isNull(tofaceNoteTxt02)">{{ tofaceNoteTxt02 + ';' }}</span>
        </p>
      </div>
      <el-form :inline="true" :rules="toFaceRules" ref="toFaceForm" :model="checkQuery" class="re_down_form" label-width="100px">
        <el-form-item label="姓名:" prop="StrUserName">
          <el-input v-model="checkQuery.StrUserName" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="StrMobile">
          <el-input v-model="checkQuery.StrMobile" size="small" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" clearable></el-input>
        </el-form-item>
        <el-form-item label="性别:" prop="BolUserSex">
          <el-select v-model="checkQuery.BolUserSex" placeholder="" size="small">
            <el-option label="女" value="女"></el-option>
            <el-option label="男" value="男"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄:" prop="StrUserAge">
          <el-input v-model="checkQuery.StrUserAge" size="small" type="number" oninput="value=value.replace(/\D+/g,'')" min="1" clearable></el-input>
        </el-form-item>
        <el-form-item label="民族:" prop="StrUsernation">
          <el-select v-model="checkQuery.StrUsernation" placeholder="" filterable size="small">
            <el-option v-for="item in nationList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="简历来源:" prop="StrSource">
          <el-select v-model="checkQuery.StrSource" placeholder="" size="small" filterable clearable>
            <el-option v-for="item in originList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到面项目" prop="Projectid">
          <el-select v-model="checkQuery.Projectid" filterable clearable size="small" placeholder="" @change="tofaceProChange">
            <el-option v-for="(item, index) in resProjectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到面岗位" prop="Jobid">
          <el-select v-model="checkQuery.Jobid" filterable clearable size="small" placeholder="" @change="tofacePostHandle">
            <el-option v-for="(item, index) in resPostList" :key="index" :label="item.JobCategory" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到面时间:" prop="Dtfacetime">
          <el-date-picker v-model="checkQuery.Dtfacetime" size="small" format="yyyy-MM-dd HH:mm" type="datetime" value-format="yyyy-MM-dd HH:mm" placeholder="">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="身份证:" prop="StrIdCard">
          <el-input v-model="checkQuery.StrIdCard" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="招聘渠道:" prop="qudao">
          <el-select v-model="checkQuery.qudao" placeholder="" size="small" @change="qudaoChange">
            <el-option value="社招">社招</el-option>
            <el-option value="公司渠道">公司渠道</el-option>
            <el-option value="外部渠道">外部渠道</el-option>
            <el-option value="企业转移">企业转移</el-option>
            <el-option value="内荐">内荐</el-option>
            <el-option value="独立招聘">独立招聘</el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="部门:" v-if="checkQuery.qudao == '社招'||checkQuery.qudao == '公司渠道'" class="face_note_txt">
          <el-cascader placeholder="请选择部门"
            v-model="dedpartNameList" ref="deSectionArr" :props="depprops" clearable filterable size="small"
            :options="faceDepartList"
            @change="handleDepFaceChange"></el-cascader>
        </el-form-item> -->
        <el-form-item label="人员:" v-if="checkQuery.qudao == '社招'" class="face_note_txt">
          <el-select filterable @change="faceSzMemberChange" v-model="szMember" clearable placeholder="请选择人员" size="small">
            <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Username">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工:" v-if="checkQuery.qudao == '内荐'" class="face_note_txt">
          <div class="face_line_box">
            <el-input placeholder="" v-model="njMember" style="width:180px;" size="small" clearable></el-input>
            <span class="txts">推荐</span>
          </div>
        </el-form-item>
        <el-form-item label="人员:" v-if="checkQuery.qudao == '公司渠道'" class="face_note_txt">
          <el-select filterable @change="faceMemberChange" v-model="checkQuery.Gsqdtjr" clearable placeholder="请选择人员" size="small">
            <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Username">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道信息:" v-if="checkQuery.qudao == '外部渠道'" class="face_note_txt">
          <el-input placeholder="请输入渠道信息" v-model="checkQuery.Wbqd" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="住宿需求:">
          <el-select v-model="checkQuery.StrAccomreq" placeholder="" size="small">
            <el-option label="需要" value="需要"></el-option>
            <el-option label="不需要" value="不需要"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="StrRemark" class="f_all_width">
          <el-input v-model="checkQuery.StrRemark" size="small" type="textarea" rows="2" clearable></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toFaceVisible = false" size="small">取消</el-button>
        <el-button :loading="btnLoading11" type="primary" class="com_dialog_btn" @click="saveCheckHandle" size="small">保存</el-button>
      </span>
    </el-dialog>
    <!-- 终止流程弹框 -->
    <el-dialog title="终止流程" :visible.sync="endProcessVisible" width="760px" class="sur_dialog">
      <div class="dia_flex_box">
        <div class="dia_flex_item">
          <p>批量终止原因：</p>
          <el-input v-model="comFaceQuery.comRemark" size="small" clearable style="width:250px;" @input="comInputChange"></el-input>
        </div>
        <div class="dia_flex_item ml10">
          <p>批量黑名单标签：</p>
          <el-select v-model="comFaceQuery.StrBlackReason" placeholder="" @change="reasonComHandle" size="small" style="width:180px;" clearable>
            <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </div>
      </div>
      <el-table v-loading="endProcessLoading" :data="endProcessTableData" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
          <template slot-scope="{$index}">
            <span>{{ Number($index) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="姓名" min-width="90px">
          <template slot-scope="{row}">
            <span>{{ row.StrUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="联系方式" min-width="110px">
          <template slot-scope="{row}">
            <span>{{ row.StrMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="项目" min-width="100px">
          <template slot-scope="{row}">
            <span>{{ row.StrprojectName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="岗位" min-width="110px">
          <template slot-scope="{row}">
            <span>{{ row.CustomerJobName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="流程状态" min-width="100px">
          <template slot-scope="{row}">
            <span>{{ row.StrnowState }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="发生时间" min-width="150px">
          <template slot-scope="{row}">
            <span>{{ row.DtInsertDate }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="*终止原因" min-width="180px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" fit :show-overflow-tooltip="true" label="黑名单标签" min-width="200px">
          <template slot-scope="{row}">
            <el-select v-model="row.StrBlackReason" placeholder="" size="mini" clearable>
              <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <p style="font-size:13px;color:#F56C6C;margin-top:10px;">注：终止流程，该人员将会被放回个人资源库中，且解绑已经关联的项目</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="endProcessVisible = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="saveEndHandle()" style="margin:0 10px">
          <el-button type="success" slot="reference" size="small" :loading="btnLoading07" class="com_dialog_btn">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
    <!-- 离职弹框 -->
    <el-dialog title="离职确认" :visible.sync="quitVisible" width="800px" class="res_dialog res_dialog01 enter_dialog">
      <el-table v-loading="quitLoading" :data="quitTableData" class="entryTable" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
          <template slot-scope="{$index}">
            <span>{{ Number($index) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="StrUserName" label="姓名" fit :show-overflow-tooltip="true" min-width="100px">
        </el-table-column>
        <el-table-column align="center" prop="StrMobile" label="联系方式" min-width="110px" fit :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column align="center" prop="StrprojectName" label="项目" min-width="160px" fit :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column align="center" prop="CustomerJobName" label="岗位" min-width="110px" fit :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="*离职类型" min-width="160" align="center">
          <template slot-scope="{$index}">
            <el-select v-model="quitList[$index].strWorkState" placeholder="" size="mini" style="width:140px">
              <el-option label="正常离职" value="正常离职"></el-option>
              <el-option label="离职转正" value="离职转正"></el-option>
              <el-option label="自离" value="自离"></el-option>
              <el-option label="被辞退" value="被辞退"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="*离职时间" min-width="160" align="center">
          <template slot-scope="{$index}">
            <el-date-picker v-model="quitList[$index].dtDepartureDate" type="date" value-format="yyyy-MM-dd" size="small" style="width:140px">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="*实际离职时间" min-width="160" align="center">
          <template slot-scope="{$index}">
            <el-date-picker v-model="quitList[$index].dtRealDepartureDate" type="date" value-format="yyyy-MM-dd" size="small" style="width:140px">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" label="黑名单" min-width="200px">
          <template slot-scope="{$index}">
            <el-select v-model="quitList[$index].strBlacklistReason" placeholder="" size="mini" clearable>
              <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              <!-- <el-option value="其他">其他</el-option> -->
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注" min-width="160px">
          <template slot-scope="{$index}">
            <el-input v-model="quitList[$index].strRemark" size="mini" clearable></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quitVisible = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="saveQuitHandle()" style="margin-left:10px">
          <el-button :loading="btnLoading08" slot="reference" type="primary" class="com_dialog_btn" size="small">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>

    <!-- 离职后减保弹框 -->
    <el-dialog title="离职成功，减保确认" :visible.sync="showReduction" width="800px" class="res_dialog res_dialog01 enter_dialog">
      <div class="quitTips">离职成功，以下在保人员是否需商保减员？</div>
      <el-table v-loading="quitLoading" :data="insureList" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
          <template slot-scope="{$index}">
            <span>{{ Number($index) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="姓名" fit :show-overflow-tooltip="true" min-width="100px">
          <template slot-scope="{row}">
            <span>{{ row.StrUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="联系方式" min-width="110px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.StrMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="项目" min-width="110px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.StrprojectName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="岗位" min-width="110px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.CustomerJobName }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showReduction = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="reduction('insureList')" style="margin-left:10px">
          <el-button :loading="btnLoading08" slot="reference" type="primary" class="com_dialog_btn" size="small">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
    <!-- 转岗弹框 -->
    <el-dialog title="转岗操作" :visible.sync="transVisible" width="800px" class="res_dialog res_dialog01 enter_dialog">
      <el-table v-loading="transLoading" :data="transTableData" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
          <template slot-scope="{$index}">
            <span>{{ Number($index) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="姓名" min-width="90px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.StrUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="联系方式" min-width="110px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.StrMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="原项目" min-width="110px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.StrprojectName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="原岗位" min-width="110px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.CustomerJobName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="原项目离职时间" min-width="150px">
          <template slot-scope="{row}">
            <el-date-picker size="mini" value-format="yyyy-MM-dd" v-model="row.Dtquittime" class="act_date" type="date" placeholder="">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" label="转入项目" min-width="160px">
          <template slot-scope="{row}">
            <el-select v-model="row.Projectidnew" filterable clearable size="mini" placeholder="" @change="transProChange(row)">
              <el-option v-for="(item, index) in resProjectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" label="转入岗位" min-width="140px">
          <template slot-scope="{row}">
            <el-select v-model="row.Jobidnew" filterable clearable size="mini" placeholder="" @change="transPostChange(row)">
              <el-option v-for="(item, index) in resPostList" :key="index" :label="item.JobCategory" :value="item.Id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" label="入职时间" min-width="140px">
          <template slot-scope="{row}">
            <el-date-picker size="small" value-format="yyyy-MM-dd" class="act_date" v-model="row.DtInducttime" type="date" placeholder="">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" label="备注" min-width="150px">
          <template slot-scope="{row}">
            <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transVisible = false" size="small">取消</el-button>
        <el-button type="primary" class="com_dialog_btn" @click="saveTransHandle" size="small">确定</el-button>
      </span>
    </el-dialog>
    <!-- 未入职弹框 -->
    <el-dialog title="未入职操作" :visible.sync="unemployedVisible" width="760px" class="res_dialog res_dialog01 enter_dialog">
      <div class="dia_flex_box">
        <div class="dia_flex_item">
          <p>批量未入职原因：</p>
          <el-input v-model="comFaceQuery.comRemark" size="small" clearable style="width:250px;" @input="comInputChange"></el-input>
        </div>
        <div class="dia_flex_item ml10">
          <p>批量黑名单标签：</p>
          <el-select v-model="comFaceQuery.StrBlackReason" placeholder="" @change="reasonComHandle" size="small" style="width:180px;" clearable>
            <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </div>
      </div>
      <el-table v-loading="unemployedLoading" :data="unemployedTableData" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
          <template slot-scope="{$index}">
            <span>{{ Number($index) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="姓名" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.StrUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="联系方式" min-width="110px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.StrMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="项目" min-width="100px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.StrprojectName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="岗位" min-width="100px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.CustomerJobName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="*未入职原因" min-width="140px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <el-input v-model="row.StrRemark" size="mini" clearable></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="是否黑名单" min-width="100px">
          <template slot-scope="{row}">
              <el-checkbox v-model="row.checked">黑名单</el-checkbox>
            </template>
        </el-table-column> -->
        <el-table-column align="center" label="黑名单标签" min-width="200px">
          <template slot-scope="{row}">
            <div class="flex_cen">
              <el-select v-model="row.StrBlackReason" placeholder="" @change="reasonHandle" size="mini" clearable>
                <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                <!-- <el-option value="其他">其他</el-option> -->
              </el-select>
              <!-- <el-input v-model="reasonQuery.remark" v-if="row.StrBlackReason == '其他'" placeholder="请输入黑名单原因" size="mini" clearable></el-input> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="unemployedVisible = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="saveUnemployedHandle()" style="margin-left:10px">
          <el-button :loading="btnLoading09" slot="reference" type="primary" class="com_dialog_btn" size="small">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>


    <!-- 录入简历弹框 -->
    <el-dialog title="录入简历" :visible.sync="enterResumeVisible" width="800px" class="res_dialog enter_dialog">
      <el-form :inline="true" :rules="enterRules" ref="enterResumeForm" :model="enterResumeQuery" class="re_down_form" label-width="100px">
        <el-form-item label="姓名:" prop="StrUserName">
          <el-input v-model="enterResumeQuery.StrUserName" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系方式:" prop="StrMobile">
          <el-input v-model="enterResumeQuery.StrMobile" size="small" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" clearable></el-input>
        </el-form-item>
        <el-form-item label="性别:" prop="BolUserSex">
          <el-select v-model="enterResumeQuery.BolUserSex" size="small">
            <el-option label="女" value="女"></el-option>
            <el-option label="男" value="男"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄:" prop="StrUserAge">
          <el-input v-model="enterResumeQuery.StrUserAge" size="small" type="number" oninput="value=value.replace(/\D+/g,'')" min="1" clearable></el-input>
        </el-form-item>
        <el-form-item label="意向地区:" prop="StrUserCity">
          <el-cascader :props="propsAddress" ref="cascaderArr" filterable size="small" v-model="strCityCode" :options="provinces" @change="changeArea"></el-cascader>
        </el-form-item>
        <el-form-item label="意向岗位:" prop="posCategoryList">
          <el-cascader ref="poSectionArr" size="small" v-model="enterResumeQuery.posCategoryList" :props="propPosition" clearable :options="intendedPost" @change="poSectionChange"></el-cascader>
        </el-form-item>
        <el-form-item label="期望薪资:">
          <div class="r_line_box">
            <el-input v-model="enterResumeQuery.salary1" size="small" type="number" min="0" oninput="value=value.replace(/\D+/g,'')" clearable class="r_line_input1"></el-input>
            <span class="r_line_txt"></span>
            <el-input v-model="enterResumeQuery.salary2" size="small" type="number" min="0" oninput="value=value.replace(/\D+/g,'')" clearable class="r_line_input2"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="简历来源:" prop="StrSource">
          <el-select v-model="enterResumeQuery.StrSource" placeholder="" size="small" filterable clearable>
            <el-option v-for="item in originList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <div class="f_all_width">
          <p class="r_l_title">公有标签</p>
          <div class="r_more_box">
            <div class="dia_label_box">
              <div class="dia_label_item" v-for="(item, j) in publicList" :key="item.LbGroup.Id" v-show="showMore4 ? j < 1 : j + 1">
                <div class="dia_groupname">{{ item.LbGroup.LableName + '：' }}</div>
                <el-checkbox-group v-model="includePublicChecks" @change="lPubEnterHandle">
                  <el-checkbox v-for="(lab, index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                    <span v-if="lab.IsEnable">{{ lab.LableName }}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="r_more_txt" style="margin-top:10px;" v-if="!isNull(publicList) && publicList.length > 1" @click="showMore4 = !showMore4">
              <span>{{ showMore4 ? '更多' : '收起' }}</span>
              <i class="el-icon-d-arrow-right" :class="{ 'rotate-img': !showMore4 }"></i>
            </div>
          </div>
          <!-- <p class="r_l_title" v-if="privateList">私有标签</p>
          <div class="r_more_box">
            <div class="dia_label_box">
              <div class="dia_label_item" v-for="(item, i) in privateList" :key="item.LbGroup.Id" v-show="showMore6 ? i < 1 : i + 1">
                <div class="dia_groupname">{{item.LbGroup.LableName + '：'}}</div>
                <el-checkbox-group v-model="includePrivateChecks" @change="lPraEnterHandle">
                  <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                    <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="r_more_txt" style="margin-top:10px;" v-if="!isNull(privateList)&&privateList.length > 1" @click="showMore6 = !showMore6">
                <span>{{showMore6 ? '更多':'收起'}}</span>
                <i class="el-icon-d-arrow-right" :class="{ 'rotate-img': !showMore6 }"></i>
              </div>
          </div> -->
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="enterResumeVisible = false" size="small">取消</el-button>
        <el-button type="primary" class="com_dialog_btn" @click="saveEnterHandle" size="small">保存</el-button>
      </span>
    </el-dialog>
    <!-- 分配记录 -->
    <el-dialog title="分配记录" :visible.sync="divRecordVisible" width="760px" class="res_dialog divide_dialog">
      <el-table v-loading="recLoading" :data="recTableData" style="width:100%">
        <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
          <template slot-scope="{$index}">
            <span>{{ (Number(listRecordQuery.currpage) - 1) * Number(listRecordQuery.perpage) + Number($index) +
              1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="时间" min-width="110px">
          <template slot-scope="{row}">
            <span>{{ row.DtDistDate }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="内容">
          <template slot-scope="{row}">
            <span>{{ row.GddistUsername }}分配{{ row.ResumeIdcount }}条简历至{{ row.BelongUsername }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination @current-change="recCurrentChange" :current-page.sync="listRecordQuery.currpage" :page-size="listRecordQuery.perpage" @size-change="recSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager,next,jumper" :total="rectotal"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="divRecordVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 选择简历分配对象弹框 -->
    <el-dialog title="选择简历分配对象" :visible.sync="divideVisible" width="760px" class="res_dialog divide_dialog">
      <div class="res_dialog_popover">
        <el-button slot="reference" class="d_btn" type="success" plain size="mini" @click="divideDtlHandle">分配记录</el-button>
      </div>
      <div class="d_rule_box">
        <p class="txt01">简历分配规则:</p>
        <p class="txt02">1、简历分配为复制机制且共享编辑，维护的信息会同步所有人。</p>
        <p class="txt02">2、同一份简历最多分给5个部门，每个部门最多5份简历。</p>
        <p class="txt02">3、如分配超出数量限制，则会按顺序机制分配至选中的部分人员，下次配合优先未分配到的人员。</p>
        <p class="txt02">4、多份简历分配多人时同样遵循以上规则。</p>
      </div>
      <p v-if="isCheckDepart" class="d_rule_txt01">最多能分配给五个部门,每个部门最多5份简历。</p>
      <el-form :rules="divideRules" ref="divideForm" :model="divideQuery" class="re_dialog_form re_dialog_form02" label-width="140px">
        <el-form-item label="分配给部门/人员:" prop="perDepartList">
          <el-cascader size="small" ref="departLabel" popper-class="disableFirstLevel" v-model="divideQuery.perDepartList" :props="props" clearable filterable :options="departList" placeholder="请选择部门或人员" @change="perSectionChange"></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="divideVisible = false" size="small">取消</el-button>
        <el-button type="primary" class="com_dialog_btn" @click="saveDivideHandle" size="small">确定</el-button>
      </span>
    </el-dialog>
    <!-- 消息沟通弹框 -->
    <el-dialog title="消息沟通" :visible.sync="noticeVisible" width="850px" class="note_dialog">
      <div class="notice_title" v-if="noteNum && noteNum > 0">
        <span @click="jumpSendRecord">查询发送记录</span>
        <i class="el-icon-d-arrow-right"></i>
      </div>
      <el-form :rules="noticeRules" ref="noticeForm" :model="noticeQuery" class="re_dialog_form" label-width="130px">
        <el-form-item label="选择通知方式:" prop="checkNoticeList">
          <el-checkbox-group v-model="checkNoticeList" disabled>
            <!-- <el-checkbox label="微信" disabled></el-checkbox> -->
            <el-checkbox label="短信"></el-checkbox>
            <!-- <el-checkbox label="企微好友" disabled></el-checkbox> -->
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="选择通知模板:" prop="TemplateId" class="n_temp_form">
          <el-select size="small" disabled v-model="noticeQuery.TemplateId" filterable clearable placeholder="请选择模板" @change="tempHandle">
            <el-option v-for="(item, index) in noticeTempList" :key="index" :label="item.TemplateName" :value="item.TemplateId">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <div v-for="index in inputNum" :key="index">
            <el-form-item :label="'参数'+(index)+':'">
                <el-input v-model="inputList[index]" size="small" clearable/>
            </el-form-item>
        </div> -->
        <el-form-item label="模板信息:">
          <el-input type="textarea" :rows="4" v-model="moduleInfo" readonly>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="n_txt_box">
        <p class="txts">注意：</p>
        <div class="n_txt_content">
          <p>1.短信总长度最长不超过500字,汉字、字母、数字、标点符号(不区分全角/半角)以及空格等都按1个字计算。</p>
          <p>2.不支持【】，以免与签名混淆。</p>
          <p>3.不支持￥、★以及通过按键录入的组合型特殊符号，例如^_^&、☞、✓、※等，以免引起短信出现乱码。</p>
        </div>
      </div>
      <el-table v-loading="noticeLoading" border :highlight-current-row="false" :data="noticeData" style="width:100%">
        <el-table-column align="center" label="姓名" min-width="80px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.StrUserName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="联系方式" min-width="100px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.StrMobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="招聘人员" min-width="100px" fit :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <span>{{ row.Recruitname }}</span>
          </template>
        </el-table-column>
        <template v-for="(item, index) in tableNoteTitle">
          <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="item.dynamic == '0' ? true : false" :key="index" :min-width="item.dynamic == '1' ? ((item.StrColumName.indexOf('地址') > -1 || item.StrColumName.indexOf('路线') > -1) ? '280px' : '200px') : '100px'" align="center">
            <template slot-scope="{row}">
              <span v-if="item.dynamic == '0'">{{ row[item.StrColumId] }}</span>
              <div v-if="item.dynamic == '1'">
                <!-- <el-input v-if="item.StrColumName.indexOf('时间')>-1||item.StrColumName.indexOf('电话')>-1" v-model="row[item.StrColumId]" size="small" clearable /> -->
                <el-input v-model="row[item.StrColumId]" maxlength="12" show-word-limit size="small" clearable />
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="noticeVisible = false" size="small">取消</el-button>
        <el-button :loading="noteLoading" type="primary" class="com_dialog_btn" @click="saveNoticeHandle" size="small">提交</el-button>
      </span>
    </el-dialog>
    <!-- 标签弹框 -->
    <el-dialog title="标签" :visible.sync="labelVisible" width="600px" class="res_dialog">
      <div class="e_txt_box">
        <el-button type="text" @click="addLabelHandle">打标签</el-button>
      </div>
      <el-form ref="noticeForm" class="re_dialog_form" label-width="80px">
        <el-form-item label="" v-if="!isNull(lPubDialogList)">
          <span v-for="(item, index) in lPubDialogList" :key="index">{{ item.LableName + ';' }}</span>
        </el-form-item>
        <!-- <el-form-item label="私有标签:" v-if="!isNull(lPriDialogList)">
          <span v-for="(item,index) in lPriDialogList" :key="index">{{item.LableName+';'}}</span>
        </el-form-item>
        <el-form-item label="私有标签:" v-if="isNull(lPriDialogList)">
          <span>暂无数据</span>
        </el-form-item> -->
      </el-form>
      <div class="com_empty" v-if="isNull(lPubDialogList)">
        <p>暂无数据</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="com_dialog_btn" @click="labelVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 添加标签弹框 -->
    <el-dialog title="编辑标签" :visible.sync="addlabelVisible" width="700px" class="res_dialog">
      <div class="r_label_box" v-loading="laloading">
        <el-tabs v-model="labelActiveName" @tab-click="handleLabelClick">
          <el-tab-pane label="全局标签" name="全局标签">
            <div class="dia_label_box">
              <div class="dia_label_item" v-for="item in publicList" :key="item.LbGroup.Id">
                <div class="dia_groupname">{{ item.LbGroup.LableName + '：' }}</div>
                <el-checkbox-group v-model="wholeCheckList" @change="dPubEnterHandle">
                  <el-checkbox v-for="(lab, index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                    <span v-if="lab.IsEnable">{{ lab.LableName }}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="私有标签" name="私有标签">
            <div class="dia_label_box">
              <div class="dia_label_item" v-for="item in privateList" :key="item.LbGroup.Id">
                <div class="dia_groupname">{{item.LbGroup.LableName + '：'}}</div>
                <div>
                  <el-checkbox-group v-model="wholeCheckList2" @change="dPraEnterHandle">
                    <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                      <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addlabelVisible = false" size="small">取消</el-button>
        <el-button type="primary" class="com_dialog_btn" @click="saveLabelHandle" size="small">保存</el-button>
      </span>
    </el-dialog>
    <!-- 跟进弹框 -->
    <el-dialog title="跟进" :visible.sync="followVisible" width="800px" class="res_dialog">
      <el-tabs v-model="activeFollowName" @tab-click="followHandleClick">
        <el-tab-pane label="人岗匹配推荐" name="人岗匹配推荐"></el-tab-pane>
        <el-tab-pane label="跟进记录" name="跟进记录"></el-tab-pane>
        <el-tab-pane label="流程记录" name="流程记录"></el-tab-pane>
      </el-tabs>
      <div class="f_list_box" v-if="activeFollowName == '人岗匹配推荐'">
        <el-table v-loading="recommendLoading" :data="recommendList" class="re_table" style="width:100%">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
              <span>{{ (Number(matchQuery.pageNum) - 1) * Number(matchQuery.pageSize) + Number($index) + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="项目" min-width="90px">
            <template slot-scope="{row}">
              <span>{{ row.StrprojectName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="岗位" min-width="90px">
            <template slot-scope="{row}">
              <span>{{ row.CustomerJobName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="综合薪资" min-width="90px">
            <template slot-scope="{row}">
              <span v-if="!isNull(row.rpj.ComprehensiveSalary)">
                {{ row.rpj.ComprehensiveSalary }}
                <span v-if="!isNull(row.rpj.ComprehensiveSalaryEnd)">{{ '~ ' + row.rpj.ComprehensiveSalaryEnd }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="上班地点" min-width="180px">
            <template slot-scope="{row}">
              <span>{{ row.rpj.InterviewProvinceName + row.rpj.InterviewCityName + row.rpj.InterviewAraeName +
                row.rpj.InterviewAddress }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="最新缺口" min-width="90px">
            <template slot-scope="{row}">
              <span>{{ row.StrgapNum }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="recommendCurrentChange" :current-page.sync="matchQuery.pageNum" :page-size="matchQuery.pageSize" @size-change="recommendSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,prev,pager,next,jumper" :total="matchCount"></el-pagination>
        </div>
      </div>
      <div class="f_list_box" v-if="activeFollowName == '跟进记录'">
        <el-form :rules="followRules" ref="followForm" :model="recommendQuery" class="re_follow_form" label-width="130px">
          <!-- <el-form-item label="更新求职意向:" prop="StrUserJobhunt">
            <el-radio-group v-model="recommendQuery.StrUserJobhunt">
              <el-radio label="有工作考虑新机会"></el-radio>
              <el-radio label="在找工作"></el-radio>
              <el-radio label="不找工作"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="跟进内容:" prop="StrRemark">
            <el-input v-model="recommendQuery.StrRemark" type="textarea" rows="3" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
        <div class="f_btns" v-if="activeFollowName == '跟进记录'">
          <el-button @click="followVisible = false" size="small">关闭</el-button>
          <el-button type="primary" class="com_dialog_btn" @click="saveFollowHandle" size="small">保存</el-button>
        </div>
        <el-table v-loading="followLoading" :highlight-current-row="false" class="re_table" :data="followData" style="width:100%;max-height:200px;overflow-y:auto;">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
              <span>{{ (Number(followQuery.currpage) - 1) * Number(followQuery.perpage) + Number($index) + 1 }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="求职意愿" min-width="110px">
            <template slot-scope="{row}">
                <span>{{row.StrUserJobhunt}}</span>
              </template>
          </el-table-column> -->
          <el-table-column align="center" label="跟进内容" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.StrRemark }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="发言人" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.userName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="时间" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ isNull(row.DtInserDate) ? '' : row.DtInserDate.replace('T', ' ') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange1" :current-page.sync="followQuery.currpage" :page-size="followQuery.perpage" @size-change="handleSizeChange1" :page-sizes="[10, 20, 50, 100]" layout="total,prev,pager,next,jumper" :total="totalFollow"></el-pagination>
        </div>
      </div>
      <div class="f_list_box" v-if="activeFollowName == '流程记录'">
        <el-table v-loading="serviceLoading" :highlight-current-row="false" class="re_table" :data="serviceData" style="width:100%">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
              <span>{{ (Number(serviceQuery.currpage) - 1) * Number(serviceQuery.perpage) + Number($index) + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.StrprojectName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="岗位名称" min-width="90px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.JobCategory }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="流程名称" min-width="90px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.StrState }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="流程时间" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span v-if="row.StrState == '已报名'">{{ isNull(row.DtInserDate) ? '' : row.DtInserDate.replace('T', ' ')
                }}</span>
              <span v-if="row.StrState == '约面'">{{ isNull(row.Dtappotime) ? '' : row.Dtappotime.replace('T', ' ')
                }}</span>
              <span v-if="row.StrState == '入职'">{{ isNull(row.DtInducttime) ? '' : row.DtInducttime.replace('T', ' ')
                }}</span>
              <span v-if="row.StrState == '离职'">{{ isNull(row.Dtquittime) ? '' : row.Dtquittime.replace('T', ' ')
                }}</span>
              <span v-if="row.StrState == '通过'">{{ isNull(row.Dtreachtime) ? row.Dtadopttime : row.Dtreachtime }}</span>
              <span v-if="row.StrState == '到面'">{{ isNull(row.Dtfacetime) ? '' : row.Dtfacetime.replace('T', ' ')
                }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作人员" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.Username }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作时间" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ isNull(row.DtInserDate) ? '' : row.DtInserDate.replace('T', ' ') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="流程备注" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.StrRemark }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange2" :current-page.sync="serviceQuery.currpage" :page-size="serviceQuery.perpage" @size-change="handleSizeChange2" :page-sizes="[10, 20, 50, 100]" layout="total,prev,pager,next,jumper" :total="totalService"></el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 导入弹框 -->
    <el-dialog :title="importName" :visible.sync="importVisible" width="700px" class="com_import_box">
      <el-steps :active="importActive" finish-status="success" class="steps-box">
        <el-step title="基础信息"></el-step>
        <el-step title="上传导入文件"></el-step>
        <el-step title="导入处理"></el-step>
      </el-steps>
      <div v-if="importActive == 0" style="margin-top:15px;padding-bottom:15px;">
        <div class="import_basic_box">
          <div>
            <div>导入表格:</div>
            <div class="storageArea">
              <div class="storageInput" style="margin:0 20px 0 0">
                <el-select v-model="importSignQuery.tabName" size="small" disabled placeholder="请选择导入表" filterable>
                  <el-option v-for="(item, index) in importTableList" :key="index" :label="item.StrTableName" :value="item.StrTableName"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="margin-left:100px">
            <div>导入模板下载:</div>
            <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;">下载普通模板</el-button>
            <el-button type="text" @click="downLoadHandle2" style="margin-left:15px;height:30px;" v-if="activeName != '待面试'">下载电子签商保一体化模板</el-button>
          </div>
          <div>
            <div>项目:</div>
            <div class="storageArea">
              <div class="storageInput" style="margin:0 20px 0 0">
                <el-select v-model="importSignQuery.projectid" filterable clearable size="small" placeholder="" @change="impProChange">
                  <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="margin-left:100px">
            <div>岗位:</div>
            <div class="storageArea">
              <div class="storageInput" style="margin:0 20px 0 0">
                <el-select v-model="importSignQuery.jobid" filterable clearable size="small" placeholder="" @change="impPostChange">
                  <el-option v-for="(item, index) in impJobList" :key="index" :label="item.CustomerJobName" :value="item.Id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="note-txt">
            <p style="font-weight:bold;">备注：</p>
            <p>1、批量导入待面试，项目和岗位必选。</p>
            <p>2、批量导入入离职，项目必选，岗位非必选。</p>
            <p>3、批量导入离职，人员名单仅限于花名册在职人员。</p>
          </div>
        </div>
      </div>
      <div v-if="importActive == 1" style="margin-top:15px;padding-bottom:15px;">
        <div class="note-txt">
          <p style="font-weight:bold;">上传文件说明：</p>
          <p>1. 支持文件后缀 xls、xlsx文件。</p>
          <p>2. 请将要上传的内容放在第一个sheet中。</p>
          <p>3. 请不要加密模板文件，将导致错误。</p>
          <p>4. 请不要上传带宏的文件，将导致错误。</p>
          <p>5. 请不要过多的使用格式，如背景色和边框，将可能导致超时。</p>
          <p>6. 导入后只会保留Excel中的数据及通过公式计算后的值，设置的文字颜色等样式、合并的单元格、以及计算公式本身都不会被保留。</p>
        </div>
        <div style="margin-top:10px">请选择导入文件（xls/xlsx格式）:</div>
        <div class="form-item" style="justify-content: space-between;">
          <div class="file-box">
            <input readonly style="width: 368px;height:32px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
            <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
            <label for="fileInput" class="file-btn">上传</label>
          </div>
        </div>
        <!-- 提示 -->
        <p style="color:red;" v-if="isError">{{ errorTxt }}</p>
        <div class="reimpArea">
          <div style="margin-top:10px">
          </div>
        </div>
      </div>
      <div v-if="importActive == 2" style="margin-top:15px;padding-bottom:15px;">
        <div class="result-box">
          <p><i class="el-icon-success" style="color: #409EFF;margin-right:5px"></i>导入数据正在处理中，导入结果请在’导入记录‘中查看。</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="importVisible = false" v-if="importActive == 0">取消</el-button>
        <el-button size="small" @click="prevSteps" v-if="importActive > 0 && importActive <= 1">上一步</el-button>
        <el-button type="primary" size="small" @click="nextSteps" v-if="importActive < 1">下一步</el-button>
        <el-tooltip effect="dark" content="未上传文件不能提交" :disabled="!isUploadSuccess" placement="top">
          <div style="display:inline-block;margin-left:10px">
            <el-button type="success" size="small" @click="lastSteps" element-loading-text="此操作可能耗费较长时间，请等待..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading.fullscreen.lock="fullscreenLoading" v-if="importActive == 1" :disabled="isUploadSuccess">提交</el-button>
          </div>
        </el-tooltip>
        <el-button type="primary" size="small" @click="backHandle" v-if="importActive == 2">确认并返回</el-button>
        <el-button size="small" @click="resultHandle" v-if="importActive == 2">查看导入结果</el-button>
      </span>
    </el-dialog>
    <!-- 设置到岗时间弹框 -->
    <el-dialog title="设置到岗时间" :visible.sync="dtreachVisible" width="700px" class="res_dialog">
      <el-form :model="dtreachQuery" ref="dtreachForm" class="re_dialog_form" label-width="130px">
        <el-form-item label="到岗时间:" prop="Dtreachtime" :rules="{
          required: true, message: '到岗时间不能为空', trigger: 'change'
        }">
          <el-date-picker size="small" value-format="yyyy-MM-dd HH:mm" format='yyyy-MM-dd HH:mm' v-model="dtreachQuery.Dtreachtime" type="datetime" placeholder="">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dtreachVisible = false" size="small">取消</el-button>
        <el-button type="primary" class="com_dialog_btn" @click="saveDtreachHandle" size="small">确定</el-button>
      </span>
    </el-dialog>
    <!-- 修改面试时间弹框 -->
    <el-dialog title="更改面试时间" :visible.sync="interviewVisible" width="700px" class="res_dialog">
      <p class="interview_title">注: 距已约的面试时间小于 60分钟，则不可修改。</p>
      <el-form :model="interviewQuery" ref="interviewForm" :rules="viewRules" class="re_dialog_form" label-width="110px">
        <el-form-item label="面试日期:" prop="dates">
          <el-select v-model="interviewQuery.dates" filterable clearable size="mini" placeholder="" @change="diaSurdateChange01">
            <el-option v-for="(item, index) in dialogDateList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面试时间:" prop="times">
          <el-select v-model="interviewQuery.times" filterable clearable size="mini" placeholder="">
            <el-option v-for="(item, index) in dialogTimeList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="interviewVisible = false" size="small">取消</el-button>
        <el-button type="primary" class="com_dialog_btn" @click="saveInterviewHandle" size="small">确定</el-button>
      </span>
    </el-dialog>
    <!-- 约面登记提示弹框 -->
    <el-dialog title="确认信息" :visible.sync="confirmInfoVisible" width="600px" class="res_dialog">
      <div style="font-size:16px;">
        <span>是否确定</span>
        <span style="font-weight:bold;color:#F56C6C;margin:0 5px;">姓名: {{ appointmentQuery.StrUserName }}，</span>
        <span style="font-weight:bold;color:#F56C6C;">项目: {{ confirmQuery.StrprojectName }}，</span>
        <span style="font-weight:bold;color:#F56C6C;margin:0 5px;">岗位: {{ confirmQuery.JobCategory }}</span>
        <span>约面登记？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="infoCancelHandle" size="small">取消</el-button>
        <el-button type="primary" class="com_dialog_btn" @click="saveInfoHandle" size="small">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="线下签约导入" :visible.sync="showOffSign" width="600px">
      <el-form label-width="120px">
        <el-form-item label="导入模板">
          <span class="blueName cp" @click="downImportTemp">下载模板</span>
        </el-form-item>
        <el-form-item label="导入Excel" prop="url">
          <div class="file-box">
            <input readonly style="width: 200px;height:29px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
            <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf2(this)" ref="upload2">
            <label for="fileInput" class="file-btn cp">上传</label>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showOffSign = false" size="small">取 消</el-button>
        <el-button type="primary" :disabled="!isUploadSuccess2" v-preventReClick style="margin-left:10px;" @click="confirmImport" size="small">提 交</el-button>
      </span>
    </el-dialog>

    <div class="eleForm">
      <el-dialog title="提交电子签约信息" :visible.sync="showEleInfo" width="1100px">
        <el-form :model="eleForm" :inline="true" :rules="eleRules" ref="eleForm" label-width="135px">
          <el-form-item label="签约模板" prop="tempid">
            <el-select v-model="TempName" placeholder="" clearable filterable size="small" style="width:200px" value-key="TempId" @change="val => { changeTemp(val) }">
              <el-option v-for="(item, index) in tempList" :key="index" :label="item.TempName" :value="item" size="small"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模板类型">
            <el-input v-model="tempType" readonly style="width:200px" disabled size="small"></el-input>
          </el-form-item>
          <!-- <el-form-item label="客户合同主体" prop="StrCustName">
            <el-input v-model="StrCustName" readonly style="width:200px" disabled size="small"></el-input>
          </el-form-item> -->
          <el-form-item label="员工签约主体" prop="ContractSubject">
            <el-select v-model="eleForm.ContractSubject" placeholder="" clearable filterable style="width:200px" @change="changeLeg" size="small">
              <el-option v-for="(item,index) in legList" :key="index" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="法人" prop="LegalPer">
            <el-input v-model="eleForm.LegalPer" readonly style="width:200px" disabled size="small"></el-input>
          </el-form-item>
          <el-form-item label="注册地址" prop="RegisterAddress">
            <el-input v-model="eleForm.RegisterAddress" readonly style="width:200px" disabled size="small"></el-input>
          </el-form-item>
          <!-- <el-form-item label="客户单位全称">
            <el-input v-model="eleForm.ClientFullName" style="width:200px" size="small"></el-input>
          </el-form-item> -->

          <el-form-item label="合同/协议类型" prop="ProtocolType">
            <el-select v-model="eleForm.ProtocolType" value-key="name" placeholder="" clearable filterable size="small" @change="changeCont" style="width:200px">
              <el-option v-for="(item, index) in contractList" :key="index" :label="item.name" :value="item"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="工作地点（区域）" prop="WorkSite" v-if="contractType == 5 || contractType == 6">
            <el-input v-model="eleForm.WorkSite" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="学校全称" prop="SchoolName" v-if="contractType == 3 || contractType == 9">
            <el-input v-model="eleForm.SchoolName" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="学生专业" prop="StudentMajor" v-if="contractType == 9">
            <el-input v-model="eleForm.StudentMajor" style="width:200px" size="small"></el-input>
          </el-form-item>

          <!-- <el-form-item label="文化程度" prop="StrEduLvl" v-if="contractType && contractType<=15">
              <el-input v-model="eleForm.StrEduLvl" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="联系地址" prop="EmpContactAddress" v-if="contractType && contractType<=15">
              <el-input v-model="eleForm.EmpContactAddress" style="width:200px" size="small"></el-input>
            </el-form-item> -->

          <el-form-item :label="contractType != 9 || contractType != 10 ? '合同起始时间' : '协议起始时间'" prop="ContractStartTime" v-if="contractType != 9 && contractType != 10 && contractType">
            <el-date-picker type="date" placeholder="" v-model="eleForm.ContractStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item :label="contractType != 9 || contractType != 10 ? '合同时长（年）' : '协议时长（年）'" v-if="contractType != 9 && contractType != 10 && contractType">
            <el-input type="number" v-model="ContractTime" @blur="getContractEndDate" style="width:200px" size="small" :disabled="!eleForm.ContractStartTime"></el-input>
          </el-form-item>
          <el-form-item :label="contractType != 9 || contractType != 10 ? '合同结束时间 （可编辑更改）' : '协议结束时间 （可编辑更改）'" prop="ContractEndTime" v-if="contractType != 9 && contractType != 10 && contractType">
            <el-date-picker type="date" placeholder="" v-model="eleForm.ContractEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="试用期起始时间" prop="TrialPeriodStartTime" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
            <el-date-picker type="date" placeholder="" v-model="eleForm.TrialPeriodStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="试用期时长(月)" prop="TrialMonth" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
            <el-input type="number" v-model="eleForm.TrialMonth" style="width:200px" size="small" :disabled="!eleForm.TrialPeriodStartTime" @blur="getEndDate"></el-input>
          </el-form-item>
          <el-form-item label="试用期结束时间（可编辑更改）" prop="TrialPeriodEndTime" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
            <el-date-picker type="date" placeholder="" v-model="eleForm.TrialPeriodEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>

          <el-form-item :label="contractType == 8 ? '终止（解除）劳动合同时间' : '终止（解除）协议时间'" prop="TimeLaborContract" v-if="contractType == 8 || contractType == 9 || contractType == 10">
            <el-date-picker type="date" placeholder="" v-model="eleForm.TimeLaborContract" value-format="yyyy-MM-dd" style="width:200px" size="small" @blur="changeTimeLaborContract"></el-date-picker>
          </el-form-item>

          <el-form-item label="工作时长(年)" prop="WorkingYear" v-if="contractType == 8">
            <el-input v-model="eleForm.WorkingYear" style="width:200px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工作时长(月)" prop="WorkingMonth" v-if="contractType == 8">
            <el-input v-model="eleForm.WorkingMonth" style="width:200px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工作时长(天)" prop="WorkingDay" v-if="contractType == 8">
            <el-input v-model="eleForm.WorkingDay" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item :label="no!=30 ? '发薪日' : '发放日'" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no!=31">
            <el-input v-model="eleForm.PayDay" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="工资标准方式" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no!=30 && no!=31">
            <el-select v-model="eleForm.MeansOfPayments" placeholder="" clearable filterable size="small" style="width:200px">
              <el-option value="0" label="固定工资" size="small"></el-option>
              <el-option value="1" label="基本工资+绩效工资" size="small"></el-option>
              <el-option value="2" label="计件工资" size="small"></el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="城市" v-if="no == 23 || no == 2">
            <el-input v-model="eleForm.WorkCity" style="width:200px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工资" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no!=25 && no!=30 && no!=31" :prop="no=='24' ? 'Yuan' : ''">
            <el-input v-model="eleForm.Yuan" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="城市" v-if="no == 23 || no == 2">
            <el-input v-model="eleForm.WorkCity" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="工时" v-if="no == 23 || no == 24" :prop="no=='24' ? 'WorkTime' : ''">
            <el-select v-model="eleForm.WorkTime" placeholder="" clearable filterable size="small" style="width:200px">
              <el-option label="标准工时制" value="0"></el-option>
              <el-option label="不定时工时制" value="1"></el-option>
              <el-option label="综合计算工时制" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="部门" v-if="no == 24" prop="StrDep">
            <el-input v-model="eleForm.StrDep" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="试用期工资" v-if="no == 24" prop="TrialPeriodDec">
            <el-input v-model="eleForm.TrialPeriodDec" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="备注1" v-if="contractType == 11">
            <el-input v-model="eleForm.list[0].Remark1" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="备注2" v-if="contractType == 11 && no!=25">
            <el-input v-model="eleForm.list[0].Remark2" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="备注3" v-if="contractType == 11 && no!=25">
            <el-input v-model="eleForm.list[0].Remark3" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="暂缓缴纳原因" v-if="no == 25" prop="StrReasonzh">
            <el-input v-model="eleForm.StrReasonzh" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="补贴金额">
            <el-input v-model="eleForm.SubsidyAmount" type="number" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item label="补贴金额大写">
            <el-input v-model="eleForm.SubsidyInstru" style="width:200px" size="small"></el-input>
          </el-form-item>

          <el-form-item :label="contractType == 8 ? '终止（解除）劳动合同时间（员工联）' : '终止（解除）协议时间（员工联）'" prop="TimeLaborContractStaff" v-if="contractType == 8 || contractType == 9 || contractType == 10">
            <el-date-picker type="date" placeholder="" v-model="eleForm.TimeLaborContractStaff" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
          </el-form-item>

          <el-table :data="eleForm.list" class="doc_table" border max-height="300px" style="width:100%;margin-top: 10px;">
            <el-table-column label="序号" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PhoneNum" label="电话" :show-overflow-tooltip="true" align="center" min-width="95">
            </el-table-column>
            <el-table-column prop="StrIdCard" label="身份证号码" :show-overflow-tooltip="true" align="center" min-width="156">
            </el-table-column>
            <el-table-column prop="StrprojectName" label="项目名称" :show-overflow-tooltip="true" align="center" min-width="140">
              <template>{{ eleForm.ObjName }}</template>
            </el-table-column>
            <el-table-column prop="DtEntryBdate" label="入职日期" align="center" min-width="140">
              <template slot-scope="{row}">
                <el-date-picker type="date" placeholder="" v-model="row.DtEntryBdate" value-format="yyyy-MM-dd" size="small" style="width:130px"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column prop="JobName" label="合同岗位" align="center" min-width="140px">
              <template slot-scope="{row}">
                <el-input v-model="row.JobName" size="small" style="width:130px"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="StrEduLvl" label="文化程度" :show-overflow-tooltip="true" align="center" min-width="130">
              <template slot-scope="{row}">
                <el-select v-model="row.StrEduLvl" size="small" style="width: 110px;" placeholder="" filterable>
                  <el-option value="博士"></el-option>
                  <el-option value="硕士"></el-option>
                  <el-option value="本科"></el-option>
                  <el-option value="大专"></el-option>
                  <el-option value="中专"></el-option>
                  <el-option value="高中"></el-option>
                  <el-option value="初中及以下"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="ClientFullName" label="客户单位全称" align="center" min-width="140px">
              <template slot-scope="{row}">
                <el-input v-model="row.ClientFullName" size="small" style="width:130px"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Bankcard" label="银行卡号" align="center" min-width="130">
              <template slot-scope="{row}">
                <el-input v-model="row.Bankcard" size="small" style="width:120px"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="DepositBank" label="开户银行" align="center" min-width="130">
              <template slot-scope="{row}">
                <el-input v-model="row.DepositBank" size="small" style="width:120px"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="EmpContactAddress" label="户籍地址" align="center" min-width="200">
              <template slot-scope="{row}">
                <el-input v-model="row.EmpContactAddress" size="small" style="width:190px"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="部门" align="center" min-width="200" v-if="no == 24">
              <template slot-scope="{row}">
                <el-input v-model="row.StrDep" size="small" style="width:190px"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="试用期工资" align="center" min-width="200" v-if="no == 24">
              <template slot-scope="{row}">
                <el-input v-model="row.TrialPeriodDec" size="small" style="width:190px"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="暂缓缴纳原因" align="center" min-width="200" v-if="no == 25">
              <template slot-scope="{row}">
                <el-input v-model="row.StrReasonzh" size="small" style="width:190px"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="补贴金额" align="center" min-width="200" v-if="no != 23">
              <template slot-scope="{row}">
                <el-input v-model="row.SubsidyAmount" size="small" style="width:190px"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="补贴金额大写" align="center" min-width="200" v-if="no != 23">
              <template slot-scope="{row}">
                <el-input v-model="row.SubsidyInstru" size="small" style="width:140px"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="保密年限" align="center" min-width="200" v-if="no==30">
              <template slot-scope="{row}">
                <el-input v-model="row.WorkingDay" size="small" style="width:140px"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showEleInfo = false" size="small">取消</el-button>
          <el-popconfirm title="请确认是否继续？" @confirm="confirmToEle()" style="margin-left:10px">
            <el-button type="primary" slot="reference" v-preventReClick size="small" :loading="isBtnLoading">去电子签约</el-button>
          </el-popconfirm>
        </span>
      </el-dialog>

      <el-dialog title="批量商保增员" :visible.sync="showDeclare" width="1100px">
        <el-form :model="declareForm" :inline="true" :rules="declareRules" ref="declareForm" label-width="135px">
          <el-form-item label="险种名称">
            <el-select v-model="declareForm.Insurance.InsuranceId" placeholder="" size="small" @change="insChange" clearable filterable style="width:300px">
              <el-option v-for="(item, index) in planList" :key="index" :label="item.Bntype" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可参保保单" prop="policy">
            <el-select v-model="policy" placeholder="" value-key="Id" size="small" clearable filterable style="width:300px" @change="policyChange">
              <el-option v-for="(item, index) in policyList" :key="index" :label="item.CoverStartTime.split('T')[0] + ' ~ ' + item.CoverEndTime.split('T')[0]" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="保障期限" prop="Insurance.InsuranceStartTime">
            <div class=" flex aic">
              <el-date-picker type="date" placeholder="" v-model="declareForm.Insurance.InsuranceStartTime" value-format="yyyy-MM-dd" style="width:143px" size="small" disabled></el-date-picker>
              <div style="margin: 0 5px;">-</div>
              <el-date-picker type="date" placeholder="" v-model="declareForm.Insurance.InsuranceEndTime" value-format="yyyy-MM-dd" style="width:143px" size="small" disabled></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="项目名称" prop="Insurance.Projectid">
            <el-input v-model="declareForm.Insurance.ProjectName" style="width:300px" size="small" readonly disabled></el-input>
          </el-form-item>
        </el-form>

        <el-table :data="declareForm.userList" class="ele_table" max-height="300px" style="width:100%;">+
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="MainlinsuredName" label="被保险人姓名" :show-overflow-tooltip="true" align="center" width="100">
          </el-table-column>
          <el-table-column prop="MainlinsuredCardId" label="被保险人证件" :show-overflow-tooltip="true" align="center" width="155">
          </el-table-column>
          <el-table-column prop="MainlinsuredPhone" label="被保险人手机号" :show-overflow-tooltip="true" align="center" width="120">
          </el-table-column>
          <el-table-column prop="JobName" label="岗位" align="center">
            <template slot="header">
              <span>
                岗位
                <el-tooltip :content="JobNameTip" placement="top" effect="light">
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <template slot-scope={row}>
              <el-input v-model="row.JobName" style="width:120px" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="JobClasss" label="职业类别" :show-overflow-tooltip="true" align="center">
            <template slot="header">
              <span>
                职业类别
                <el-tooltip :content="JobClasssTip" placement="top" effect="light">
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <template slot-scope={row}>
              <el-select v-model="row.JobClasss" placeholder="" clearable size="small" style="width:120px">
                <el-option v-for="(item, index) in JobClasssList" :key="index" :value="item"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="EmployeeAttribute" label="员工属性" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <el-select v-model="row.EmployeeAttribute" placeholder="" clearable size="small" style="width:120px">
                <el-option value="长期工"></el-option>
                <el-option value="临时工"></el-option>
                <el-option value="日结工"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="LaborContractUnit" label="劳动合同公司" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <el-select v-model="row.LaborContractUnit" placeholder="" clearable size="small" style="width:120px" filterable>
                <el-option v-for="(item,index) in legList2" :key="index" :value="item.name"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDeclare = false" size="small">取消</el-button>
          <el-popconfirm title="请确认是否继续？" @confirm="confirmToInsure()" style="margin-left:10px">
            <el-button type="primary" slot="reference" v-preventReClick size="small">提 交</el-button>
          </el-popconfirm>
        </span>
      </el-dialog>
      <el-dialog title="批量商保" :visible.sync="insuranceVisible" width="900px" class="ins_dialog_box">
        <el-form :model="insQuery" :inline="true" :rules="insRules" ref="insForm" label-width="100px">
          <el-form-item label="险种名称" prop="InsuranceId">
            <el-select v-model="insQuery.InsuranceId" placeholder="" size="small" clearable filterable style="width:300px" @change="insChange">
              <el-option v-for="(item, index) in planList" :key="index" :label="item.Bntype" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="可参保保单" prop="policy">
            <el-select v-model="insQuery.policy" placeholder="" value-key="Id" size="small" clearable filterable style="width:300px" @change="policyChange">
              <el-option v-for="(item, index) in policyList" :key="index" :label="item.CoverStartTime.split('T')[0] + ' ~ ' + item.CoverEndTime.split('T')[0]" :value="item"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="保障期限" prop="InsuranceStartTime">
            <div class=" flex aic">
              <el-date-picker type="date" placeholder="" v-model="insQuery.InsuranceStartTime" value-format="yyyy-MM-dd" style="width:143px" size="small"></el-date-picker>
              <div style="margin: 0 5px;">-</div>
              <el-date-picker type="date" placeholder="" v-model="insQuery.InsuranceEndTime" value-format="yyyy-MM-dd" style="width:143px" size="small"></el-date-picker>
            </div>
          </el-form-item> -->
          <el-form-item label="职业类别" prop="JobClasss">
            <el-select v-model="insQuery.JobClasss" placeholder="" clearable size="small" style="width:300px">
              <el-option v-for="(item, index) in JobClasssList" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="员工属性" prop="EmployeeAttribute">
            <el-select v-model="insQuery.EmployeeAttribute" placeholder="" clearable size="small" style="width:300px">
              <el-option value="长期工"></el-option>
              <el-option value="临时工"></el-option>
              <el-option value="日结工"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位名称" prop="JobName">
            <el-input v-model="insQuery.JobName" style="width:300px" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
        <el-table :data="insuranceData" class="ele_table" max-height="400px" style="width:100%;">
          <el-table-column label="姓名" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span>{{ row.StrUserName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="身份证" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span>{{ row.StrIdCard }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系方式" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span>{{ row.StrMobile }}</span>
            </template>
          </el-table-column>
          <el-table-column label="项目名称" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span>{{ row.StrprojectName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="JobName" label="岗位名称" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span>{{ row.CustomerJobName }}</span>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="insuranceVisible = false" size="small">取消</el-button>
          <el-button type="primary" size="small" :loading="insLoading" @click="saveInsureHandle">提 交</el-button>
        </span>
      </el-dialog>

      <el-dialog title="补充信息" :visible.sync="showCompletionInfo" width="500px" class="ins_dialog_box">
        <el-form :model="cInfo" :rules="insRules" ref="insForm" label-width="100px">
          <el-form-item label="姓名">
            <el-input v-model="StrUserName" style="width:300px" size="small" readonly disabled></el-input>
          </el-form-item>
          <el-form-item label="项目">
            <el-select v-model="cInfo.projectId" filterable clearable size="small" placeholder="" @change="changePro()" style="width:300px">
              <el-option v-for="(item, index) in resProjectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位">
            <el-select v-model="cInfo.jobId" filterable clearable size="small" placeholder="" style="width:300px">
              <el-option v-for="(item, index) in jobList" :key="index" :label="item.JobCategory" :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showCompletionInfo = false" size="small">取消</el-button>
          <el-button type="primary" size="small" :loading="insLoading" @click="confirmCompletionInfo">确 认</el-button>
        </span>
      </el-dialog>

      <el-dialog title="" :visible.sync="showWarnMsg" width="700px">
        <div v-html="warnMsg">
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showWarnMsg = false" size="small">关 闭</el-button>
        </span>
      </el-dialog>

      <el-dialog :title="signType == 'entry' ? '待入职登记' : '面试登记'" :visible.sync="showEntrySign" width="920px">
        <entrySign ref="entrySignRef" @close="close" :signType="signType"></entrySign>
      </el-dialog>
      <el-dialog title="打印" :visible.sync="showPrint" width="920px">
        <!-- 打印 -->
        <Print ref="printRef" @closePrint="closePrint" :printList=printList></Print>
      </el-dialog>


      <!-- 详情 -->
      <el-dialog title="详情" :visible.sync="showPsnDtl" width="650px" class="res_dialog enter_dialog">
        <div v-if="showPsnDtl">
          <el-form :inline="true" ref="registForm" class="re_down_form" label-width="110px">
            <el-form-item label="姓名：">
              <div class="psnDtlItem">{{ psnDtlInfo.StrUserName }}</div>
            </el-form-item>
            <el-form-item label="电话：">
              <div class="psnDtlItem">{{ psnDtlInfo.StrMobile }}</div>
            </el-form-item>
            <el-form-item label="性别：">
              <div class="psnDtlItem">{{ psnDtlInfo.BolUserSex }}</div>
            </el-form-item>
            <el-form-item label="年龄：">
              <div class="psnDtlItem">{{ psnDtlInfo.StrUserAge }}</div>
            </el-form-item>
            <el-form-item label="民族：">
              <div class="psnDtlItem">{{ psnDtlInfo.StrUsernation }}</div>
            </el-form-item>
            <el-form-item label="简历来源：">
              <div class="psnDtlItem">{{ psnDtlInfo.StrSource }}</div>
            </el-form-item>
            <el-form-item label="项目名称：">
              <div class="psnDtlItem">{{ psnDtlInfo.StrprojectName }}</div>
            </el-form-item>
            <el-form-item label="岗位名称：">
              <div class="psnDtlItem">{{ psnDtlInfo.CustomerJobName }}</div>
            </el-form-item>
            <el-form-item label="身份证：">
              <div class="psnDtlItem">{{ psnDtlInfo.StrIdCard }}</div>
            </el-form-item>
            <el-form-item label="住宿需求：">
              <div class="psnDtlItem">{{ psnDtlInfo.StrAccomreq }}</div>
            </el-form-item>
            <el-form-item label="推荐渠道：">
              <div class="psnDtlItem">{{ psnDtlInfo.PushName }}</div>
            </el-form-item>
            <el-form-item label="推荐渠道备注：">
              <div class="psnDtlItem">{{ psnDtlInfo.PushRemark }}</div>
            </el-form-item>
            <el-form-item label="推荐渠道人员来源：">
              <div class="psnDtlItem">{{ psnDtlInfo.ReferralChannels }}</div>
            </el-form-item>
            <el-form-item label="备注：">
              <div class="psnDtlItem">{{ psnDtlInfo.StrRemark }}</div>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>

      <!-- 修改手机号 -->
      <el-dialog title="修改联系方式" :visible.sync="showEditPhone" width="500px" class="ins_dialog_box">
        <el-form :model="cInfo" :rules="insRules" ref="insForm" label-width="100px">
          <el-form-item label="联系方式">
            <el-input v-model="phoneInfo.StrPhoneNum" style="width:300px" size="small"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showEditPhone = false" size="small">取消</el-button>
          <el-button type="primary" size="small" :loading="insLoading" @click="confirmEditPhone">确 认</el-button>
        </span>
      </el-dialog>

      <el-dialog title="导出使用人数" :visible.sync="showImportUserList" width="400px">
        <el-form :model="iulForm" label-width="100px">
          <el-form-item label="开始时间" prop="start">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="iulForm.start" type="date" style="width:180px" placeholder="">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="end">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="iulForm.end" type="date" style="width:180px" placeholder="">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showImportUserList = false" size="small">取 消</el-button>
          <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmImportUserList" size="small" :loading="isBtnLoading">确 认</el-button>
        </span>
      </el-dialog>
      <!-- 发送通知弹框 -->
      <el-dialog title="发送通知" :visible.sync="sendNoticeVisible" width="800px" class="send_notice_dialog" :close-on-click-modal="false">
        <div class="notice_section">
          <div class="notice_label">已接受人：</div>
          <div class="notice_content">
            <span class="count_num">{{ selectedNoticeRows.length }}人</span>
            <div class="recipient_names" v-if="selectedNoticeRows.length > 0">
              <span v-for="(row, idx) in selectedNoticeRows.slice(0, 5)" :key="idx">{{ row.StrUserName }}{{ idx < (selectedNoticeRows.slice(0, 5).length - 1) ? '，' : '' }}</span>
              <span v-if="selectedNoticeRows.length > 5">...</span>
            </div>
          </div>
        </div>

        <div class="notice_section">
          <div class="notice_label">发送渠道：</div>
          <div class="notice_content channel_box">
            <el-checkbox v-model="channels.sms" @change="onChannelChange">
              短信，选择发送签名：
              <el-select v-model="sendNoticeForm.channelType" size="mini" placeholder="请选择签名" style="width:240px;margin-left:6px" :disabled="!channels.sms" @change="onSmsSignChange">
                <el-option v-for="item in smsSignList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
              </el-select>
            </el-checkbox>
            <!-- <el-checkbox v-model="channels.wx" @change="onChannelChange">
              微信公众号：{{ wxAccountName }}
            </el-checkbox> -->
          </div>
        </div>

        <div class="notice_section" v-if="channels.sms">
          <div class="notice_label">短信模板：</div>
          <div class="notice_content">
            <el-select v-model="smsCategory" size="small" placeholder="请选择类别" @change="onSmsCategoryChange" style="width:140px">
              <el-option v-for="(item,index) in smsCategoryList" :key="index" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
            <el-select v-model="sendNoticeForm.templateId" size="small" placeholder="请选择模板" style="width:200px;margin-left:10px" @change="smsTemplateChange">
              <el-option v-for="item in smsTemplateList" :key="item.templateId" :label="item.templateName" :value="item.templateId"></el-option>
            </el-select>
          </div>
        </div>

        <!-- <div class="notice_section" v-if="channels.wx">
          <div class="notice_label">公众号模板：</div>
          <div class="notice_content">
            <el-select v-model="sendNoticeForm.wxCategory" size="small" placeholder="请选择类别" @change="onWxCategoryChange" style="width:140px">
              <el-option v-for="item in wxCategoryList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
            <el-select v-model="sendNoticeForm.wxTemplate" size="small" placeholder="请选择模板" style="width:200px;margin-left:10px">
              <el-option v-for="item in filteredWxTemplateList" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </div>
        </div> -->

        <div class="notice_section" v-if="sendNoticeForm.templateId">
          <div class="notice_label">可选字段：</div>
          <div class="notice_content optional_fields">
            <div class="optional_item" v-for="item in filedList" :key="item.Id">
              <span class="opt_label">{{ item.variableName }}：</span>
              <template v-if="item.sourceType != 'customValue'">
                <el-radio v-model="item.sourceType" label="systemField">{{ '按对应' + [item.variableName] }}</el-radio>
                <el-radio v-model="item.sourceType" label="customValue1">自定义</el-radio>
              </template>
              <el-input v-model="sendNoticeForm.customVariableValues[item.variableName]" size="mini" placeholder="" :disabled="item.sourceType != 'customValue' && item.sourceType == 'systemField'" style="width:240px;margin-left:6px" @blur="getSmsPreviewText" :maxlength="item.maxLength" show-word-limit></el-input>
            </div>
          </div>
        </div>

        <div class="notice_section" v-if="sendNoticeForm.templateId">
          <div class="notice_label">发送内容预览：</div>
          <div class="notice_content">
            <el-tabs v-model="previewTab" @tab-click="onPreviewTabChange">
              <el-tab-pane label="短信预览" name="sms" v-if="channels.sms">
                <div class="preview_box sms_preview">{{ smsPreviewText }}</div>
              </el-tab-pane>
              <el-tab-pane label="公众号预览" name="wx" v-if="channels.wx">
                <div class="preview_box wx_preview">
                  <div class="wx_card">
                    <div class="wx_card_title">标题：{{ wxPreviewData.title }}</div>
                    <div class="wx_card_pos">岗位：{{ wxPreviewData.position }}</div>
                    <div class="wx_card_time">报到：{{ wxPreviewData.reportTime }}</div>
                    <div class="wx_card_remark">备注：{{ wxPreviewData.remark }}</div>
                    <div class="wx_card_btns">
                      <span class="wx_link">点击确认接受</span>
                      <span class="wx_link">点击拒绝</span>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <div class="notice_section">
          <div class="notice_label">发送时间：</div>
          <div class="notice_content radio_group">
            <el-radio v-model="sendNoticeForm.sendType" :label="1">立即发送</el-radio>
            <el-radio v-model="sendNoticeForm.sendType" :label="2">定时发送</el-radio>
            <el-date-picker v-model="sendNoticeForm.sendTime" type="datetime" size="mini" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :disabled="sendNoticeForm.sendType !== 2" style="width:140px;margin-left:10px"></el-date-picker>
          </div>
        </div>

        <div class="notice_warning">
          <span class="warning_text">注意：发送录用通知后将产生法律效力，请确认后再发送！</span>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="sendNoticeVisible = false" size="small">取消</el-button>
          <el-button type="primary" :loading="sendNoticeLoading" @click="confirmSendNotice" size="small">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "./../../common.vue";
  import moment from 'moment'
  import FUN from "./../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import ImportItem from "./components/importItem.vue"
  import ResourceComTabs from "./components/resourceComTabs.vue"
  import entrySign from "./components/entrySign.vue"
  import Print from "./components/Print.vue"
  import "moment-precise-range-plugin"
  export default {
    components: {
      ImportItem,
      ResourceComTabs,
      entrySign,
      Print
    },
    data() {
      var validatetInsuranceTime = (rule, value, callback) => {
        if (!this.declareForm.Insurance.InsuranceStartTime) {
          callback(new Error("请选择保障开始时间"));
        } else if (!this.declareForm.Insurance.InsuranceStartTime) {
          callback(new Error("请选择保障结束时间"));
        } else {
          callback();
        }
      };
      var validatePhone = (rule, value, callback) => {
        const phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
        // console.log('validatePhone',value)
        if (value.length == 11 && phoneReg.test(value)) {
          //校验通过
          this.checkHandle(value, (res) => {
            // console.log('validatePhone',res)
            if (res) {
              this.getResumeDtl(this.enterResumeQuery.ResumeId)
              callback()
            } else {
              callback()
            }
          })
        } else {
          callback(new Error('请输入正确的手机号'))
        }
      }
      var validatePhone01 = (rule, value, callback) => {
        // const phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/i;
        const phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
        // console.log('validatePhone',value)
        if (value.length == 11 && phoneReg.test(value)) {
          //校验通过
          if (this.phoneType01 != 'save') {
            this.getResumeDtl01(value, 'regist')
          }
          callback()
        } else {
          callback(new Error('请输入正确的手机号'))
        }
      }
      var validatePhone02 = (rule, value, callback) => {
        const phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
        // console.log('validatePhone',value)
        if (value.length == 11 && phoneReg.test(value)) {
          //校验通过
          if (this.phoneType02 != 'save') {
            this.getResumeDtl01(value, 'toface')
            callback()
          }
          callback()
        } else {
          callback(new Error('请输入正确的手机号'))
        }
      }
      var validatecard = (rule, value, callback) => {
        // console.log('value',value)
        if (!this.isNullNotZero(value)) {
          if (value.length != 18) {
            callback(new Error('身份证号码格式不正确'));
          } else {
            let idcode = value;
            let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, ];
            let check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
            let code = idcode + "";
            let last = idcode[17].toUpperCase(); //最后一个
            let seventeen = code.substring(0, 17);
            // ISO 7064:1983.MOD 11-2
            // 判断最后一位校验码是否正确
            let arr = seventeen.split("");
            let len = arr.length;
            let num = 0;
            for (let i = 0; i < len; i++) {
              num = num + arr[i] * weight_factor[i];
            }
            // 获取余数
            var resisue = num % 11;
            var last_no = check_code[resisue];
            // 格式的正则
            // 正则思路
            var idcard_patter = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
            // 判断格式是否正确
            var format = idcard_patter.test(idcode);
            if (last === last_no && format == true) {
              callback()
            } else {
              callback(new Error('身份证号码格式不正确'));
            }
          }
        } else {
          callback()
        }
      };
      return {
        confirmInfoVisible: false,
        interviewVisible: false,
        noteLoading: false,
        confirmQuery: {
          StrprojectName: '',
          JobCategory: ''
        },
        // 导入岗位列表
        impJobList: [],
        dialogDateList: [],
        dialogTimeList: [],
        phoneType01: '', //登记手机号是否是保存操作
        phoneType02: '',
        tofaceNoteTxt01: '',
        tofaceNoteTxt02: '',
        // 是否能到面登记
        isTofaceAct: true,
        // 是否能点击搜索按钮
        isSearchHandle: false,
        btnLoading01: false,
        btnLoading02: false,
        btnLoading03: false,
        btnLoading04: false,
        btnLoading05: false,
        btnLoading06: false,
        btnLoading07: false,
        btnLoading08: false,
        btnLoading09: false,
        btnLoading10: false,
        btnLoading11: false,
        recommendLoading: false,
        // 报名登记项目列表
        resProjectList: [],
        // 所有岗位列表
        allPostList: [],
        // 岗位列表
        resPostList: [],
        // 约面
        surfaceVisible: false,
        surfaceLoading: false,
        surfaceTableData: [],
        // 放弃入职
        abandonVisible: false,
        abandonLoading: false,
        abandonTableData: [],
        // 黑名单标签
        blackLabelList: [],
        abandonQuery: {
          currpage: 1,
          perpage: 10
        },
        // 报名登记
        registVisible: false,
        registTableData: [],
        registQuery: {
          StrUserName: '',
          StrMobile: 10
        },
        // 到面
        tofaceVisible: false,
        tofaceLoading: false,
        tofaceTableData: [],
        // 撤销约面/未到面
        revokeVisible: false,
        revokeLoading: false,
        revokeTableData: [],
        revokeTxt: '',
        // 面试通过
        passInterVisible: false,
        passInterLoading: false,
        passInterTableData: [],
        // 面试未通过
        failInterVisible: false,
        failInterLoading: false,
        failInterTableData: [],
        // 到面登记
        toFaceVisible: false,
        checkQuery: {},
        checkTableData: [],
        // 终止流程
        endProcessVisible: false,
        endProcessLoading: false,
        endProcessTableData: [],
        // 离职
        quitVisible: false,
        quitLoading: false,
        quitTableData: [],
        // 转岗
        transVisible: false,
        transLoading: false,
        transTableData: [],
        // 未入职
        unemployedVisible: false,
        unemployedLoading: false,
        unemployedTableData: [],
        // 超过五个部门提示
        isCheckDepart: false,
        // 项目列表
        projectList: [],
        // 项目名称列表参数
        proNameQuery: {
          projectname: '', // 项目名称
          projectid: '', // 项目id
          custname: '', //客户名称
          strAchieveowner: '', // 业绩归属人
          strservuserid: '', // 客服
          strBusiStat: '', //项目状态
          strpartner2: '', //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: '',
          roletype: ''
        },
        // 通知输入框列表
        inputList: [],
        // 是否获取过全部标签(包含标签)
        isGetALLLabel1: true,
        // 是否获取过全部标签(排除标签)
        isGetALLLabel2: true,
        // 模板信息
        moduleInfo: '',
        // 导入显示页面
        importActive: 0,
        // 选中的地区code
        strCityCode: [],
        // 表头
        tableTitle: [],
        // 表头参数
        titleQuery: {
          ststus: '报名' //报名 已约面 到面 通过 在职 异常 离职 流程已入职 流程未入职（流程统计中）
        },
        // 意向岗位列表
        intendedPost: [],
        // 所有标签
        allLabelList: [],
        // 录入简历公有标签
        includePublicChecks: [],
        // 录入简历私有标签
        includePrivateChecks: [],
        // 弹框
        importVisible: false,
        enterResumeVisible: false,
        divideVisible: false,
        isBtnLoading: false,
        // 录入简历参数
        enterResumeQuery: {
          ResumeId: '0', //简历ID
          StrUserName: '', //姓名
          StrMobile: '', //联系方式
          StrWorkState: '', //当前状态
          BolUserSex: '', //性别
          StrUserAge: '', //年龄
          StrNativePlace: '', //户籍
          StrEduLvl: '', //学历
          StrJobInf: '', //意向岗位
          StrCategoryIds: '', //意向岗位id
          // 选中的意向岗位
          posCategoryList: [],
          StrUserCity: '', //求职城市
          StrUserAdd: '', //居住地
          StrUserCityCode: '', //求职城市code
          StrSource: '', //来源
          StrUserExpectSa: '', //期望薪资
          salary1: '',
          salary2: '',
          StrRemark: '', //备注
          StrlateCompany: '', //最近入职项目
          DtlateInducDate: '', //最近入职时间
          DtlatequitDate: '', //最近离职时间
          StrquitReason: '', //离职原因
          StrUserJobhunt: '', //求职意向
          StrPsnIsType: '', //是否公海 1 公海 0私人
          StrJobType: '', //岗位类型
          StrState: '', //在离职状态
          //拓展
          StrIsBlack: '', //是否黑名单
          StrBlackReason: '', //黑名单原因
          StrUsernation: '', //民族
          Strskill: '', //技能
          Strcertificate: '', //证书
          StrAccomreq: '', //住宿要求
          StrDinreq: '', //吃饭要求
          StrIsqwfri: '', //是否企微好友
          StrCont1: '', //拓展1
          StrCont2: '',
          StrCont3: '',
          StrCont4: '',
          StrCont5: '',
          StrCont6: '',
          StrCont7: '',
          StrCont8: '',
          StrCont9: '',
          StrCont10: '',
          WorkingShift: '', // 班次
          Workingposition: '', // 站班/坐班
          StrResumefile: '', // 简历文件名称
          trResumefileUrl: '' // 简历文件路径
        },
        // 分配简历参数
        divideQuery: {
          resumeIds: '', // 简历id (多条用,连接)
          userIds: '', // 人员id (多条用,连接)
          StrPsnIsType: '', // 0 私有  1公海
          perDepartList: []
        },
        // 分配选中的人员
        dividePersonList: [],
        // 到面登记规则
        toFaceRules: {
          Projectid: [{
            required: true,
            message: '请选择到面项目',
            trigger: 'change'
          }],
          Jobid: [{
            required: true,
            message: '请选择到面岗位',
            trigger: 'change'
          }],
          StrUserName: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          StrIdCard: [{
            message: '请输入正确的身份证号码',
            validator: validatecard,
            trigger: ['blur']
          }],
          StrMobile: [{
              required: true,
              message: '请输入手机号',
              trigger: 'blur'
            },
            {
              validator: validatePhone02,
              trigger: ['blur']
            }
          ],
          BolUserSex: [{
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }],
          StrUserAge: [{
            required: true,
            message: '请输入年龄',
            trigger: 'blur'
          }],
          StrSource: [{
            required: true,
            message: '请选择简历来源',
            trigger: 'change'
          }],
          StrUsernation: [{
            required: true,
            message: '请选择民族',
            trigger: 'change'
          }],
          Dtfacetime: [{
            required: true,
            message: '请选择到面时间',
            trigger: 'change'
          }],
          qudao: [{
            required: true,
            message: '请选择招聘渠道',
            trigger: 'change'
          }]
        },
        // 报名登记规则
        rules1: {
          Projectid: [{
            required: true,
            message: '请选择报名项目',
            trigger: 'change'
          }],
          Jobid: [{
            required: true,
            message: '请选择报名岗位',
            trigger: 'change'
          }],
          StrUserName: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          StrUserAge: [{
            required: true,
            message: '请输入年龄',
            trigger: 'blur'
          }],
          StrIdCard: [{
            message: '请输入正确的身份证号码',
            validator: validatecard,
            trigger: ['blur']
          }],
          BolUserSex: [{
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }],
          StrMobile: [{
              required: true,
              message: '请输入电话',
              trigger: ['blur']
            },
            {
              validator: validatePhone01,
              trigger: ['blur']
            }
          ],
          StrSource: [{
            required: true,
            message: '请选择简历来源',
            trigger: 'change'
          }],
          StrUsernation: [{
            required: true,
            message: '请选择民族',
            trigger: 'change'
          }],
          PushName: {
            required: true,
            message: '请选择推荐渠道',
            trigger: 'change'
          },
          PushRemark: {
            required: true,
            message: '请选择推荐渠道备注',
            trigger: 'change'
          }
        },
        // 约面登记规则
        rules2: {
          Projectid: [{
            required: true,
            message: '请选择约面项目',
            trigger: 'change'
          }],
          Jobid: [{
            required: true,
            message: '请选择约面岗位',
            trigger: 'change'
          }],
          appDtviewDate: [{
            required: true,
            message: '请选择面试日期',
            trigger: 'change'
          }],
          appDtviewTime: [{
            required: true,
            message: '请选择面试时间',
            trigger: 'change'
          }],
          StrUserName: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          StrUserAge: [{
            required: true,
            message: '请输入年龄',
            trigger: 'blur'
          }],
          BolUserSex: [{
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }],
          StrIdCard: [{
            message: '请输入正确的身份证号码',
            validator: validatecard,
            trigger: ['blur']
          }],
          StrMobile: [{
              required: true,
              message: '请输入电话',
              trigger: 'blur'
            },
            {
              validator: validatePhone01,
              trigger: ['blur']
            }
          ],
          StrSource: [{
            required: true,
            message: '请选择简历来源',
            trigger: 'change'
          }],
          StrUsernation: [{
            required: true,
            message: '请选择民族',
            trigger: 'change'
          }],
          Strviewadd: [{
            required: true,
            message: '请选择面试地址',
            trigger: 'change'
          }],
          // posCategoryList: [
          //   { type: 'array', required: true, message: '请选择意向岗位', trigger: 'change'}
          // ]
        },
        // 录入简历规则
        enterRules: {
          StrUserName: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          StrMobile: [{
              required: true,
              message: '请输入联系方式',
              trigger: 'blur'
            },
            {
              validator: validatePhone,
              trigger: ['blur']
            }
          ],
          StrUserCity: [{
            required: true,
            message: '请选择意向地区',
            trigger: 'change'
          }],
          BolUserSex: [{
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }],
          StrSource: [{
            required: true,
            message: '请选择简历来源',
            trigger: 'change'
          }],
          posCategoryList: [{
            type: 'array',
            required: true,
            message: '请选择意向岗位',
            trigger: 'change'
          }],
          StrUserAge: [{
            required: true,
            message: '请输入年龄',
            trigger: 'blur'
          }]
        },
        // 分配简历对象
        divideRules: {
          perDepartList: [{
            type: 'array',
            required: true,
            message: '请选择部门或人员',
            trigger: 'change'
          }]
        },
        // 修改面试时间规则
        viewRules: {
          dates: [{
            required: true,
            message: '请选择面试日期',
            trigger: 'change'
          }],
          times: [{
            required: true,
            message: '请选择面试时间',
            trigger: 'change'
          }]
        },
        // 通知
        noticeRules: {
          TemplateId: [{
            required: true,
            message: '请选择通知模板',
            trigger: 'change'
          }],
          checkNoticeList: [{
            type: 'array',
            required: true,
            message: '请选择通知方式',
            trigger: 'change'
          }]
        },
        // 人岗匹配推荐
        followRules: {
          StrRemark: [{
            required: true,
            message: '请输入补充信息',
            trigger: 'blur'
          }]
          // fCheckList: [
          //   { type: 'array', required: true, message: '请选择更新求职意愿', trigger: 'change'}
          // ]
        },
        // 人岗匹配推荐
        recommendQuery: {
          ResumeId: '', // 简历id
          StrUserJobhunt: '', // 求职意愿
          StrReason: '', // 原因
          StrRemark: '', // 备注
          GduserId: '', // 操作人
          GduserName: '', // 操作人姓名
          StrOther: '', // 其他
          fCheckList: []
        },
        // 部门参数
        departQuery: {
          strorgancode: '',
          roletype: ''
        },
        departMemberQuery: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        },
        // 部门列表
        departList: [],
        // 人员列表
        memberList: [],
        // 自定义 级联选择props
        depprops: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        propPosition: {
          label: 'strParametername',
          value: 'strParameterid',
          children: 'children',
          checkStrictly: true
        },
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          multiple: true
        },
        tableHeight: 0,
        showDropScreen: -1,
        activeName: '报名',
        tabids: [],
        onworkQuery: {
          StrObjName: '',
          roletype: ''
        },
        // 列表参数
        listQuery: {
          StrnowState: '已报名', //状态
          strProjectName: '', // 项目名称
          projectid: '',
          strUserName: '', // 姓名
          strMobile: '', // 联系方式
          strJobInf: '', //岗位
          strSource: '', //来源
          strreuser: '', //招聘顾问
          strUserkf: '', //客服
          stroutid: '', //导出选中id
          currpage: 1, // 分页
          perpage: 10,
          strSourcejl: '', //简历来源
          roletype: localStorage.loginRoletype,
          posCategoryList: [], //意向岗位
          jobList: [], // 人岗匹配岗位
          SignatureStatus: '0', //签约状态
          isInsure: '',
        },
        // 导出参数
        exportQuery: {
          strProjectName: '', // 项目名称
          strUserName: '', // 姓名
          strMobile: '', // 联系方式
          strJobInf: '', //岗位
          strSource: '', //来源
          strreuser: '', //招聘顾问
          strUserkf: '', //客服
          stroutid: '', //导出选中id
          ststus: '',
          currpage: 1, // 分页
          perpage: 1000000
        },
        //显示更多
        showMore4: true,
        showMore5: true,
        showMore6: true,
        switchBtn: true,
        canvasImg: './../../../assets/images/qrcode.png',
        canvasImg1: '',
        canvasImg2: '',
        tableLoading: false,
        tableData: [],
        isCanHandle: true,
        total: 0,
        multipleSelection: [],
        divideLoading: false,
        noticeVisible: false,
        noticeLoading: false,
        labelVisible: false,
        addlabelVisible: false,
        laloading: false,
        followVisible: false,
        // 分配记录列表
        divideData: [],
        // 消息通知参数
        noticeQuery: {
          TemplateId: '',
          SendList: []
        },
        checkNoticeList: ['短信'],
        // 通知模板
        noticeTempList: [],
        // 消息通知列表数据
        noticeData: [],
        // 发送通知弹框
        sendNoticeVisible: false,
        sendNoticeLoading: false,
        selectedNoticeRows: [],
        previewTab: 'sms',
        wxAccountName: '杰博股份',
        smsSignList: [{
          Name: '宁波杰博人力',
          Id: 1
        }, {
          Name: '宁波英普瑞特供应链管理',
          Id: 2
        }],
        smsCategoryList: [],
        wxCategoryList: [],
        smsTemplateList: [],
        wxTemplateList: [],
        channels: {
          sms: false,
          wx: false
        },
        sendNoticeForm: {
          channelType: '',
          channelId: '',
          templateId: '',
          customVariableValues: {

          },
          recipients: [],
          sendTime: null,
          sendType: 1,
          SenderId: Cookies.get("userid-b")
        },
        filedList: [],
        smsPreviewText: '',
        smsTemplateContent: '',
        positionType: '按应聘岗位',
        signName: '',
        smsCategory: '',
        // 标签列表
        wholeCheckList: [],
        wholeCheckList2: [],
        // 全局标签列表
        publicList: [],
        // 私有标签列表
        privateList: [],
        roleType: localStorage.loginRoletype,
        labelActiveName: '全局标签',
        activeFollowName: '人岗匹配推荐',
        // 人岗匹配推荐列表
        recommendList: [],
        // 投入公海参数
        injectQuery: {
          resumeIds: '' // 简历id (多条用,连接)
        },
        // 服务记录 流程记录
        serviceLoading: false,
        serviceData: [],
        // 跟进记录
        followLoading: false,
        followData: [],
        // 简历录入打标签参数
        enterTagQuery: {
          resumeIds: '', // 简历id (多条用,连接)
          labelIds: '' // 标签id (多条用,连接)
        },
        // 简历录入已经打的标签
        enTagChecks: [],
        // 省份
        provinces: [],
        propsAddress: {
          checkStrictly: true,
          value: 'Id',
          label: 'Name',
          children: 'children'
        },
        // 标签弹框全局标签列表
        lPubDialogList: [],
        // 标签弹框私有标签列表
        lPriDialogList: [],
        // 添加标签弹框选中的标签
        diaTagChecks: [],
        // 简历id
        resumeIds: '',
        // 跟进记录
        followQuery: {
          resumeId: '', //简历id
          currpage: 1,
          perpage: 10
        },
        totalFollow: 0,
        // 服务记录
        serviceQuery: {
          resumeId: '', //简历id
          roletype: localStorage.loginRoletype,
          currpage: 1,
          perpage: 10
        },
        totalService: 0,
        btnLoading: false,
        // 通知动态input的数量
        inputNum: 0,
        // 动态input的值
        inputList: [],
        matchQuery: {
          StrPlanstatus: '招聘中', // 招聘中或停招
          JobCategory: '',
          ResumeId: '',
          pageNum: 1,
          pageSize: 10
        },
        matchCount: 0,
        // 添加的分配列表
        devUserList: [],
        addDivideQuery: {
          departName: '',
          Username: '',
          userIds: []
        },
        // 招聘来源(来源)列表
        originList: [],
        // 人员列表
        memberSearchList: [],
        // 客服/顾问参数
        oneDepartQuery: {
          strorgancode: '',
          roletype: ''
        },
        depMemberQuery: {
          currpage: 1,
          perpage: 10000,
          strWorkState: '在职',
          keyword: ''
        },
        // 选中的分配人员
        mulDivideList: [],
        devDataList: [],
        useridList: [],
        // 分配记录
        listRecordQuery: {
          perpage: 10,
          currpage: 1
        },
        rectotal: 0,
        divRecordVisible: false,
        recLoading: false,
        recTableData: [],
        pageCrumb: '报名',
        imgPath: this.$store.state.EMP.imgPath,
        // 通知表头
        tableNoteTitle: [],
        // 弹框选中的全局标签
        dCheckCommonLabelList: [],
        // 弹框选中的私有标签
        dCheckPriLabelList: [],
        showEntrySign: false,
        appointmentQuery: {
          Jobid: '', //岗位id
          Projectid: '', //项目id
          Belonguserid: '', //创建人
          ResumeId: '', //简历ID
          StrState: '', //当前状态
          StrUserName: '', //姓名
          StrMobile: '', //联系方式
          StrUserCity: '', //求职城市
          StrUserCityCode: '', //求职城市
          StrRemark: '', //备注
          StrUserAge: '', //年龄
          BolUserSex: '', //性别
          StrSource: '', //简历来源
          StrUsernation: '', //民族
          Dtviewtime: '', //面试时间
          appDtviewDate: '', //面试日期
          appDtviewTime: '', //面试时间
          Strviewadd: '', //面试地址
          StrAccomreq: '', //住宿需求
          StrIdCard: '', //身份证
          PushName: '', //推荐渠道
          PushRemark: '', //推荐备注
          ReferralChannels: null,
        },
        checkQuery: {
          Jobid: '', //岗位id
          Projectid: '', //项目id
          StrState: '到面', //当前状态
          StrUserName: '', //姓名
          StrMobile: '', //联系方式
          Belonguserid: '', //创建人
          ResumeId: '', //简历ID
          Dtviewtime: '', //面试时间
          Strviewadd: '', //面试地址
          StrUserCity: '', //求职城市
          StrUserCityCode: '', //求职城市
          StrRemark: '', //备注
          StrUserAge: '', //年龄
          BolUserSex: '', //性别
          StrPsnIsType: '0', //是否公海
          Dtfacetime: '', //到面时间
          StrIdCard: '', //身份证
          StrSource: '', //简历来源
          StrUsernation: '', //民族
          qudao: '', //招聘渠道
          Sctjr: '', //社招推荐人(部门/人)
          Gsqd: '', //公司渠道
          Gsqdtjr: '', //公司渠道推荐人
          Wbqd: '', //外部渠道
          Wbqdtjr: '', //外部渠道推荐人
          Qtqk: '', //其他情况
          StrAccomreq: '', //住宿需求
          appDtviewtime: ''
        },
        njMember: '', //内荐人
        appointCityVal: '',
        // 根据岗位获取面试时间列表
        viewTimeQuery: {
          interviewStartTime: '',
          interviewEndTime: ''
        },
        viewTimeList: [],
        // 检查约面返回的数据
        surfaceBackList: [],
        loginRoleType: '',
        userLabel: localStorage.userLabel,
        // 各登记弹框名称
        signDialogTitle: '',
        // 民族列表
        nationList: [],
        // 面试地址
        viewAddressList: [],
        searPostList: [],
        // 生成二维码
        codeQuery: {
          Id: '', // 岗位ID
          pagepath: 'pages/enter/enter', // 页面URL
          strLinkType: 'D' //A-报名二维码，B-到面二维码,C-入职二维码通过二维码 D-简历采集二维(ID传空)
        },
        // 登录人员的所有角色
        allLoginRoleType: '',
        // 修改到岗时间
        dtreachQuery: {
          GdststusId: '',
          Dtreachtime: '',
          Dtviewretime: '', // 面试时间
          strtype: '通过' //已面试 通过
        },
        dtreachVisible: false,
        // 二维码项目岗位列表
        qrProjectList: [],
        // 二维码项目选中参数
        qrProQuery: {
          projectid: '',
          strVal: '',
        },
        // 约面提醒
        faceNoteTxt01: '',
        faceNoteTxt02: '',
        // 到面部门列表
        faceDepartList: [],
        // 选中的部门
        dedpartNameList: [],
        // 选中的部门名称
        depNameVal: '',
        // 选中的社招推荐人
        szMember: '',
        // 是否能约面登记
        isFaceAct: true,
        // 岗位约面日期列表
        viewDateList: [],
        // 岗位约面时间列表
        viewTimesList: [],
        tablePath: this.$store.state.EMP.tablePath,
        userid: Cookies.get("userid-b"),
        // 导入参数
        ExcelSrc: {
          value: '',
          check: false,
          fileName: ''
        },
        excelpath: '',
        isUploadSuccess: false,
        fullscreenLoading: false,
        errorTxt: '',
        //是否下载过导入模板
        isDownProcessTemplate: false,
        //表头错误提示
        isError: false,
        importSignQuery: {
          fileid: '批量导入待面试模板',
          tableid: 'JB_emp_PsnStatusDms', //JB_emp_PsnStatus 批量到面导入表 JB_emp_UserBase  批量入职模板（简易）
          tabName: '批量导入待面试模板',
          projectid: '',
          strprojectName: '', //选择的项目名称
          jobid: '', //选择的岗位
          customerJobName: '' //岗位名称
        },
        importTableList: [{
          StrTableName: '批量导入待面试模板'
        }, {
          StrTableName: '批量导入待入职模板'
        }, {
          StrTableName: '批量入职模板（简易）'
        }, {
          StrTableName: '批量导入离职模板'
        }],
        importProjectList: [],
        importPostList: [],
        importName: '批量待面试导入',
        isFaceDownload: false, //是否下载过待面试、待入职模板
        isJobDownload: false, //是否下载过入职模板
        isDepartDownload: false, //是否下载过离职模板
        isDownFaceTemplate: '',
        isDownJobTemplate: '',
        downSignQuery: { //下载模板
          tableid: ''
        },
        interviewQuery: {
          GdststusId: '',
          Dtreachtime: '',
          dates: '',
          times: '',
          Dtviewtime: '', // 面试时间
          strtype: '已约面' //已约面 通过
        },
        viewJobId: '',
        proSearchQuery: {
          searchVal: '',
          pageSize: 100000000,
          pageNum: 1
        },
        // 搜索项目列表
        proNameList: [],
        searchProJobList: [],
        jobProId: '',
        codeloading: false,
        // 按钮权限参数
        butQuery: {
          path: '/signupList',
          powerEnName: 'employee'
        },
        permissionLists: [],
        eleForm: { //电子签约信息表单
          tempid: '', //模板id
          ContractSubject: '', //员工签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          ClientFullName: '', //客户单位全称
          ContractStartTime: '', //合同开始时间
          ContractEndTime: '', //合同结束时间
          TrialPeriodStartTime: '', //试用期开始时间
          TrialPeriodEndTime: '', //试用期结束时间
          TrialMonth: '', //试用期时长
          ProtocolType: '', //合同/协议类型
          JobName: '', //岗位
          WorkSite: '', //工作地点
          SchoolName: '', //学校
          Bankcard: '', //银行卡号
          DepositBank: '', //开户银行
          WorkingYear: '', //工作时长(年)
          WorkingMonth: '', //工作时长(月)
          WorkingDay: '', //工作时长(天)
          TimeLaborContract: '', //终止（解除）劳动合同时间
          TimeLaborContractStaff: '', //终止（解除）劳动合同时间（员工联）
          StrEduLvl: '', //文化程度
          EmpContactAddress: '', //联系地址
          MeansOfPayments: '', //工资标准方式
          PayDay: '',
          Yuan: '',
          WorkCity: '',
          WorkTime: '',
          list: [], //选中的在职人员列表
        },
        showEleInfo: false, //提交电子签约信息弹窗
        tempList: [], //模板列表
        legList: [], //主体列表
        legList2: [], //主体列表
        tempType: '', //模板类型
        TempName: '',
        StrCustName: '', //客户合同主体
        eleRules: {
          tempid: {
            required: true,
            message: '请选择模板',
            trigger: 'change'
          },
          ContractSubject: {
            required: true,
            message: '请选择员工签约主体',
            trigger: 'change'
          },
          LegalPer: {
            required: true,
            message: '请选择法人',
            trigger: 'change'
          },
          RegisterAddress: {
            required: true,
            message: '请选择注册地址',
            trigger: 'change'
          },
          ContractStartTime: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'change'
          },
          ContractEndTime: {
            required: true,
            message: '请选择合同结束时间',
            trigger: 'change'
          },
          TrialPeriodStartTime: {
            required: true,
            message: '请选择试用期起始时间',
            trigger: 'change'
          },
          TrialPeriodEndTime: {
            required: true,
            message: '请选择试用期结束时间',
            trigger: 'change'
          },
          TrialMonth: {
            required: true,
            message: '请输入试用期时长',
            trigger: 'blur'
          },
          ProtocolType: {
            required: true,
            message: '请选择合同/协议类型',
            trigger: 'change'
          },
          JobName: {
            required: true,
            message: '请输入工作岗位（工种）',
            trigger: 'blur'
          },
          SchoolName: {
            required: true,
            message: '学校全称',
            trigger: 'blur'
          },
          WorkSite: {
            required: true,
            message: '请输入工作地点（区域）',
            trigger: 'blur'
          },
          WorkingYear: {
            required: true,
            message: '请输入工作时长(年)',
            trigger: 'blur'
          },
          WorkingMonth: {
            required: true,
            message: '请输入工作时长(月)',
            trigger: 'blur'
          },
          WorkingDay: {
            required: true,
            message: '请输入工作时长(天)',
            trigger: 'blur'
          },
          TimeLaborContract: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间',
            trigger: 'change'
          },
          TimeLaborContractStaff: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间（员工联）',
            trigger: 'change'
          },
          StudentMajor: {
            required: true,
            message: '请输入学生专业',
            trigger: 'blur'
          },
          PayDay: {
            required: true,
            message: '请输入发薪日',
            trigger: 'blur'
          },
          MeansOfPayments: {
            required: true,
            message: '请选择工资标准方式',
            trigger: 'blur'
          },
          Yuan: {
            required: true,
            message: '请输入工资',
            trigger: 'blur'
          },
          StrReasonzh: {
            required: true,
            message: '请输入暂缓缴纳原因',
            trigger: 'blur'
          },
          WorkTime: {
            required: true,
            message: '请输入工时',
            trigger: 'blur'
          },
        },
        fileList: [],
        showOffSign: false,
        isUploadSuccess2: false, //是否上传成功
        impUrl: '', //导入url
        ContractTime: '', //合同时长
        contractList: this.$store.state.EMP.contractList, //合同/协议列表
        contractType: '',
        // 用户通知数量
        noteNum: '',
        declareForm: {
          Insurance: {
            BusinessType: 1, //1报增 0 报减
            InsuranceId: '', //险种id
            ProjectName: '', //项目名称
            OrderNum: '', //订单号
            Projectid: '', //项目id
            InsuranceStartTime: '', //保险期限
            InsuranceEndTime: '',
          },
          userList: []
        },
        planList: [], //险种列表
        showDeclare: false,
        declareRules: {
          'Insurance.InsuranceStartTime': {
            required: true,
            validator: validatetInsuranceTime,
            trigger: "change",
          },
          'Insurance.InsuranceId': {
            required: true,
            message: "请选择险种",
            trigger: "change",
          },
        },
        JobClasssList: ['1-4类', '5'],
        JobNameTip: '需要具体细化，参考《职业分类表》进行填写',
        JobClasssTip: '参考《职业分类表》',
        // 公共批量参数
        comFaceQuery: {
          comRemark: '', //备注
          StrAccomreq: '', //住宿需求
          timeChecked: false, //是否未确定到岗时间
          Dtreachtime: '', //到岗时间
          checked: false, //是否体检
          Strphysicalhos: '', //体检医院
          StrBlackReason: '', //黑名单标签
          StrJobNamejs: '' //结算岗位
        },
        // 未入职黑名单原因
        reasonQuery: {
          remark: ''
        },
        // 批量导入状态
        importStrState: '',
        insuranceVisible: false,
        // 保单列表
        policyList: [],
        policy: '',
        showCompletionInfo: false,
        StrUserName: '',
        jobList: [],
        cInfo: {
          gdststusID: '',
          jobId: '',
          projectId: ''
        },
        insQuery: {
          BusinessType: 1, //1报增  报减
          InsuranceId: '', //险种id
          ProjectName: '', //项目名称
          OrderNum: '', //订单号可不传
          Projectid: '', //项目id
          JobName: '', //岗位名称
          // InsuranceStartTime:'',//保障期限
          // InsuranceEndTime:'',
          JobClasss: '', //职业类别
          EmployeeAttribute: '' //员工属性
        },
        insRules: {
          InsuranceId: {
            required: true,
            message: "请选择险种",
            trigger: "change"
          },
          JobClasss: {
            required: true,
            message: "请选择职业类别",
            trigger: "change"
          },
          EmployeeAttribute: {
            required: true,
            message: "请选择员工属性",
            trigger: "change"
          },
          JobName: {
            required: true,
            message: "请输入岗位名称",
            trigger: "blur"
          }
        },
        // 批量商保的人
        insuranceData: [],
        insLoading: false,
        xjzprojectid: '',
        xjzprojectname: '',
        JXZQCode: '',
        // 导入查询参数
        stateInfoQuery: {
          pagecount: 10,
          currpage: 1,
          strOperType: '入职批量导入', //待面试批量导入 待入职批量导入 入职批量导入  离职批量导入
          excelname: '',
          tableid: "JB_emp_UserBaseSimple",
          datestart: '',
          dateend: '',
          strobjname: '',
          impdate: '',
          druserId: ''
        },
        showWarnMsg: false,
        warnMsg: '',
        no: '',
        signType: '', //登记类型
        printList: [],
        psnDtlInfo: {}, //详情信息
        showPsnDtl: false,
        showPrint: false,
        entryBatchVisible: false, //批量入职弹框
        entryBatchData: {
          DtEntryBdate: '', //批量用工之日：
          StrWorkState: '',
          StrBlCmp: '', //开票公司
          CustomerJobName: '', //岗位名称
          Recruitdep: '', //招聘部门
        },
        showEditPhone: false,
        phoneInfo: {
          StrExcelPath: '',
          IntExcelLine: '',
          StrPhoneNum: ''
        },
        quitList: [], //离职操作列表
        insureList: [],
        showReduction: false,
        showImportUserList: false,
        ChannelsList: [{
            name: '无',
            value: 0
          },
          {
            name: '58',
            value: 1
          }, {
            name: '抖音',
            value: 2
          }, {
            name: '微信群或朋友圈',
            value: 3
          }, {
            name: '快手',
            value: 4
          }, {
            name: '小红书',
            value: 5
          }, {
            name: '其他网上招聘途径等',
            value: 6
          }, {
            name: '贴单',
            value: 7
          }, {
            name: '内荐（含熟人介绍）',
            value: 8
          }, {
            name: '设摊（含主动上门）',
            value: 9
          }, {
            name: '供应商',
            value: 10
          }, {
            name: '企业转移',
            value: 11
          }
        ],
        iulForm: {
          start: '',
          end: '',
          userid: Cookies.get("userid-b"),
          filename: '',
        }
      }
    },
    created() {
      if (this.$route.query.objName != undefined && this.$route.query.objName) {
        this.listQuery.strProjectName = this.$route.query.objName;
      }
      if (this.$route.query.strUserName != undefined && this.$route.query.strUserName) {
        this.listQuery.strUserName = this.$route.query.strUserName;
      }
      if (this.$route.query.strMobile != undefined && this.$route.query.strMobile) {
        this.listQuery.strMobile = this.$route.query.strMobile;
      }
      this.loginRoleType = localStorage.loginRoletype
      this.proNameQuery.roletype = localStorage.loginRoletype
      this.proNameQuery.strorgancode = localStorage.gancode
      this.calHeight()
      this.getButtonPower() //获取按钮权限
      if (this.userLabel != 'K') {
        // 客服列表
        this.getCusList('customer')
        // 部门列表
        this.getDepartList()
      }
      // 所有标签
      this.GetLabelManagement()
      // 获取省份
      this.getprovinces()
      // 意向岗位
      this.getTreestr()
      // 黑名单标签
      this.getdictdatalistbyid('132')
      this.getdictdatalistbyid('253')
      this.getdictdatalistbyid('118')
      // 获取有权限的项目列表和岗位列表
      this.getResourceJoblist();
      // 获取导入权限及权限项目列表
      // this.getImportProject()
      this.getSearchProList()
      // this.getSearchJobProList()
      this.getLegalSubjectList();
      this.getlegalsubjectlist2();
    },
    computed: {
      registerRules: function () {
        if (this.signDialogTitle == '约面登记') {
          return this.rules2
        } else {
          return this.rules1
        }
      },
      // wxPreviewData() {
      //   let firstRow = this.selectedNoticeRows.length > 0 ? this.selectedNoticeRows[0] : null
      //   let position = ''
      //   if (this.sendNoticeForm.fields.showPosition) {
      //     position = this.positionType === '自定义' ?
      //       this.sendNoticeForm.fields.customPosition :
      //       (firstRow ? firstRow.CustomerJobName : 'XXXX')
      //   }
      //   return {
      //     title: '录用通知书（' + (firstRow ? firstRow.StrUserName : '张伟') + ' 先生/女士）',
      //     position: position || 'XXXX',
      //     reportTime: this.sendNoticeForm.fields.showReportTime ?
      //       this.sendNoticeForm.customVariableValues.报到时间 : '2026/8/10 上午9点',
      //     remark: this.sendNoticeForm.fields.showRemark ?
      //       this.sendNoticeForm.customVariableValues.备注 : '请带身份证'
      //   }
      // }
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      // 批量处理流程入职
      employBatchHandle() {
        let that = this
        if (that.isNull(that.multipleSelection)) {
          that.$message({
            type: 'warning',
            message: '请选择需要处理的数据'
          })
          return
        } else {
          let arr = []
          for (let i = 0; i < this.multipleSelection.length; i++) {
            let eleMul = that.multipleSelection[i];
            arr.push({
              GdststusId: eleMul.GdststusId,
              DtEntryBdate: eleMul.DtEntryBdate,
              StrIdCard: eleMul.StrIdCard
            })
          }
          that.$confirm('是否确定入职?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then((res) => {
            xz.saveStatusonworkInf(arr).then(res => {
              if (res.status == 'ok') {
                that.$message({
                  type: 'success',
                  message: '操作成功'
                })
                that.listQuery.currpage = 1
                that.getList()
              } else {
                that.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          })
        }
      },
      // 商保
      insDialogHandle(type, act) {
        let that = this;
        window.location.href = "/declare?currAct=" + act;
        // that.$router.push({
        //   path: "/declare",
        //   query: {
        //     currAct: act,
        //     refresh:true
        //   }
        // })
        // if (this.isNull(this.multipleSelection)) {
        //   that.$message({
        //     type: 'warning',
        //     message: '请选择商保的数据'
        //   })
        //   return false;
        // } else {
        //   that.insuranceData = that.multipleSelection;
        //   let id = that.multipleSelection[0].Projectid;
        //   // 判断选中的数据是否是同一个项目
        //   if ((that.multipleSelection.some(v => v.Projectid != id)) == true) {
        //     that.$message({
        //       type: 'warning',
        //       message: '存在不同项目的数据,不能操作,请选择同一个项目或选中项目筛选后搜索再批量选择数据操作'
        //     })
        //     return false;
        //   }else{
        //     let item = that.insuranceData[0]
        //     that.insQuery.ProjectName = item.StrprojectName
        //     that.insQuery.Projectid = item.Projectid
        //     if(type == '报增'){
        //       that.insQuery.BusinessType = 1
        //     }
        //     if(type == '报减'){
        //       that.insQuery.BusinessType = 0
        //     }
        //     that.getInsurancManageByUserid()
        //     that.insuranceVisible = true
        //   }
        // }
      },
      // 商保保存
      saveInsureHandle() {
        let that = this;
        let Insurance = {
          BusinessType: that.insQuery.BusinessType,
          InsuranceId: that.insQuery.InsuranceId,
          ProjectName: that.insQuery.ProjectName,
          Projectid: that.insQuery.Projectid
        }
        let userList = [];
        for (let i = 0; i < that.insuranceData.length; i++) {
          let element = that.insuranceData[i];
          userList.push({
            MainlinsuredName: element.StrUserName,
            MainlinsuredCardId: element.StrIdCard,
            Idtype: "身份证",
            MainlinsuredPhone: element.StrMobile,
            JobName: element.CustomerJobName,
            JobClasss: that.insQuery.JobClasss,
            EmployeeAttribute: that.insQuery.EmployeeAttribute,
          })
        }
        let query = {
          Insurance: Insurance,
          userList: userList
        }
        // console.log('query',query)
        that.$refs["insForm"].validate((valid) => {
          if (valid) {
            that.insLoading = true
            xz.reportAddApprov(query, this.roleType).then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.insuranceVisible = false;
                this.$message.success('操作成功！');
              } else {
                this.$message.error('系统出错！');
              }
              that.insLoading = false
            })
          }
        })
      },
      // 选择险种
      insChange(val) {
        if (!this.isNull(val)) {
          this.getPolicyList(val)
          this.getInsurancCategory(val)
        }
      },
      //获取可参保时间段列表
      getPolicyList(Id) {
        let data = {
          insurable: 1,
          pageNum: 1,
          InsuranceId: Id,
          pageSize: 1000,
        }
        xz.getOrderPolicyManageList(data, this.roleType).then(res => {
          if (res.status == 'ok') {
            this.policyList = res.data.list;
          } else {
            this.policyList = []
          }
        })
      },
      // 选择黑名单原因
      reasonHandle(val) {
        if (!this.isNull(val)) {
          if (val == '其他') {
            // 未入职
            if (!this.isNull(this.unemployedTableData) && (this.unemployedVisible == true)) {
              for (let i = 0; i < this.unemployedTableData.length; i++) {
                let eleFaceMul4 = this.unemployedTableData[i];
                this.$set(eleFaceMul4, 'StrBlackReason', this.reasonQuery.remark);
              }
            }
            // 不通过
            if (!this.isNull(this.failInterTableData) && (this.failInterVisible == true)) {
              for (let i = 0; i < this.failInterTableData.length; i++) {
                let eleFaceMul3 = this.failInterTableData[i];
                this.$set(eleFaceMul3, 'StrBlackReason', this.reasonQuery.remark);
              }
            }
          }
        } else {
          this.reasonQuery.remark = ''
        }
      },
      // 批量黑名单标签
      reasonComHandle(val) {
        let that = this
        // 不通过
        if (!this.isNull(this.failInterTableData) && (this.failInterVisible == true)) {
          for (let i = 0; i < this.failInterTableData.length; i++) {
            let eleFaceMul3 = that.failInterTableData[i];
            that.$set(eleFaceMul3, 'StrBlackReason', that.comFaceQuery.StrBlackReason);
          }
        }
        // 未入职
        if (!this.isNull(this.unemployedTableData) && (this.unemployedVisible == true)) {
          for (let i = 0; i < this.unemployedTableData.length; i++) {
            let eleFaceMul4 = that.unemployedTableData[i];
            that.$set(eleFaceMul4, 'StrBlackReason', that.comFaceQuery.StrBlackReason);
          }
        }
        // 终止
        if (!this.isNull(this.endProcessTableData) && (this.endProcessVisible == true)) {
          for (let i = 0; i < this.endProcessTableData.length; i++) {
            let eleFaceMul5 = that.endProcessTableData[i];
            that.$set(eleFaceMul5, 'StrBlackReason', that.comFaceQuery.StrBlackReason);
          }
        }
      },
      // 批量选择体检医院
      comPhyChange(val) {
        // 通过
        let that = this
        if (!this.isNull(this.passInterTableData) && (this.passInterVisible == true)) {
          for (let i = 0; i < that.passInterTableData.length; i++) {
            let eleFaceMul2 = that.passInterTableData[i];
            that.$set(eleFaceMul2, 'Strphysicalhos', that.comFaceQuery.Strphysicalhos);
          }
        }
      },
      // 批量选择是否体检
      examHandle(val) {
        // 通过
        let that = this
        if (!this.isNull(this.passInterTableData) && (this.passInterVisible == true)) {
          for (let i = 0; i < that.passInterTableData.length; i++) {
            let eleFaceMul2 = that.passInterTableData[i];
            that.$set(eleFaceMul2, 'checked', that.comFaceQuery.checked);
          }
        }
      },
      // 批量选择到岗时间
      comTimeChange(val) {
        // console.log('ll',row)
        let that = this
        if (that.comFaceQuery.timeChecked) {
          that.comFaceQuery.Dtreachtime = ''
        }
        // 通过
        if (!this.isNull(this.passInterTableData) && (this.passInterVisible == true)) {
          for (let i = 0; i < that.passInterTableData.length; i++) {
            let eleFaceMul2 = that.passInterTableData[i];
            that.$set(eleFaceMul2, 'timeChecked', that.comFaceQuery.timeChecked);
            that.$set(eleFaceMul2, 'Dtreachtime', that.comFaceQuery.Dtreachtime);
          }
        }
      },
      dateBatchChange(val) {
        // console.log('ll',val)
        let that = this
        that.comFaceQuery.Dtreachtime = val
        if (!this.isNull(val)) {
          that.comFaceQuery.timeChecked = false
        }
        // 通过
        if (!this.isNull(this.passInterTableData) && (this.passInterVisible == true)) {
          for (let i = 0; i < that.passInterTableData.length; i++) {
            let eleFaceMul2 = that.passInterTableData[i];
            that.$set(eleFaceMul2, 'timeChecked', that.comFaceQuery.timeChecked);
            that.$set(eleFaceMul2, 'Dtreachtime', that.comFaceQuery.Dtreachtime);
          }
        }
      },
      // 批量结算岗位
      comJsJobChange() {
        let that = this;
        // 通过
        if (!this.isNull(this.passInterTableData) && (this.passInterVisible == true)) {
          for (let i = 0; i < that.passInterTableData.length; i++) {
            let eleFaceMul2 = that.passInterTableData[i];
            that.$set(eleFaceMul2, 'StrJobNamejs', that.comFaceQuery.StrJobNamejs);
          }
        }
      },
      // 批量选择住宿需求
      reqHandle(val) {
        let that = this;
        // 待面试
        if (!this.isNull(this.surfaceTableData) && (this.surfaceVisible == true)) {
          for (let i = 0; i < that.surfaceTableData.length; i++) {
            let eleFaceMul = that.surfaceTableData[i];
            that.$set(eleFaceMul, 'StrAccomreq', that.comFaceQuery.StrAccomreq);
          }
        }
        // 通过
        if (!this.isNull(this.passInterTableData) && (this.passInterVisible == true)) {
          for (let i = 0; i < that.passInterTableData.length; i++) {
            let eleFaceMul2 = that.passInterTableData[i];
            that.$set(eleFaceMul2, 'StrAccomreq', that.comFaceQuery.StrAccomreq);
          }
        }
      },
      // 待面试输入备注
      comInputChange(val) {
        // console.log('备注', val)
        let that = this;
        // 待面试
        if (!this.isNull(this.surfaceTableData) && (this.surfaceVisible == true)) {
          for (let i = 0; i < that.surfaceTableData.length; i++) {
            let eleFaceMul = that.surfaceTableData[i];
            that.$set(eleFaceMul, 'StrRemark', that.comFaceQuery.comRemark);
          }
        }
        // 通过
        if (!this.isNull(this.passInterTableData) && (this.passInterVisible == true)) {
          for (let i = 0; i < that.passInterTableData.length; i++) {
            let eleFaceMul2 = that.passInterTableData[i];
            that.$set(eleFaceMul2, 'StrRemark', that.comFaceQuery.comRemark);
          }
        }
        // 不通过
        if (!this.isNull(this.failInterTableData) && (this.failInterVisible == true)) {
          for (let i = 0; i < this.failInterTableData.length; i++) {
            let eleFaceMul3 = that.failInterTableData[i];
            that.$set(eleFaceMul3, 'StrRemark', that.comFaceQuery.comRemark);
          }
        }
        // 未入职
        if (!this.isNull(this.unemployedTableData) && (this.unemployedVisible == true)) {
          for (let i = 0; i < this.unemployedTableData.length; i++) {
            let eleFaceMul4 = that.unemployedTableData[i];
            that.$set(eleFaceMul4, 'StrRemark', that.comFaceQuery.comRemark);
          }
        }
        // 终止
        if (!this.isNull(this.endProcessTableData) && (this.endProcessVisible == true)) {
          for (let i = 0; i < this.endProcessTableData.length; i++) {
            let eleFaceMul5 = that.endProcessTableData[i];
            that.$set(eleFaceMul5, 'StrRemark', that.comFaceQuery.comRemark);
          }
        }
      },
      // 获取搜索项目列表(除在离职)
      getSearchProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: localStorage.loginRoletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
            if (this.$route.query.objName != undefined && this.$route.query.objName) {
              let item = this.proNameList.find(e => e.StrprojectName == this.$route.query.objName)
              this.listQuery.projectid = item.Projectid;
            } else if (this.$route.query.projectid != undefined && this.$route.query.projectid) {
              this.listQuery.projectid = this.$route.query.projectid;
              let item = this.proNameList.find(e => e.Projectid == this.$route.query.projectid)
              this.listQuery.strProjectName = item.StrprojectName;
            }
          } else {
            this.proNameList = []
          }
        })
      },
      // 获取搜索项目列表(在离职)
      getSearchJobProList() {
        this.onworkQuery.roletype = localStorage.loginRoletype
        xz.getproListsonwork(this.onworkQuery).then(res => {
          // console.log('项目列表22', res)
          if (res.status == 'ok') {
            this.searchProJobList = res.msg
          } else {
            this.searchProJobList = []
          }
        })
      },
      // 保存修改面试时间
      saveInterviewHandle() {
        let that = this
        if (!this.isNull(this.interviewQuery.times)) {
          this.interviewQuery.Dtviewtime = this.interviewQuery.dates + ' ' + this.interviewQuery.times.split('-')[0]
        }
        // console.log(333,this.interviewQuery)
        this.$refs['interviewForm'].validate((valid) => {
          if (valid) {
            xz.updateDtreachtime(that.interviewQuery).then(res => {
              if (res.status == 'ok') {
                that.$message({
                  type: 'success',
                  message: '修改成功'
                })
                that.interviewVisible = false
                that.getList()
              } else {
                that.$message({
                  type: 'error',
                  message: '操作失败，请稍后再试'
                })
              }
            })
          }
        })
      },
      // 导入选择项目
      impProChange(val) {
        let that = this
        that.importSignQuery.jobid = ''
        if (!this.isNull(val)) {
          let obj = {};
          obj = this.proNameList.find((item) => {
            return item.Projectid === val;
          });
          // console.log('hh',val)
          this.importSignQuery.strprojectName = obj.StrprojectName
          this.stateInfoQuery.strobjname = obj.StrprojectName
          this.getresourcejobcategoryblist(obj.Projectid, 'import')
        } else {
          this.importSignQuery.strprojectName = ''
          this.importSignQuery.projectid = ''
          this.importPostList = []
          this.importSignQuery.jobid = ''
        }
      },
      // 获取导入岗位列表
      getImportPostList(projectid) {
        this.importPostList = []
        if (!this.isNull(this.allPostList)) {
          for (let i = 0; i < this.allPostList.length; i++) {
            let element07 = this.allPostList[i];
            if (element07.Projectid == projectid) {
              this.importPostList.push({
                Id: element07.Id,
                CustomerJobName: element07.CustomerJobName
              })
            }
          }
        }
      },
      // 导入选择岗位
      impPostChange(val) {
        let that = this
        if (!this.isNull(val)) {
          let obj = {};
          obj = this.impJobList.find((item) => {
            return item.Id === val;
          });
          this.importSignQuery.customerJobName = obj.CustomerJobName
        } else {
          this.importSignQuery.customerJobName = ''
          this.importSignQuery.jobid = ''
        }
      },
      //下载模板
      downLoadHandle() {
        let that = this;
        xz.getImportModeUrl(this.downSignQuery.tableid, this.importSignQuery.fileid).then(res => {
          // console.log('下载模板', res)
          if (res.status == 'ok') {
            if (that.importSignQuery.tabName == '批量导入待面试模板') {
              that.isFaceDownload = true;
              window.localStorage.setItem('isFaceDownload', new Date());
            }
            if (that.importSignQuery.tabName == '批量导入待入职模板') {
              that.isPendingEntryDownload = true;
              window.localStorage.setItem('isPendingEntryDownload', new Date());
            }
            if (that.importSignQuery.tabName == '批量导入离职模板') {
              that.isDepartDownload = true;
              window.localStorage.setItem('isDepartDownload', new Date());
            }
            if (that.importSignQuery.tabName == '批量入职模板（简易）') {
              that.isJobDownload = true;
              window.localStorage.setItem('isJobDownload', new Date());
            }
            let d = res.msg.data.StrOutPath
            d = d.replace("\"", "").replace("\"", "")
            var path = that.tablePath + d
            let aTag = document.createElement('a')
            aTag.href = path
            aTag.download = this.importSignQuery.tabName + '.xlsx';
            aTag.click();
          }
        })
      },
      downLoadHandle2() {
        let that = this;
        xz.getImportModeUrl(this.downSignQuery.tableid, this.importSignQuery.fileid).then(res => {
          if (res.status == 'ok') {
            if (that.importSignQuery.tabName == '批量导入待入职模板') {
              that.isPendingEntryDownload = true;
              window.localStorage.setItem('isPendingEntryDownload', new Date());
            }
            if (that.importSignQuery.tabName == '批量入职模板（简易）') {
              that.isJobDownload = true;
              window.localStorage.setItem('isJobDownload', new Date());
            }
            let d = res.msg.data.StrOutExcel
            d = d.replace("\"", "").replace("\"", "")
            var path = that.tablePath + d
            let aTag = document.createElement('a')
            aTag.href = path
            aTag.download = '电子签商保一体化模板.xlsx';
            aTag.click();
          }
        })
      },
      calDaysBetween(date) {
        let startDate = Date.parse(date);
        let endDate = Date.now();

        // 检查日期是否合法
        if (isNaN(startDate)) {
          console.warn('Invalid date input:', date);
          return;
        }

        const days = (endDate - startDate) / (24 * 60 * 60 * 1000);

        const tabMapping = {
          '批量导入待面试模板': 'isFaceDownload',
          '批量导入待入职模板': 'isPendingEntryDownload',
          '批量导入离职模板': 'isDepartDownload',
          '批量入职模板（简易）': 'isJobDownload'
        };

        const tabName = this.importSignQuery.tabName;
        const flagKey = tabMapping[tabName];

        if (flagKey !== undefined) {
          this[flagKey] = days <= 7;
        }
      },
      //下一步导入
      nextSteps() {
        let that = this
        if (this.importActive == 0) {
          if (this.isNull(this.importSignQuery.projectid)) {
            this.$message({
              message: "请选择项目",
              type: "warning",
              duration: 2000
            });
            return false
          }
          if (that.importSignQuery.jobid == '') {
            that.importSignQuery.jobid = 0
          }
          // console.log('22222',that.importSignQuery.jobid)
          if (this.importSignQuery.tabName == '批量导入待面试模板') {
            if (!that.isFaceDownload) {
              that.$message({
                message: "请先下载导入模板，下一步导入请使用新的模板导入",
                type: "warning",
                duration: 5000
              });
              return false
            }
            this.importActive += 1
          }
          if (this.importSignQuery.tabName == '批量导入待入职模板') {
            if (!that.isPendingEntryDownload) {
              that.$message({
                message: "请先下载导入模板，下一步导入请使用新的模板导入",
                type: "warning",
                duration: 5000
              });
              return false
            }
            this.importActive += 1
          }
          if (this.importSignQuery.tabName == '批量导入离职模板') {
            if (!that.isDepartDownload) {
              that.$message({
                message: "请先下载导入模板，下一步导入请使用新的模板导入",
                type: "warning",
                duration: 5000
              });
              return false
            }
            this.importActive += 1
          }
          if (this.importSignQuery.tabName == '批量入职模板（简易）') {
            if (!that.isJobDownload) {
              that.$message({
                message: "请先下载导入模板，下一步导入请使用新的模板导入",
                type: "warning",
                duration: 5000
              });
              return false
            }
            that.queryImportState()
          }
        }
      },
      //上一步导入
      prevSteps() {
        this.importActive -= 1
      },
      //提交导入
      async lastSteps() {
        if (this.ExcelSrc.value == '') {
          this.isUploadSuccess = true
          this.$message({
            message: "请选择文件上传",
            type: "warning"
          });
          this.importActive = 1
          return false
        } else {
          //检查表头是否正确
          let checkData = {
            excelpath: this.excelpath,
            tableid: this.importSignQuery.tableid,
            fileid: this.importSignQuery.fileid
          }
          // console.log('checkData', checkData)
          this.fullscreenLoading = true;
          xz.chkPsnTableForm(checkData).then(res => {
            // console.log('checkData',res)
            let resultTxt = res.msg
            if (this.isNull(res.msg)) {
              this.isError = false
              this.isUploadSuccess = false
              let Edata = {
                instname: '',
                strState: this.importStrState, //状态
                tableid: this.importSignQuery.tableid,
                // impexcel:"简历导入表",
                reimp: this.reimp,
                excelpath: this.excelpath,
                impexcel: this.ExcelSrc.fileName,
                servusrname: '', // 负责客服
                servcentname: '', // 服务中心
                custname: '', // 客户简称
                fileid: this.importSignQuery.fileid,
                projectid: this.importSignQuery.projectid,
                strprojectName: this.importSignQuery.strprojectName, //选择的项目名称
                jobid: this.importSignQuery.jobid, //选择的岗位
                customerJobName: this.importSignQuery.customerJobName, //岗位名称
                roletype: localStorage.loginRoletype
                // IsRPAImport:'1'
              }
              xz.psnAnlysisExcelInfstatus(Edata).then(res => {
                // console.log('Edata', res)
                if (res.status == 'ok') {
                  this.importActive = 2
                } else {
                  this.$message('导入错误');
                }
                this.fullscreenLoading = false;
                // this.isUploadSuccess = true
              })
            } else {
              this.isError = true
              this.importActive = 1
              this.isUploadSuccess = true
              this.errorTxt = resultTxt
              //导入操作，如果第一次导入某个文件会触发导入操作，但是第二次导入重复该文件，不会触发操作
              //清空input file值
              let file = document.getElementById("fileInput");
              file.value = '';
              this.fullscreenLoading = false;
            }
          })
        }
      },
      // 查看导入结果
      resultHandle() {
        let act;
        if (this.importSignQuery.tabName == '批量导入待面试模板' || this.importSignQuery.tabName == '批量导入入职模板') {
          act = 'second';
        }
        if (this.importSignQuery.tabName == '批量导入离职模板') {
          act = 'four';
        }
        if (this.importSignQuery.tabName == '批量入职模板（简易）') {
          act = 'third';
        }
        this.$router.push({
          path: "/resImportList",
          query: {
            active: '导入导出记录',
            activeTab: act
          }
        })
      },
      //导入-确认返回
      backHandle() {
        this.importVisible = false
        this.listQuery.currpage = 1
        this.getList()
      },
      //查询导入状态(在职导入)
      queryImportState() {
        let that = this
        xz.getPsnImpDataList(this.stateInfoQuery).then((res) => {
          if (res) {
            if (res.msg && res.msg.data.length > 0) {
              let results = res.msg.data
              let opTime = results[0].DtImpDate.replace('T', ' ');
              if ((new Date().getTime() > new Date((new Date(opTime)).valueOf() + 360000).getTime()) || results[0].StrImpEdateStr == '100') {
                that.importActive += 1
              } else {
                this.$message({
                  message: '您有一条正在导入的记录，请在导入完成后再导入',
                  duration: 5000,
                  type: 'warning'
                })
              }
            } else {
              that.importActive += 1
            }
          } else {
            this.$message.error("系统出错，请联系管理员");
          }
        })
      },
      //文件读取
      async importf() {
        let fileInput = this.$refs.upload;
        this.excelpath = ''
        FUN.returnExcelSrc(fileInput).then(src => {
          if (src) {
            // console.log('src0o0', src)
            this.isFileSuccess = true
            this.$set(this.ExcelSrc, "value", src.src);
            this.$set(this.ExcelSrc, "check", false);
            this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
            // console.log('srccc', this.ExcelSrc)
            //上传excel
            let excelFile = FUN.base64ToFile(this.ExcelSrc.value, this.ExcelSrc.fileName);
            let formData = new FormData();
            formData.append("pagename", 'empexcel');
            formData.append("action", 'save');
            formData.append("userid", Cookies.get("userid-b"));
            formData.append("entid", Cookies.get("userid-b"));
            formData.append("excel", excelFile, this.ExcelSrc.fileName);
            // console.log('formData', formData)
            xz.uploadCert(formData).then(res => {
              // console.log('formData', res)
              if (this.isNull(res) || res == false) {
                this.$message('上传Excel失败!')
                this.isUploadSuccess = true
              } else {
                this.errorTxt = ''
                this.excelpath = res;
                this.isUploadSuccess = false
              }
            });
          } else {
            this.$message('上传Excel失败!')
          }
        })
      },
      //列表是黑名单字体变红
      tableRowClassName({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        // console.log( row, column, rowIndex, columnIndex)
        if (row.StrIsBlack == "是") {
          return 'choose-row';
        }
      },
      // 获取弹框岗位约面日期
      getSurfaceDialogDate(jobid) {
        let nowdate = moment().format("YYYY-MM-DD HH:mm");
        let endDate = moment().add(1, 'months').format("YYYY-MM-DD HH:mm");
        let viewTimeQuery = {
          interviewStartTime: nowdate,
          interviewEndTime: endDate
        }
        xz.getjobdateappoint(jobid, viewTimeQuery).then(res => {
          // console.log('gettemplatelist', res)
          if (res.status == 'ok') {
            this.dialogDateList = res.data
          } else {
            this.dialogDateList = []
          }
        })
      },
      // 获取岗位约面日期
      getSurfaceDate(jobid) {
        let nowdate = moment().format("YYYY-MM-DD HH:mm");
        let endDate = moment().add(1, 'months').format("YYYY-MM-DD HH:mm");
        let viewTimeQuery = {
          interviewStartTime: nowdate,
          interviewEndTime: endDate
        }
        xz.getjobdateappoint(jobid, viewTimeQuery).then(res => {
          // console.log('gettemplatelist', res)
          if (res.status == 'ok') {
            this.viewDateList = res.data
          } else {
            this.viewDateList = []
          }
        })
      },
      // 获取岗位约面时间
      getSurfaceTime(jobid, time) {
        let viewTimeQuery = {
          interviewTime: time
        }
        xz.getjobappointtime(jobid, viewTimeQuery).then(res => {
          // console.log('gettemplatelist', res)
          if (res.status == 'ok') {
            this.viewTimesList = res.data
          } else {
            this.viewTimesList = []
          }
        })
      },
      proQrChange(val) {
        this.getresourcejobcategoryblist(val, 'search')
      },
      // 判断在职天数是否是负数
      isMinus(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || Number(o) < 0
      },
      // 招聘渠道社招人员选择
      faceSzMemberChange(value) {
        let obj = {};
        let that = this
        if (!this.isNull(value)) {
          obj = that.memberList.find((item) => {
            return item.Username === value;
          });
          that.depNameVal = obj.Strorganname
        } else {
          that.depNameVal = ''
        }
        // console.log('ff',obj)
      },
      // 招聘渠道公司渠道人员选择
      faceMemberChange(value) {
        let obj = {};
        let that = this
        if (!this.isNull(value)) {
          obj = that.memberList.find((item) => {
            return item.Username === value;
          });
          that.checkQuery.Gsqd = obj.Strorganname
        } else {
          that.checkQuery.Gsqd = ''
        }
        // console.log('ff',obj)
      },
      // 招聘渠道选择
      qudaoChange(val) {
        // console.log('val',val)
        this.szMember = ''
        this.depNameVal = ''
        this.checkQuery.Sctjr = ''
        this.checkQuery.Gsqd = ''
        this.checkQuery.Gsqdtjr = ''
        this.checkQuery.Wbqd = ''
        this.checkQuery.Wbqdtjr = ''
        this.njMember = ''
        this.checkQuery.Qtqk = ''
        this.dedpartNameList = []
      },
      // handleDepFaceChange(value){
      //   // console.log(value)
      //   if(this.isNull(value)){
      //       this.dedpartNameList = []
      //       this.checkQuery.Gsqd = ''
      //       this.checkQuery.Gsqdtjr = ''
      //       this.checkQuery.Sctjr = ''
      //       this.szMember = ''
      //       this.depNameVal = ''
      //   }else{
      //       this.szMember = ''
      //       this.checkQuery.Gsqdtjr = ''
      //       const checkedNode01 = this.$refs["deSectionArr"].panel.getNodeByValue(this.dedpartNameList);
      //       // console.log('checkedNode01',checkedNode01)
      //       let labels = checkedNode01.pathLabels;
      //       if(this.checkQuery.qudao == '社招'){
      //           this.depNameVal = labels[Number(labels.length)-1]
      //       }else{
      //           this.checkQuery.Gsqd = labels[Number(labels.length)-1]
      //       }
      //       let strorgancode = value[Number(value.length)-1]
      //       this.getauthUserInfoByorgancode(strorgancode)
      //   }
      // },
      // 获取部门列表
      getFaceDepartList() {
        this.dedpartNameList = []
        xz.getorganstr('', '0383e791-72fd-4edc-aa70-2bcadminuser', {
          strIsDisable: ''
        }).then(res => {
          // console.log('部门', res)
          if (res.status == 'ok') {
            if (res.msg && res.msg.parent) {
              this.faceDepartList = res.msg.parent[0].children
            }
          } else {
            this.faceDepartList = []
          }
        });
      },
      // 入职登记
      enrollHandle() {
        this.$router.push({
          name: 'enrollRegist'
        })
      },
      dtTimeChange(row) {
        // console.log('ll',row)
        if (row.timeChecked) {
          row.Dtreachtime = ''
        }
      },
      // 判断是否在面试时间一小时之前
      isRangeHandle(row, item) {
        // 前一小时
        let beforeHour = moment(row.Dtviewtime).subtract(1, "hours").format("YYYY-MM-DD HH:mm")
        let date = moment().format("YYYY-MM-DD HH:mm")
        // console.log(1111,beforeHour,date)
        return (new Date(beforeHour).getTime() > new Date(date).getTime()) || (new Date(beforeHour).getTime() === new Date(date).getTime())
      },
      editViewtime(item) {
        this.interviewVisible = true
        this.interviewQuery.GdststusId = item.GdststusId
        this.interviewQuery.dates = ''
        this.interviewQuery.times = ''
        this.viewJobId = item.Jobid
        this.getSurfaceDialogDate(item.Jobid)
      },
      editDtreachtime(row) {
        this.dtreachVisible = true
        if (this.activeName == '待入职') {
          this.dtreachQuery.GdststusId = row.GdststusId
        }
      },
      // 修改到岗时间
      saveDtreachHandle() {
        this.$refs['dtreachForm'].validate((valid) => {
          if (valid) {
            xz.updateDtreachtime(this.dtreachQuery).then(res => {
              if (res.status == 'ok') {
                this.$message({
                  type: 'success',
                  message: '修改成功'
                })
                this.dtreachVisible = false
                this.getList()
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败，请稍后再试'
                })
              }
            })
          }
        })
      },
      // 约面选择项目
      surProChange(item) {
        // 匹配对于项目id的项目名称
        let selectedName = {};
        // 获取岗位列表
        let postArr = []
        this.$set(item, 'Jobid', '');
        this.$set(item, 'JobName', '');
        this.$set(item, 'appDtviewDate', '');
        this.$set(item, 'appDtviewTime', '');
        this.$set(item, 'viewDateList', []);
        this.$set(item, 'viewTimesList', []);
        this.$set(item, 'Dtviewtime', '');
        this.$set(item, 'StrNeedAmount', '');
        this.$set(item, 'Strremind', '');
        if (this.activeName == '异常') {
          if (item.Projectid != item.prevProjectid) {
            this.$set(item, 'StrSource', '');
            this.$set(item, 'Recruitdep', '');
            this.$set(item, 'Recruitname', '');
          }
        }
        if (!this.isNull(item.Projectid)) {
          selectedName = this.resProjectList.find((res) => {
            return item.Projectid == res.Projectid;
          });
          // console.log('333',item,selectedName)
          this.$set(item, 'ProjectidnewName', selectedName.StrprojectName);
          this.$set(item, 'Projectid', selectedName.Projectid);
          this.$set(item, 'ProjectName', selectedName.StrprojectName);
          if (!this.isNull(this.allPostList)) {
            for (let k = 0; k < this.allPostList.length; k++) {
              let element07 = this.allPostList[k];
              if (element07.Projectid == selectedName.Projectid) {
                postArr.push({
                  Id: element07.Id,
                  JobCategory: element07.CustomerJobName
                })
              }
            }
            this.$set(item, 'resPostList', postArr);
          }
        }
        // this.getPostList(item.Projectid);
      },
      changePro() {
        if (!this.isNull(this.allPostList)) {
          let postArr = [];
          for (let k = 0; k < this.allPostList.length; k++) {
            let element07 = this.allPostList[k];
            if (element07.Projectid == this.cInfo.projectId) {
              postArr.push({
                Id: element07.Id,
                JobCategory: element07.CustomerJobName
              })
            }
          }
          this.jobList = postArr
        }
      },
      //根据targetName查询该节点和所有父级节点 回显el-cascader组件的值
      getParentsById(list, targetName) {
        for (let i in list) {
          if (list[i].strorganname === targetName) {
            //查询到就返回该数组对象
            return [list[i]]
          }
          if (list[i].children) {
            let node = this.getParentsById(list[i].children, targetName)
            if (node !== undefined) {
              //查询到把父节点连起来
              return node.concat(list[i])
            }
          }
        }
      },
      // 到面选择岗位
      tofacePostHandle() {
        this.szMember = ''
        this.depNameVal = ''
        this.checkQuery.Sctjr = ''
        this.checkQuery.Gsqd = ''
        this.checkQuery.Gsqdtjr = ''
        this.checkQuery.Wbqd = ''
        this.checkQuery.Wbqdtjr = ''
        this.njMember = ''
        this.checkQuery.Qtqk = ''
        this.dedpartNameList = []
        let checkList = [{
          resumeId: this.isNullNotZero(this.checkQuery.ResumeId) ? '0' : this.checkQuery.ResumeId, // 简历id
          projectid: this.checkQuery.Projectid, // 项目id
          jobid: this.checkQuery.Jobid
        }];
        // 判断约面超额
        xz.getresumestatuscheck('到面', checkList).then(res => {
          // console.log('checkList', res)
          if (res.status == 'ok') {
            if (!this.isNull(res.msg)) {
              this.tofaceNoteTxt01 = res.msg[0].StrNeedAmount;
              this.tofaceNoteTxt02 = res.msg[0].Strremind;
              this.checkQuery.qudao = res.msg[0].StrSourceqQD;
              this.checkQuery.StrIdCard = res.msg[0].StrIdCard;
              if (this.checkQuery.qudao == '社招') {
                this.szMember = res.msg[0].Recruitname;
                this.depNameVal = res.msg[0].Recruitdep;
                this.checkQuery.Sctjr = res.msg[0].Recruitdep + '/' + res.msg[0].Recruitname
              } else if (this.checkQuery.qudao == '公司渠道') {
                this.checkQuery.Gsqd = res.msg[0].Recruitdep;
                this.checkQuery.Gsqdtjr = res.msg[0].Recruitname;
              } else if (this.checkQuery.qudao == '外部渠道') {
                this.checkQuery.Wbqd = res.msg[0].Recruitdep;
                this.checkQuery.Wbqdtjr = res.msg[0].Recruitname;
              } else if (this.checkQuery.qudao == '内荐') {
                let firstIndex = res.msg[0].Recruitname.indexOf('工');
                let lastIndex = res.msg[0].Recruitname.lastIndexOf('推');
                let startindex = Number(firstIndex) + 1;
                this.njMember = res.msg[0].Recruitname.substring(startindex, lastIndex);
                this.checkQuery.Qtqk = res.msg[0].Recruitname;
              } else if (this.checkQuery.qudao == '企业转移') {
                this.checkQuery.Qtqk = res.msg[0].StrSourceqQD;
              } else if (this.checkQuery.qudao == '独立招聘') {
                this.checkQuery.Qtqk = res.msg[0].StrSourceqQD;
              }
              // 部门回显
              // if(!this.isNull(res.msg[0].Recruitdep)){
              //     let posArrVal = this.getParentsById(
              //         this.faceDepartList,
              //         res.msg[0].Recruitdep
              //     );
              //     // console.log('posArrVal', posArrVal)
              //     if(posArrVal.length>1){
              //       for (let index = 0; index < posArrVal.length; index++) {
              //           let posEle01 = posArrVal[index];
              //           this.dedpartNameList.push(posEle01.strorgancode)
              //       }
              //       this.dedpartNameList = this.dedpartNameList.reverse()
              //     }else if(posArrVal.length==1){
              //         this.dedpartNameList = [posArrVal[0].strorgancode]
              //     }
              // }
              if (res.msg[0].Isopera == '0') {
                this.isTofaceAct = true
              } else {
                this.isTofaceAct = false
              }
            }
          }
        });
      },
      // 约面选择岗位
      surPostChange(item) {
        let selectedName = {};
        let that = this
        this.$set(item, 'appDtviewDate', '');
        this.$set(item, 'appDtviewTime', '');
        this.$set(item, 'Dtviewtime', '');
        this.$set(item, 'viewTimesList', []);
        this.$set(item, 'StrNeedAmount', '');
        this.$set(item, 'Strremind', '');
        if (that.activeName == '异常') {
          if (item.Jobid != item.prevJobid) { // 判断是否修改的是同一个岗位
            this.$set(item, 'StrSource', '');
            this.$set(item, 'Recruitdep', '');
            this.$set(item, 'Recruitname', '');
          }
        }
        if (!this.isNull(item.Jobid)) {
          selectedName = item.resPostList.find((res) => {
            return item.Jobid == res.Id;
          });
          this.$set(item, 'JobName', selectedName.JobCategory);
          this.$set(item, 'Jobid', selectedName.Id);
          let checkList = [{
            resumeId: this.isNullNotZero(item.ResumeId) ? '0' : item.ResumeId, // 简历id
            projectid: item.Projectid, // 项目id
            jobid: item.Jobid
          }];
          // 判断约面超额
          xz.getresumestatuscheck('约面', checkList).then(res => {
            // console.log('checkList', res)
            if (res.status == 'ok') {
              if (!this.isNull(res.msg)) {
                this.$set(item, 'StrNeedAmount', res.msg[0].StrNeedAmount);
                this.$set(item, 'Strremind', res.msg[0].Strremind);
                this.$set(item, 'Isopera', res.msg[0].Isopera);
              }
            }
          });
          // 根据岗位获取面试时间列表
          // if(this.activeName != '报名'){
          let nowdate = moment().format("YYYY-MM-DD HH:mm")
          let endDate = moment().add(1, 'months').format("YYYY-MM-DD HH:mm")
          let viewTimeQuery = {
            interviewStartTime: nowdate,
            interviewEndTime: endDate
          }
          xz.getjobdateappoint(selectedName.Id, viewTimeQuery).then(res => {
            // console.log('getTimeList', res)
            if (res.status == 'ok') {
              this.$set(item, 'viewDateList', res.data);
            }
          });
          // }
        }
      },
      diaSurdateChange(item) {
        this.$set(item, 'appDtviewTime', '');
        let viewTimeQuery = {
          interviewTime: item.appDtviewDate
        }
        if (!this.isNull(item.Jobid) && (!this.isNull(item.appDtviewDate))) {
          xz.getjobappointtime(item.Jobid, viewTimeQuery).then(res => {
            // console.log('getTimeList', res)
            if (res.status == 'ok') {
              this.$set(item, 'viewTimesList', res.data);
            }
          });
        }
      },
      // 根据面试日期获取面试时间
      diaSurdateChange01() {
        let viewTimeQuery = {
          interviewTime: this.interviewQuery.dates
        }
        let that = this
        if (!this.isNull(this.viewJobId) && (!this.isNull(this.interviewQuery.dates))) {
          xz.getjobappointtime(that.viewJobId, viewTimeQuery).then(res => {
            // console.log('getTimeList', res)
            if (res.status == 'ok') {
              this.dialogTimeList = res.data;
            }
          });
        }
      },
      // 子组件传值
      async currChange(value) {
        this.$store.commit("setResourceComTabsIsover", false);
        // console.log('currChange',value)
        this.activeName = value
        this.pageCrumb = value
        if (this.activeName == '报名') {
          this.listQuery.StrnowState = '已报名'
          this.titleQuery.ststus = '报名'
          this.getTableTitleLists()
        } else if (this.activeName == '已约面') {
          this.listQuery.StrnowState = '约面'
          this.titleQuery.ststus = '已约面'
          this.getTableTitleLists()
        } else if (this.activeName == '待面试') {
          this.listQuery.StrnowState = '待面试'
          this.titleQuery.ststus = '已约面'
          this.getTableTitleLists()
        } else if (this.activeName == '待入职') {
          this.listQuery.StrnowState = '待入职'
          this.titleQuery.ststus = '通过'
          this.getTableTitleLists()
        } else if (this.activeName == '在职') {
          this.listQuery.StrnowState = '入职'
          this.titleQuery.ststus = '在职'
          this.getTableTitleLists()
        } else if (this.activeName == '异常') {
          this.listQuery.StrnowState = '未到面,未通过,未入职'
          this.titleQuery.ststus = '异常'
          this.getTableTitleLists()
        } else if (this.activeName == '离职') {
          this.listQuery = {
            userid: Cookies.get("userid-b"),
            type: 2, //查询类型1：在职2：离职0：全量
            strEmpName: '',
            strIdCard: '',
            strPhoneNum: '',
            projectid: 0, //项目0:全部
            strOther: -1, //临时工-1：全部1：是0：否
            ageStart: -1, //年龄始-1:全部
            ageEnd: -1, //年龄止-1：全部
            expiration: 0, //到期提醒 0:全部 1:身份证到期 2:试用期到期 3:合同到期 4:16周岁以下 5:16~18周岁 6:退休男 7:退休女 8:65周岁以上 9:工伤纠纷
            strEduLv: [],
            dtEntryBdateStart: '', //用工之日始
            dtEntryBdateEnd: '', //用工之日止
            strContractType: [], //合同（协议）类型
            pushName: [],
            pushRemark: '',
            isEnrollment: -1, //是否参保-1：全部1：是0：否
            isSigning: -1, //是否签约-1：全部1：是0：否2:将到期
            dtDepartureDateStart: '',
            dtDepartureDateEnd: '',
            pagination: {
              page: 1,
              pageSize: 10,
              orders: []
            }
          }
          // this.listQuery.StrnowState = '离职'
          this.titleQuery.ststus = '离职'
          this.tableTitle = this.$store.state.EMP.tableTitle
          // this.getList()
        } else if (this.activeName == '待离职') {
          this.listQuery.StrnowState = '待离职'
          this.titleQuery.ststus = '待离职'
          this.getTableTitleLists()
        }
      },
      // 获取二维码
      getCode() {
        this.codeloading = true;
        this.canvasImg = '';
        this.canvasImg1 = '';
        this.canvasImg2 = '';
        if (this.activeName == '待面试' || this.activeName == '待入职') {
          let d = {
            projectid: this.qrProQuery.projectid,
            jobid: this.qrProQuery.strVal,
            H5url: this.activeName == '待面试' ? '/interviewApplication' : '/empApplication'
          }
          xz.GetProjectQRCode(d, this.loginRoleType).then(res => {
            if (res.status == 'ok') {
              let url = res.data;
              let base64 = url.toString()
              let byteCharacters = atob(
                base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
              )
              let byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              let byteArray = new Uint8Array(byteNumbers)
              let blob = new Blob([byteArray], {
                type: `application/pdf`
              })
              this.canvasImg2 = URL.createObjectURL(blob)
            } else {
              this.$message.error(res.msg)
            }
            this.codeloading = false
          })
        } else {
          if (this.activeName == '到面') {
            this.codeQuery = {
              Id: this.qrProQuery.strVal, // 岗位ID
              pagepath: 'pages/registerToFace/registerToFace', // 页面URL
              strLinkType: 'B'
            }
          } else if (this.activeName == '通过') {
            this.codeQuery = {
              Id: this.qrProQuery.strVal, // 岗位ID
              pagepath: 'pages/registerPass/registerPass', // 页面URL
              strLinkType: 'C'
            }
          } else {
            this.codeQuery = {
              Id: '', // 岗位ID
              pagepath: 'pages/enter/enter', // 页面URL
              strLinkType: 'D'
            }
          }
          xz.getapplyjoobqrcodegenerated(this.loginRoleType, this.codeQuery).then(res => {
            // console.log('eee', res)
            if (res.status == 'ok') {
              let result = res.data
              if (this.activeName == '到面') {
                this.canvasImg1 = this.imgPath + result
              } else if (this.activeName == '通过') {
                this.canvasImg2 = this.imgPath + result
              } else {
                this.canvasImg = this.imgPath + result
              }
            }
            this.codeloading = false
            // console.log('getStateLists', this.data.status)
          })
        }
      },
      cellStyle({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        // console.log(row, column, rowIndex, columnIndex, 'tablestyle')
        if (column.label === '黑名单标签') {
          // let cellStyle = {}
          if (!this.isNull(row.StrBlackReason)) {
            return {
              color: '#F56C6C'
            }
          } else {
            return {
              background: '#fff',
              color: '#606266'
            }
          }
        }
      },
      // 入职
      entryHandle(row, type) {
        const routerUrl = this.$router.resolve({
          path: "/rosterEmpEdit",
          query: {
            gdststusID: row.GdststusId,
            type: 'entry'
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      entryAgain(row) {
        const routerUrl = this.$router.resolve({
          path: "/rosterEmpEdit",
          query: {
            strExcelPath: row.StrExcelPath,
            intExcelLine: row.IntExcelLine,
            type: 'entryAgain'
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      //补充 项目和岗位信息
      completionInfo(row) {
        this.StrUserName = row.StrUserName;
        this.cInfo = {
          gdststusID: row.GdststusId,
          jobId: '',
          projectId: ''
        }
        this.showCompletionInfo = true;
      },
      confirmCompletionInfo() {
        this.insLoading = true;
        xz.EditEmpProJob(this.cInfo).then(res => {
          if (res.status == 'ok') {
            this.insLoading = false;
            this.$message.success('保存成功');
            this.showCompletionInfo = false;
            this.getList();
          } else {
            this.insLoading = false;
            this.$message.error(res.msg);
            this.showCompletionInfo = false;
            this.getList();
          }
        })
      },
      // 约面弹框
      surDialogHandle() {
        let that = this
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择要待面试的数据'
          })
          return false;
        } else {
          this.surfaceVisible = true
          this.comFaceQuery = this.$options.data.call(this).comFaceQuery
          if (this.activeName != '异常') {
            this.getresumestatuscheck('约面', 'surface')
          } else {
            this.surfaceTableData = JSON.parse(JSON.stringify(that.multipleSelection))
            let nowdate = moment().format("YYYY-MM-DD HH:mm")
            let endDate = moment().add(1, 'months').format("YYYY-MM-DD HH:mm")
            let viewTimeQuery = {
              interviewStartTime: nowdate,
              interviewEndTime: endDate
            }
            if (!this.isNull(this.surfaceTableData)) {
              for (let i = 0; i < this.surfaceTableData.length; i++) {
                const eleFaceMul = this.surfaceTableData[i];
                let postArr = []
                // this.getPostList(eleFace01.Projectid);
                if (this.activeName != '报名') {
                  if (!this.isNull(this.allPostList)) {
                    for (let k = 0; k < this.allPostList.length; k++) {
                      let element07 = this.allPostList[k];
                      if (element07.Projectid == eleFaceMul.Projectid) {
                        postArr.push({
                          Id: element07.Id,
                          JobCategory: element07.CustomerJobName
                        })
                      }
                    }
                    this.$set(eleFaceMul, 'resPostList', postArr);
                  }
                  // 终止的项目和岗位不显示
                  let objPro1 = that.resProjectList.findIndex((v) => (v.Projectid === eleFaceMul.Projectid));
                  if (objPro1 == -1) {
                    // console.log("不存在");
                    this.$set(eleFaceMul, 'Projectid', '');
                    // this.$set(eleFace01, 'Strremind', '');
                    this.$set(eleFaceMul, 'StrNeedAmount', '');
                  }
                  if (!this.isNull(eleFaceMul.resPostList)) {
                    let objPro2 = eleFaceMul.resPostList.findIndex((v) => (v.Id === eleFaceMul.Jobid));
                    if (objPro2 == -1) {
                      // console.log("不存在");
                      this.$set(eleFaceMul, 'Jobid', '');
                      // this.$set(eleFace01, 'Strremind', '');
                      this.$set(eleFaceMul, 'StrNeedAmount', '');
                    }
                  } else {
                    this.$set(eleFaceMul, 'Jobid', '');
                    this.$set(eleFaceMul, 'Strremind', '');
                    this.$set(eleFaceMul, 'StrNeedAmount', '');
                  }
                } // 根据岗位获取面试时间列表
                if (!this.isNull(eleFaceMul.Jobid)) {
                  xz.getjobdateappoint(eleFaceMul.Jobid, viewTimeQuery).then(res => {
                    // console.log('getTimeList2', res)
                    if (res.status == 'ok') {
                      this.$set(eleFaceMul, 'viewDateList', res.data);
                    }
                  });
                }
                this.$set(eleFaceMul, 'prevProjectid', eleFaceMul.Projectid);
                this.$set(eleFaceMul, 'prevJobid', eleFaceMul.Jobid);
              }
            }
            // console.log('uu',this.surfaceTableData,this.multipleSelection)
          }
        }
      },
      quitTimeChange(val, time) {
        // console.log('44',time)
        if (this.isNull(val)) {
          time = ''
        }
      },
      // 确定约面
      saveSurfaceHandle() {
        let resList = []
        let resNonList = []
        let resNonFilterList = []
        let that = this
        if (!this.isNull(this.surfaceTableData)) {
          // 判断是否存在不能约面的数据
          // if(this.activeName != '异常'){
          if (that.surfaceTableData.some(v => v.Isopera == 1)) {
            this.$message({
              type: 'warning',
              message: '存在不能约面的数据,不能操作,请查看提醒确认'
            })
            return false;
          }
          // }
          if (that.surfaceTableData.some(val => this.isNull(val.Projectid))) {
            this.$message({
              type: 'warning',
              message: '请选择项目'
            })
            return false
          }
          if (that.surfaceTableData.some(val => this.isNull(val.Jobid))) {
            this.$message({
              type: 'warning',
              message: '请选择岗位'
            })
            return false
          }
          if (that.surfaceTableData.some(val => this.isNull(val.appDtviewDate))) {
            this.$message({
              type: 'warning',
              message: '请选择面试日期'
            })
            return false
          }
          if (that.surfaceTableData.some(val => this.isNull(val.appDtviewTime))) {
            this.$message({
              type: 'warning',
              message: '请选择面试时间'
            })
            return false
          }
          for (let i = 0; i < this.surfaceTableData.length; i++) {
            const surEle = this.surfaceTableData[i];
            if (this.activeName == '异常') {
              resList.push({
                Jobid: surEle.Jobid, //岗位id
                Projectid: surEle.Projectid, //项目id
                ResumeId: surEle.ResumeId, //简历ID
                StrState: '约面', //当前状态
                StrRemark: surEle.StrRemark, //否决原因 离职原因等
                Dtviewtime: (!this.isNull(surEle.appDtviewDate) && !this.isNull(surEle.appDtviewTime)) ? (surEle.appDtviewDate + ' ' + surEle.appDtviewTime.split('-')[0]) : '', //面试时间
                Strviewadd: surEle.InterviewAddress, //面试地址
                Dtreachtime: surEle.Dtreachtime == '未确定' ? '1900-01-01' : surEle.Dtreachtime, //预计到岗时间
                DtInducttime: '', //入职时间
                StrIsphysical: '', //是否体检
                Strphysicalhos: '', //体检医院
                Dtquittime: '', //离职时间
                Strquittype: '', //离职类型
                Sctjr: surEle.StrSource == '社招' ? (surEle.Recruitdep + '/' + surEle.Recruitname) : '',
                Gsqd: surEle.StrSource == '公司渠道' ? (surEle.Recruitdep) : '',
                Gsqdtjr: surEle.StrSource == '公司渠道' ? (surEle.Recruitname) : '',
                Wbqd: surEle.StrSource == '外部渠道' ? (surEle.Recruitdep) : '',
                Wbqdtjr: surEle.StrSource == '外部渠道' ? (surEle.Recruitname) : '',
                Qtqk: (surEle.StrSource == '内荐') ? surEle.Recruitname : ((surEle.StrSource == '企业转移' || surEle.StrSource == '独立招聘') ? surEle.StrSource : ''),
                StrIsBlack: surEle.StrIsBlack ? surEle.StrIsBlack : '否', //是否黑名单
                StrBlacklabel: !this.isNull(surEle.StrBlackReason) ? surEle.StrBlackReason : '', //黑名单标签
                StrAccomreq: !this.isNull(surEle.StrAccomreq) ? surEle.StrAccomreq : '', //住宿需求
                StrIdCard: !this.isNull(surEle.StrIdCard) ? surEle.StrIdCard : '' //身份证号码
              })
            } else {
              resList.push({
                Jobid: surEle.Jobid, //岗位id
                Projectid: surEle.Projectid, //项目id
                ResumeId: surEle.ResumeId, //简历ID
                StrState: '约面', //当前状态
                StrRemark: surEle.StrRemark, //否决原因 离职原因等
                Dtviewtime: (!this.isNull(surEle.appDtviewDate) && !this.isNull(surEle.appDtviewTime)) ? (surEle.appDtviewDate + ' ' + surEle.appDtviewTime.split('-')[0]) : '', //面试时间
                Strviewadd: surEle.InterviewAddress, //面试地址
                Dtreachtime: surEle.Dtreachtime == '未确定' ? '1900-01-01' : surEle.Dtreachtime, //预计到岗时间
                DtInducttime: '', //入职时间
                StrIsphysical: '', //是否体检
                Strphysicalhos: '', //体检医院
                Dtquittime: '', //离职时间
                Strquittype: '', //离职类型
                gdststusID: surEle.gdststusID,
                StrIsBlack: surEle.StrIsBlack ? surEle.StrIsBlack : '否', //是否黑名单
                StrBlacklabel: !this.isNull(surEle.StrBlackReason) ? surEle.StrBlackReason : '', //黑名单标签
                StrAccomreq: !this.isNull(surEle.StrAccomreq) ? surEle.StrAccomreq : '', //住宿需求
                StrIdCard: !this.isNull(surEle.StrIdCard) ? surEle.StrIdCard : '' //身份证号码
              })
            }
          }
          this.btnLoading01 = true
          // console.log('无空值，通过')  //false
          if (this.activeName == '异常' || this.activeName == '离职') {
            for (let i = 0; i < this.multipleSelection.length; i++) {
              let endEle01 = this.multipleSelection[i];
              resNonList.push({
                Jobid: endEle01.Jobid, //岗位id
                Projectid: endEle01.Projectid, //项目id
                ResumeId: endEle01.ResumeId, //简历ID
                GdststusId: endEle01.GdststusId,
                StrState: '终止', //当前状态
                StrRemark: endEle01.StrRemark, //否决原因 离职原因等
                Dtviewtime: '', //面试时间
                Strviewadd: '', //面试地址
                Dtreachtime: endEle01.Dtreachtime == '未确定' ? '1900-01-01' : endEle01.Dtreachtime, //预计到岗时间
                DtInducttime: '', //入职时间
                StrIsphysical: '', //是否体检
                Strphysicalhos: '', //体检医院
                Dtquittime: '', //离职时间
                Strquittype: '', //离职类型
                StrIsBlack: endEle01.StrIsBlack ? endEle01.StrIsBlack : '否', //是否黑名单
                StrBlacklabel: endEle01.StrBlackReason, //黑名单标签
                StrAccomreq: !this.isNull(endEle01.StrAccomreq) ? endEle01.StrAccomreq : '', //住宿需求
                StrIdCard: !this.isNull(endEle01.StrIdCard) ? endEle01.StrIdCard : '' //身份证号码
              });
            }
            let multipleSelectionList = JSON.parse(JSON.stringify(resNonList)) //拷贝
            if (this.activeName == '异常') {
              // 排除掉岗位未修改时的数据(异常状态下未修改的不用走终止接口)
              resNonFilterList = multipleSelectionList.filter(item => {
                return that.surfaceTableData.every((x) => x.Jobid != item.Jobid)
              });
            } else {
              resNonFilterList = resNonList
            }
            // console.log('eee',resNonFilterList)
            // console.log('non',resNonList,resList)
            if (!this.isNull(resNonFilterList)) {
              // 终止旧流程
              xz.saveProcessRecords(resNonFilterList).then(res => {
                if (res.status == 'ok') {
                  this.changeProcessRecord(resList, '约面')
                } else {
                  this.$message({
                    type: 'error',
                    message: res.msg
                  })
                }
              })
            } else {
              this.changeProcessRecord(resList, '约面')
            }
          } else {
            this.changeProcessRecord(resList, '约面')
          }
        } else {
          this.$message({
            type: 'warning',
            message: '没有要约面的数据'
          })
          return false
        }
        // console.log('ff',resList,this.surfaceTableData)
      },
      // 转岗
      changeTransRecord(query, type) {
        xz.transferEmpData(query).then(res => {
          // console.log('saveEnterHandle', res)
          if (res.status == 'ok') {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            if (type == '转岗') {
              this.transVisible = false
            }
            this.getList()
          } else {
            this.$message({
              type: 'error',
              message: '操作失败，请稍后再试'
            })
          }
        })
      },
      // 添加流程记录
      changeProcessRecord(query, type) {
        xz.saveProcessRecords(query).then(res => {
          // console.log('saveEnterHandle', res)
          if (res.status == 'ok') {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            if (type == '约面') {
              this.btnLoading01 = false
              this.surfaceVisible = false
            } else if (type == '放弃入职') {
              this.btnLoading02 = false
              this.abandonVisible = false
            } else if (type == '到面') {
              this.btnLoading03 = false
              this.tofaceVisible = false
            } else if (type == '未到面') {
              this.btnLoading04 = false
              this.revokeVisible = false
            } else if (type == '通过') {
              this.btnLoading05 = false
              this.passInterVisible = false
            } else if (type == '未通过') {
              this.btnLoading06 = false
              this.failInterVisible = false
            } else if (type == '终止') {
              this.btnLoading07 = false
              this.endProcessVisible = false
            } else if (type == '离职') {
              this.btnLoading08 = false
              this.quitVisible = false
            } else if (type == '未入职') {
              this.btnLoading09 = false
              this.unemployedVisible = false
            }
            this.getList()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      },
      // 放弃入职弹框
      abadonHandle() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择放弃入职的数据'
          })
          return false;
        } else {
          this.abandonTableData = this.multipleSelection
          this.abandonVisible = true
        }
      },
      // 确定放弃入职
      saveAbadonHandle() {
        let resList = []
        if (!this.isNull(this.abandonTableData)) {
          for (let i = 0; i < this.abandonTableData.length; i++) {
            const surAba = this.abandonTableData[i];
            resList.push({
              Jobid: surAba.Jobid, //岗位id
              Projectid: surAba.Projectid, //项目id
              ResumeId: surAba.ResumeId, //简历ID
              GdststusId: surAba.GdststusId,
              StrState: '未入职', //当前状态
              StrRemark: surAba.StrRemark, //否决原因 离职原因等
              Dtviewtime: '', //面试时间
              Strviewadd: '', //面试地址
              Dtreachtime: surAba.Dtreachtime == '未确定' ? '1900-01-01' : surAba.Dtreachtime, //预计到岗时间
              DtInducttime: '', //入职时间
              StrIsphysical: '', //是否体检
              Strphysicalhos: '', //体检医院
              Dtquittime: '', //离职时间
              Strquittype: '', //离职类型
              checked: surAba.checked,
              StrIsBlack: surAba.StrIsBlack ? surAba.StrIsBlack : '否', //是否黑名单
              StrBlacklabel: surAba.StrBlackReason, //黑名单标签
              StrAccomreq: !this.isNull(surAba.StrAccomreq) ? surAba.StrAccomreq : '', //住宿需求
              StrIdCard: !this.isNull(surAba.StrIdCard) ? surAba.StrIdCard : '' //身份证号码
            })
          }
          // console.log('resList',resList)
          if (resList.some(val => this.isNull(val.StrRemark))) {
            this.$message({
              type: 'warning',
              message: '请填写放弃原因'
            })
            return false
          } else {
            this.btnLoading02 = true
            // console.log('无空值，通过')  //false
            this.changeProcessRecord(resList, '放弃入职')
          }
        } else {
          this.$message({
            type: 'warning',
            message: '没有相应的数据'
          })
          return false
        }
      },
      // 定时任务(异常状态)
      regularTimeHandle() {
        this.$confirm('是否确定走定时任务?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          xz.taskPsnStatuszz().then(res => {
            if (res.status == 'ok') {
              this.$message({
                type: 'success',
                message: '操作成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: '操作失败'
              })
            }
          })
        }).catch(() => {
          console.log('已取消');
        });
      },
      // 登记弹框
      registHandle(type) {
        this.signDialogTitle = type
        // if(this.signDialogTitle == '约面登记'){
        //   this.registerRules = this.rules2
        // }else{
        //   this.registerRules = this.rules1
        // }
        this.$nextTick(e => {
          this.$refs['registForm'].resetFields();
        })
        // console.log('ff',this.$options.data())
        this.appointmentQuery = this.$options.data.call(this).appointmentQuery
        this.viewAddressList = []
        this.viewTimeList = []
        this.resPostList = []
        this.appointCityVal = ''
        this.faceNoteTxt01 = ''
        this.faceNoteTxt02 = ''
        this.phoneType01 = ''
        this.registVisible = true
        // 获取有权限的项目列表和岗位列表
        this.getResourceJoblist()
      },
      // 保存登记
      saveRegistHandle() {
        this.phoneType01 = 'save'
        let that = this
        // if(this.isNull(this.appointmentQuery.Belonguserid)){
        this.appointmentQuery.Belonguserid = Cookies.get("userid-b")
        // }
        if (this.isNullNotZero(this.appointmentQuery.ResumeId)) {
          this.appointmentQuery.ResumeId = '0'
        }
        if (this.signDialogTitle == '报名登记') {
          this.appointmentQuery.StrState = '已报名'
        }
        if (this.signDialogTitle == '约面登记') {
          this.appointmentQuery.StrState = '约面'
        }
        if (this.isFaceAct == false) { // 是否能约面报名登记
          return false;
        } else {
          if ((!this.isNull(this.appointmentQuery.appDtviewDate)) && !this.isNull(this.appointmentQuery.appDtviewTime)) {
            this.appointmentQuery.Dtviewtime = this.appointmentQuery.appDtviewDate + ' ' + this.appointmentQuery.appDtviewTime.split('-')[0]
          }
          // console.log('registQuery', this.appointmentQuery)
          that.$refs['registForm'].validate((valid) => {
            if (valid) {
              if (this.signDialogTitle == '约面登记') {
                let obj = {};
                obj = that.resProjectList.find((item) => {
                  return item.Projectid === that.appointmentQuery.Projectid;
                });
                let obj02 = {};
                obj02 = that.resPostList.find((item) => {
                  return item.Id === that.appointmentQuery.Jobid;
                });
                that.confirmQuery.StrprojectName = obj.StrprojectName
                that.confirmQuery.JobCategory = obj02.JobCategory
                that.confirmInfoVisible = true
              } else {
                that.btnLoading10 = true
                that.saveSigninfo(that.appointmentQuery)
              }
            } else {
              return false;
            }
          })
        }
      },
      // 取消确认约面登记
      infoCancelHandle() {
        this.confirmInfoVisible = false
      },
      // 确认约面登记
      saveInfoHandle() {
        // this.btnLoading10 = true
        this.saveSigninfo(this.appointmentQuery)
      },
      // 到面弹框
      tofaceHandle() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择到面的数据'
          })
          return false;
        } else {
          this.tofaceTableData = this.multipleSelection
          this.tofaceVisible = true
        }
      },
      // 确定到面
      saveTofaceHandle() {
        let resList = []
        let resNonList = []
        if (!this.isNull(this.tofaceTableData)) {
          for (let i = 0; i < this.tofaceTableData.length; i++) {
            const surFace = this.tofaceTableData[i];
            resList.push({
              Jobid: surFace.Jobid, //岗位id
              Projectid: surFace.Projectid, //项目id
              ResumeId: surFace.ResumeId, //简历ID
              GdststusId: surFace.GdststusId,
              StrState: '到面', //当前状态
              StrRemark: surFace.StrRemark, //否决原因 离职原因等
              Dtviewtime: surFace.Dtviewtime, //面试时间
              Dtfacetime: surFace.Dtfacetime, //到面时间
              Strviewadd: '', //面试地址
              Dtreachtime: surFace.Dtreachtime == '未确定' ? '1900-01-01' : surFace.Dtreachtime, //预计到岗时间
              DtInducttime: '', //入职时间
              StrIsphysical: '', //是否体检
              Strphysicalhos: '', //体检医院
              Dtquittime: '', //离职时间
              Strquittype: '', //离职类型
              checked: '',
              Sctjr: surFace.StrSource == '社招' ? (surFace.Recruitdep + '/' + surFace.Recruitname) : '',
              Gsqd: surFace.StrSource == '公司渠道' ? (surFace.Recruitdep) : '',
              Gsqdtjr: surFace.StrSource == '公司渠道' ? (surFace.Recruitname) : '',
              Wbqd: surFace.StrSource == '外部渠道' ? (surFace.Recruitdep) : '',
              Wbqdtjr: surFace.StrSource == '外部渠道' ? (surFace.Recruitname) : '',
              Qtqk: (surFace.StrSource == '内荐') ? surFace.Recruitname : ((surFace.StrSource == '企业转移' || surFace.StrSource == '独立招聘') ? surFace.StrSource : ''),
              StrIsBlack: surFace.StrIsBlack ? surFace.StrIsBlack : '否', //是否黑名单
              StrBlacklabel: !this.isNull(surFace.StrBlackReason) ? surFace.StrBlackReason : '', //黑名单标签
              StrAccomreq: !this.isNull(surFace.StrAccomreq) ? surFace.StrAccomreq : '', //住宿需求
              StrIdCard: !this.isNull(surFace.StrIdCard) ? surFace.StrIdCard : '' //身份证号码
            })
          }
          if (resList.some(val => this.isNull(val.Dtfacetime))) {
            this.$message({
              type: 'warning',
              message: '请选择到面时间'
            })
            return false
          } else {
            this.btnLoading03 = true
            if (this.activeName == '异常' || this.activeName == '离职') {
              // for (let i = 0; i < this.multipleSelection.length; i++) {
              //   let endEle01 = this.multipleSelection[i];
              //     resNonList.push({
              //       Jobid:endEle01.Jobid, //岗位id
              //       Projectid:endEle01.Projectid, //项目id
              //       ResumeId:endEle01.ResumeId,//简历ID
              //       StrState:'终止',//当前状态
              //       StrRemark:'',//否决原因 离职原因等
              //       Dtviewtime:'',//面试时间
              //       Strviewadd:'',//面试地址
              //       Dtreachtime:endEle01.Dtreachtime=='未确定'?'1900-01-01':endEle01.Dtreachtime,//预计到岗时间
              //       DtInducttime:'',//入职时间
              //       StrIsphysical:'',//是否体检
              //       Strphysicalhos:'',//体检医院
              //       Dtquittime:'',//离职时间
              //       Strquittype:'',//离职类型
              //       StrIsBlack:!this.isNull(endEle01.StrBlackReason)?'是':'否',//是否黑名单
              //       StrBlacklabel:endEle01.StrBlackReason,//黑名单标签
              //       StrIdCard:!this.isNull(endEle01.StrIdCard)?endEle01.StrIdCard:''//身份证号码
              //     });
              //     // console.log('non',resNonList)
              // }
              // 终止旧流程
              // xz.saveProcessRecords(resNonList).then(res => {
              //   if (res.status == 'ok') {
              this.changeProcessRecord(resList, '到面')
              //   }else{
              //     this.$message({ type: 'error', message: res.msg })
              //   }
              // })
            } else {
              this.changeProcessRecord(resList, '到面')
            }
          }
          // console.log('resList',resList)
        } else {
          this.$message({
            type: 'warning',
            message: '没有相应的数据'
          })
          return false
        }
      },
      // 取消约面
      revokeHandle(type) {
        this.revokeTxt = type
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择取消约面的数据'
          })
          return false;
        } else {
          this.revokeTableData = this.multipleSelection
          this.revokeVisible = true
        }
      },
      // 确定取消约面
      saveRevokeHandle() {
        let resList = []
        if (!this.isNull(this.revokeTableData)) {
          for (let i = 0; i < this.revokeTableData.length; i++) {
            const revokeEle = this.revokeTableData[i];
            resList.push({
              Jobid: revokeEle.Jobid, //岗位id
              Projectid: revokeEle.Projectid, //项目id
              ResumeId: revokeEle.ResumeId, //简历ID
              GdststusId: revokeEle.GdststusId,
              StrState: '未到面', //当前状态
              StrRemark: revokeEle.StrRemark, //否决原因 离职原因等
              Dtviewtime: '', //面试时间
              Strviewadd: '', //面试地址
              Dtreachtime: revokeEle.Dtreachtime == '未确定' ? '1900-01-01' : revokeEle.Dtreachtime, //预计到岗时间
              DtInducttime: '', //入职时间
              StrIsphysical: '', //是否体检
              Strphysicalhos: '', //体检医院
              Dtquittime: '', //离职时间
              Strquittype: '', //离职类型
              checked: revokeEle.checked,
              StrIsBlack: revokeEle.StrIsBlack ? revokeEle.StrIsBlack : '否', //是否黑名单
              StrBlacklabel: revokeEle.StrBlackReason, //黑名单标签
              StrAccomreq: !this.isNull(revokeEle.StrAccomreq) ? revokeEle.StrAccomreq : '', //住宿需求
              StrIdCard: !this.isNull(revokeEle.StrIdCard) ? revokeEle.StrIdCard : '' //身份证号码
            })
          }
          // console.log('resList',resList)
          if (resList.some(val => this.isNull(val.StrRemark))) {
            this.$message({
              type: 'warning',
              message: '请填写原因'
            })
            return false
          } else {
            this.btnLoading04 = true
            // console.log('无空值，通过')  //false
            this.changeProcessRecord(resList, '未到面')
          }
        } else {
          this.$message({
            type: 'warning',
            message: '没有相应的数据'
          })
          return false
        }
      },
      // 面试通过
      passInterviewHandle() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择面试通过的数据'
          })
          return false;
        } else {
          this.passInterTableData = this.multipleSelection
          for (let i = 0; i < this.passInterTableData.length; i++) {
            let passEle = this.passInterTableData[i];
            this.checkIdcard(passEle);
            this.$set(passEle, 'msgerror', '')
            this.$set(passEle, 'timeChecked', false);
            this.$set(passEle, 'Dtreachtime', '')
            this.$set(passEle, 'StrJobNamejs', '');
          }
          this.passInterVisible = true;
          this.btnLoading05 = false;
          this.comFaceQuery = this.$options.data.call(this).comFaceQuery
        }
      },
      //确认通过前的校验
      beforePass() {
        let arr = []
        if (!this.isNull(this.passInterTableData)) {
          if (this.passInterTableData.some(val => !val.judge)) {
            this.$message.error('有身份证未通过校验！')
            return false
          }
          for (let i = 0; i < this.passInterTableData.length; i++) {
            const row = this.passInterTableData[i];
            // 判断同一行内的 Dtreachtime为空 和 timeChecked为 false
            if (!row.timeChecked && (!row.Dtreachtime || row.Dtreachtime.trim() === '')) {
              this.$message.warning(`第 ${i + 1} 行数据：请选择预定到岗时间或勾选“未确定”`);
              return; // 中断执行
            }
          }
          this.btnLoading05 = true;
          for (let i = 0; i < this.passInterTableData.length; i++) {
            const passEle = this.passInterTableData[i];
            let d = {
              StrUserName: passEle.StrUserName,
              Projectid: passEle.Projectid,
              StrprojectName: passEle.StrprojectName,
              StrIdCard: passEle.StrIdCard
            }
            arr.push(d)
          }
          xz.checkDrzByidcard(arr, 'checkDrzByidcard').then(res => {
            if (res.status == 'ok') {
              try {
                if (res.msg.length > 0) {
                  let errList = [];
                  res.msg.forEach((item, index) => {
                    if (!this.isNull(item.msgerror)) {
                      errList.push(index + 1)
                    }
                    this.passInterTableData[index].msgerror = item.msgerror;
                    if (index == res.msg.length - 1) {
                      if (errList.length > 0) {

                        this.$message.error(`第${errList.toString()}行有报错不能提交，请修改或者删除后再提交！`)
                        this.btnLoading05 = false;
                      } else {
                        this.savePassHandle();
                      }
                    }
                  });
                }
              } catch (e) {
                console.log(e)
                this.$message.error('校验失败');
                this.btnLoading05 = false;
              }
            } else {
              this.$message.error(res.msg)
              this.btnLoading05 = false;
            }
          })

        } else {
          this.$message({
            type: 'warning',
            message: '没有相应的数据'
          })
          return false
        }
      },
      // 确认通过
      savePassHandle() {
        let resList = [];
        for (let i = 0; i < this.passInterTableData.length; i++) {
          const passEle = this.passInterTableData[i];
          resList.push({
            StrUserName: passEle.StrUserName,
            Jobid: passEle.Jobid, //岗位id
            Projectid: passEle.Projectid, //项目id
            ResumeId: passEle.ResumeId, //简历ID
            GdststusId: passEle.GdststusId,
            StrState: '通过', //当前状态
            StrRemark: passEle.StrRemark, //否决原因 离职原因等
            Dtviewtime: '', //面试时间
            Strviewadd: '', //面试地址
            Dtreachtime: passEle.timeChecked ? '1900-01-01' : passEle.Dtreachtime, //预计到岗时间
            DtInducttime: '', //入职时间
            StrIsphysical: passEle.checked ? '是' : '否', //是否体检
            Strphysicalhos: passEle.Strphysicalhos, //体检医院
            Dtquittime: '', //离职时间
            Strquittype: '', //离职类型,
            StrJobNamejs: passEle.StrJobNamejs ? passEle.StrJobNamejs : '', //结算岗位
            checked: passEle.checked,
            Sctjr: passEle.StrSource == '社招' ? (passEle.Recruitdep + '/' + passEle.Recruitname) : '',
            Gsqd: passEle.StrSource == '公司渠道' ? (passEle.Recruitdep) : '',
            Gsqdtjr: passEle.StrSource == '公司渠道' ? (passEle.Recruitname) : '',
            Wbqd: passEle.StrSource == '外部渠道' ? (passEle.Recruitdep) : '',
            Wbqdtjr: passEle.StrSource == '外部渠道' ? (passEle.Recruitname) : '',
            Qtqk: (passEle.StrSource == '内荐') ? passEle.Recruitname : ((passEle.StrSource == '企业转移' || passEle.StrSource == '独立招聘') ? passEle.StrSource : ''),
            timeChecked: passEle.timeChecked, //未确定到岗时间
            StrIsBlack: passEle.StrIsBlack ? passEle.StrIsBlack : '否', //是否黑名单
            StrBlacklabel: !this.isNull(passEle.StrBlackReason) ? passEle.StrBlackReason : '', //黑名单标签
            StrAccomreq: !this.isNull(passEle.StrAccomreq) ? passEle.StrAccomreq : '', //住宿需求
            StrIdCard: !this.isNull(passEle.StrIdCard) ? passEle.StrIdCard : '' //身份证号码
          })
        }
        this.changeProcessRecord(resList, '通过')
      },
      //批量入职
      batchEntry() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请至少选择一条'
          })
          return false;
        } else {
          this.passInterTableData = this.multipleSelection
          for (let i = 0; i < this.passInterTableData.length; i++) {
            let passEle = this.passInterTableData[i];
            this.checkIdcard(passEle);
            this.$set(passEle, 'msgerror', '');
            this.$set(passEle, 'DtEntryBdate', '')
            this.$set(passEle, 'StrBlCmp', '')
          }
          this.entryBatchData = {
            DtEntryBdate: '', //批量用工之日：
            StrWorkState: '',
            StrBlCmp: '', //开票公司
          }
          this.btnLoading05 = false;
          this.entryBatchVisible = true;
        }
      },
      //批量入职前的校验
      beforeEntry() {
        let arr = []
        if (!this.isNull(this.passInterTableData)) {
          if (this.passInterTableData.some(val => !val.judge)) {
            this.$message.error('有身份证未通过校验！')
            return false
          }
          if (this.passInterTableData.some(val => this.isNullDate(val.StrMobile))) {
            this.$message({
              type: 'warning',
              message: '请输入联系方式'
            })
            return false
          } else if (this.passInterTableData.some(val => this.isNullDate(val.DtEntryBdate))) {
            this.$message({
              type: 'warning',
              message: '请选择用工之日'
            })
            return false
          } else if (this.passInterTableData.some(val => this.isNullDate(val.StrWorkState))) {
            this.$message({
              type: 'warning',
              message: '请选择在/离职状态'
            })
            return false
          } else if (this.passInterTableData.some(val => this.isNullDate(val.StrBlCmp))) {
            this.$message({
              type: 'warning',
              message: '请选择开票公司'
            })
            return false
          } else if (this.passInterTableData.some(val => this.isNullDate(val.Recruitdep))) {
            this.$message({
              type: 'warning',
              message: '请选择推荐渠道'
            })
            return false
          } else {
            this.btnLoading05 = true;
            for (let i = 0; i < this.passInterTableData.length; i++) {
              const passEle = JSON.parse(JSON.stringify(this.passInterTableData[i]));
              let d = {
                GdststusId: passEle.GdststusId,
                StrUserName: passEle.StrUserName,
                Projectid: passEle.Projectid,
                StrprojectName: passEle.StrprojectName,
                StrIdCard: passEle.StrIdCard
              }
              arr.push(d)
            }
            xz.checkDrzByidcard(arr, 'getEmponworkcheck').then(res => {
              if (res.status == 'ok') {
                try {
                  if (res.msg.length > 0) {
                    let errList = [];
                    res.msg.forEach((item, index) => {
                      if (!this.isNull(item.msgerror)) {
                        errList.push(index + 1)
                      }
                      this.passInterTableData[index].msgerror = item.msgerror;
                      if (index == res.msg.length - 1) {
                        if (errList.length > 0) {
                          this.$message.error(`第${errList.toString()}行有报错不能提交，请修改或者删除后再提交！`)
                          this.btnLoading05 = false;
                        } else {
                          this.confirmBatchEntry();
                        }
                      }
                    });
                  }
                } catch (e) {
                  console.log(e)
                  this.$message.error('校验失败')
                }
              } else {
                this.$message.error(res.msg)
                this.btnLoading05 = false;
              }
            })
          }
        } else {
          this.$message({
            type: 'warning',
            message: '没有相应的数据'
          })
          return false
        }
      },
      confirmBatchEntry() {
        let arr = [];
        this.passInterTableData.forEach(e => {
          let d = {
            StrUserName: e.StrUserName,
            GdststusId: e.GdststusId,
            Projectid: e.Projectid, // 项目ID
            StrprojectName: e.StrprojectName, // 项目名称
            StrUserName: e.StrUserName, // 姓名
            StrIdCard: e.StrIdCard, // 身份证
            StrMobile: e.StrMobile, // 手机号
            CustomerJobName: e.CustomerJobName, // 岗位
            StrWorkState: e.StrWorkState, // 在职状态
            Recruitdep: e.Recruitdep, // 推荐渠道
            Recruitname: e.Recruitname, // 推荐渠道备注
            StrBlCmp: e.StrBlCmp, // 开票公司
            StrRemark: e.StrRemark, // 备注
            DtEntryBdate: e.DtEntryBdate
          };
          arr.push(d);
        });
        // console.log(arr)
        xz.AddEmponwork(arr).then(res => {
          if (res.status == 'ok') {
            this.$message.success('批量入职成功！');
            this.getList();
            this.entryBatchVisible = false;
            this.btnLoading05 = false;
          } else {
            this.btnLoading05 = false;
            this.$message.error(res.msg)
          }
        })
      },
      // 面试未通过
      failInterHandle() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择面试未通过的数据'
          })
          return false;
        } else {
          this.failInterTableData = JSON.parse(JSON.stringify(this.multipleSelection))
          this.failInterVisible = true
          this.reasonQuery.remark = ''
          this.comFaceQuery = this.$options.data.call(this).comFaceQuery
          this.failInterTableData.forEach(function (item) {
            this.$set(item, 'StrRemark', '不合格');
          }, this);
        }
      },
      // 确定未通过
      saveFailHandle() {
        let resList = []
        if (!this.isNull(this.failInterTableData)) {
          for (let i = 0; i < this.failInterTableData.length; i++) {
            const failEle = this.failInterTableData[i];
            resList.push({
              Jobid: failEle.Jobid, //岗位id
              Projectid: failEle.Projectid, //项目id
              ResumeId: failEle.ResumeId, //简历ID
              GdststusId: failEle.GdststusId,
              StrState: '未通过', //当前状态
              StrRemark: failEle.StrRemark, //否决原因 离职原因等
              Dtviewtime: '', //面试时间
              Strviewadd: '', //面试地址
              Dtreachtime: '', //预计到岗时间
              DtInducttime: '', //入职时间
              StrIsphysical: '', //是否体检
              Strphysicalhos: '', //体检医院
              Dtquittime: '', //离职时间
              Strquittype: '', //离职类型
              checked: failEle.checked,
              StrIsBlack: failEle.StrIsBlack ? failEle.StrIsBlack : '否', //是否黑名单
              StrBlacklabel: failEle.StrBlackReason, //黑名单标签
              StrAccomreq: !this.isNull(failEle.StrAccomreq) ? failEle.StrAccomreq : '', //住宿需求
              StrIdCard: !this.isNull(failEle.StrIdCard) ? failEle.StrIdCard : '' //身份证号码
            })
          }
          console.log('resList', resList)
          if (resList.some(val => this.isNull(val.StrRemark))) {
            // console.log('有空值，不通过') //true
            this.$message({
              type: 'warning',
              message: '请填写未通过原因'
            })
            return false
          } else {
            this.btnLoading06 = true
            // console.log('无空值，通过')  //false
            this.changeProcessRecord(resList, '未通过')
          }
        } else {
          this.$message({
            type: 'warning',
            message: '没有相应的数据'
          })
          return false
        }
      },
      // 到面登记弹框
      checkInterHandle() {
        let that = this
        this.checkQuery = this.$options.data.call(this).checkQuery
        this.$nextTick(e => {
          that.$refs['toFaceForm'].resetFields();
        })
        this.toFaceVisible = true
        this.tofaceNoteTxt01 = '';
        this.tofaceNoteTxt02 = ''
        this.phoneType02 = ''
        // 获取有权限的项目列表和岗位列表
        this.getResourceJoblist()
        this.getauthUserInfoByorgancode()
        this.getFaceDepartList()
      },
      // 保存到面登记
      saveCheckHandle() {
        let that = this
        this.phoneType02 = 'save'
        // if(this.isNull(this.checkQuery.Belonguserid)){
        this.checkQuery.Belonguserid = Cookies.get("userid-b")
        // }
        if (this.isTofaceAct == false) {
          // this.$message({ type: 'warning', message: '不能继续操作' })
          return
        }
        if (this.checkQuery.qudao == '社招') {
          // if(this.isNull(this.dedpartNameList)){
          //     this.$message({ type: 'warning', message: '请选择社招部门' })
          //     return false
          // }
          if (this.isNull(this.szMember)) {
            this.$message({
              type: 'warning',
              message: '请选择社招人员'
            })
            return false
          }
          this.checkQuery.Sctjr = this.depNameVal + '/' + this.szMember;
        } else if (this.checkQuery.qudao == '公司渠道') {
          // if(this.isNull(this.dedpartNameList)){
          //     this.$message({ type: 'warning', message: '请选择公司渠道的部门' })
          //     return false
          // }
          if (this.isNull(this.checkQuery.Gsqdtjr)) {
            this.$message({
              type: 'warning',
              message: '请选择公司渠道的人员'
            })
            return false
          }
        } else if (this.checkQuery.qudao == '外部渠道') {
          if (this.isNull(this.checkQuery.Wbqd)) {
            this.$message({
              type: 'warning',
              message: '请输入渠道信息'
            })
            return false
          }
        } else if (this.checkQuery.qudao == '内荐') {
          if (this.isNull(this.njMember)) {
            this.$message({
              type: 'warning',
              message: '请输入员工名称'
            })
            return false
          } else {
            this.checkQuery.Qtqk = '员工' + this.njMember + '推荐'
          }
        } else if (this.checkQuery.qudao == '企业转移' || this.checkQuery.qudao == '独立招聘') {
          this.checkQuery.Qtqk = this.checkQuery.qudao
        }
        // console.log('registQuery', this.checkQuery)
        that.$refs['toFaceForm'].validate((valid) => {
          if (valid) {
            this.btnLoading11 = true
            this.saveSigninfo(this.checkQuery)
          } else {
            return false;
          }
        })
      },
      // 终止流程弹框
      endHandle() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择终止的数据'
          })
          return false;
        } else {
          this.endProcessTableData = this.multipleSelection
          this.endProcessVisible = true
          this.comFaceQuery = this.$options.data.call(this).comFaceQuery
        }
      },
      // 确定终止
      saveEndHandle() {
        let resList = []
        if (!this.isNull(this.endProcessTableData)) {
          for (let i = 0; i < this.endProcessTableData.length; i++) {
            const endEle = this.endProcessTableData[i];
            resList.push({
              Jobid: endEle.Jobid, //岗位id
              Projectid: endEle.Projectid, //项目id
              ResumeId: endEle.ResumeId, //简历ID
              GdststusId: endEle.GdststusId,
              StrState: '终止', //当前状态
              StrRemark: endEle.StrRemark, //否决原因 离职原因等
              Dtviewtime: '', //面试时间
              Strviewadd: '', //面试地址
              Dtreachtime: endEle.Dtreachtime == '未确定' ? '1900-01-01' : endEle.Dtreachtime, //预计到岗时间
              DtInducttime: '', //入职时间
              StrIsphysical: '', //是否体检
              Strphysicalhos: '', //体检医院
              Dtquittime: '', //离职时间
              Strquittype: '', //离职类型
              checked: endEle.checked,
              StrIsBlack: endEle.StrIsBlack ? endEle.StrIsBlack : '否', //是否黑名单
              StrBlacklabel: endEle.StrBlackReason, //黑名单标签
              StrAccomreq: !this.isNull(endEle.StrAccomreq) ? endEle.StrAccomreq : '', //住宿需求
              StrIdCard: !this.isNull(endEle.StrIdCard) ? endEle.StrIdCard : '' //身份证号码
            })
          }
          // console.log('resList',resList)
          if (resList.some(val => this.isNull(val.StrRemark))) {
            // console.log('有空值，不通过') //true
            this.$message({
              type: 'warning',
              message: '请填写终止原因'
            })
            return false
          } else {
            this.btnLoading07 = true
            // console.log('无空值，通过')  //false
            this.changeProcessRecord(resList, '终止')
          }
        } else {
          this.$message({
            type: 'warning',
            message: '没有相应的数据'
          })
          return false
        }
      },
      // 回退
      backHandle() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请至少选择一条'
          })
          return false;
        } else {
          let arr = [];
          this.tableLoading = true;
          this.multipleSelection.forEach(e => {
            arr.push({
              GdststusId: e.GdststusId
            })
          });
          xz.fallbackPsnStatus(arr).then(res => {
            if (res.status == 'ok') {
              this.$message.success("操作成功！");
              this.getList();
              this.tableLoading = false;
            } else {
              this.$message.error(res.msg);
              this.tableLoading = false;
            }
          })
        }
      },
      //批量离职
      quitBatchHandle() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择数据'
          })
          return false;
        } else {
          this.quitTableData = this.multipleSelection;
          this.quitList = [];
          this.insureList = [];
          this.multipleSelection.forEach(e => {
            let data = {
              strExcelPath: e.StrExcelPath,
              intExcelLine: e.IntExcelLine,
              gdststusID: e.GdststusId,
              strWorkState: '',
              strBlacklistReason: '',
              strRemark: '',
              dtDepartureDate: '',
              dtRealDepartureDate: '',
            }
            this.quitList.push(data)
            if (e.Insurance == '已参保') {
              this.insureList.push(e)
            }
          });
          this.quitVisible = true
        }
      },
      // 离职弹框
      quitHandle(row) {
        // if(this.isNull(this.multipleSelection)){
        //   this.$message({ type: 'warning', message: '请选择面试未通过的数据' })
        //   return false;
        // }else{
        this.quitTableData = [row];
        this.insureList = [];
        this.quitList = [{
          // strExcelPath: row.StrExcelPath,
          // intExcelLine: row.IntExcelLine,
          gdststusID: row.GdststusId,
          strWorkState: '',
          strBlacklistReason: '',
          strRemark: '',
          dtDepartureDate: '',
          dtRealDepartureDate: '',
        }]
        if (row.Insurance == '是') {
          this.insureList = [row]
        }
        this.quitVisible = true
        // }
      },
      // 确定离职
      saveQuitHandle() {
        if (this.quitList.some(val => this.isNull(val.dtDepartureDate))) {
          this.$message({
            type: 'warning',
            message: '请选择离职时间'
          })
          return false
        } else if (this.quitList.some(val => this.isNull(val.dtRealDepartureDate))) {
          this.$message({
            type: 'warning',
            message: '请选择实际离职时间'
          })
          return false
        } else if (this.quitList.some(val => this.isNull(val.strWorkState))) {
          this.$message({
            type: 'warning',
            message: '请选择离职类型'
          })
          return false
        } else {
          this.btnLoading08 = true;
          let d = {
            type: 1, //类型1：待离职2：在职
            founder: Cookies.get("userid-b"),
            list: this.quitList
          }
          xz.rcFun(d, 'InterviewOnboarding/SetResignation').then(res => {
            if (res.status == 'ok') {
              this.$message.success('离职操作成功！');
              this.btnLoading08 = false;
              this.quitVisible = false;
              this.getList();
              if (this.insureList.length > 0) {
                this.showReduction = true;
              }
            } else {
              this.$message.error(res.msg);
              this.btnLoading08 = false;
            }
          })
        }
      },
      // 转岗弹框
      transHandle() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择转岗的数据'
          })
          return false;
        } else {
          this.transTableData = this.multipleSelection
          this.getResourceJoblist()
          this.transVisible = true
        }
      },
      // 确定转岗
      saveTransHandle() {
        let resList = []
        let transList = []
        if (!this.isNull(this.transTableData)) {
          for (let i = 0; i < this.transTableData.length; i++) {
            const transEle = this.transTableData[i];
            resList.push({
              Jobid: transEle.Jobid, //岗位id
              Projectid: transEle.Projectid, //项目id
              ResumeId: transEle.ResumeId, //简历ID
              StrRemark: transEle.StrRemark, //否决原因 离职原因等
              Dtquittime: transEle.Dtquittime, //离职时间
              Jobidnew: transEle.Jobidnew, //新岗位id
              Projectidnew: transEle.Projectidnew, //新的项目id
              ProjectidnewName: transEle.Projectidnew, //新项目名称
              JobidnewName: transEle.JobidnewName,
              DtInducttime: transEle.DtInducttime, //入职时间
              StrIdCard: transEle.StrIdCard //身份证
            })
            transList.push({
              StrRemark: transEle.StrRemark, //否决原因 离职原因等
              Dtquittime: transEle.Dtquittime, //离职时间
              StrJobInf: transEle.Jobidnew, //新岗位名称
              StrObjName: transEle.Projectidnew, //新的项目名称
              DtInducttime: transEle.DtInducttime, //入职时间
              StrIdCard: transEle.StrIdCard //身份证
            })
          }
          // console.log('resList',resList,transList)
          xz.savetransferrecords(resList).then(res => { // 添加转岗记录
            // console.log('saveEnterHandle', res)
            if (res.status == 'ok') {
              this.changeTransRecord(transList, '转岗')
            } else {
              this.$message({
                type: 'error',
                message: '操作失败，请稍后再试'
              })
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '没有相应的数据'
          })
          return false
        }
      },
      // 转岗--选择有权限的项目列表
      transProChange(item) {
        // console.log('333',val)
        // item.Jobidnew = ''
        // 匹配对于项目id的项目名称
        let selectedName = {};
        selectedName = this.resProjectList.find((res) => {
          return item.Projectidnew == res.Projectid;
          //筛选出匹配数据，是对应数据的整个对象
        });
        // console.log('333',item,selectedName)
        this.$set(item, 'ProjectidnewName', selectedName.StrprojectName)
        this.getPostList(item.Projectidnew)
      },
      // 转岗--选择有权限的岗位列表
      transPostChange(item) {
        let selectedName = {};
        selectedName = this.resPostList.find((res) => {
          return item.Jobidnew == res.Id;
        });
        this.$set(item, 'JobidnewName', selectedName.JobCategory);
      },
      // 未入职
      unemployedHandle() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择未入职的数据'
          })
          return false;
        } else {
          this.unemployedTableData = this.multipleSelection
          this.unemployedVisible = true
          this.comFaceQuery = this.$options.data.call(this).comFaceQuery
          this.reasonQuery.remark = ''
        }
      },
      saveUnemployedHandle() {
        let resList = []
        if (!this.isNull(this.unemployedTableData)) {
          for (let i = 0; i < this.unemployedTableData.length; i++) {
            const unempEle = this.unemployedTableData[i];
            console.log(unempEle)
            resList.push({
              Jobid: unempEle.Jobid, //岗位id
              Projectid: unempEle.Projectid, //项目id
              ResumeId: unempEle.ResumeId, //简历ID
              StrState: '未入职', //当前状态
              StrRemark: unempEle.StrRemark, //否决原因 离职原因等
              Dtviewtime: '', //面试时间
              GdststusId: unempEle.GdststusId,
              Strviewadd: '', //面试地址
              Dtreachtime: '', //预计到岗时间
              DtInducttime: '', //入职时间
              StrIsphysical: '', //是否体检
              Strphysicalhos: '', //体检医院
              Dtquittime: '', //离职时间
              Strquittype: '', //离职类型
              checked: unempEle.checked,
              StrIsBlack: unempEle.StrIsBlack ? unempEle.StrIsBlack : '否', //是否黑名单
              StrBlacklabel: unempEle.StrBlackReason, //黑名单标签
              StrAccomreq: !this.isNull(unempEle.StrAccomreq) ? unempEle.StrAccomreq : '', //住宿需求
              StrIdCard: !this.isNull(unempEle.StrIdCard) ? unempEle.StrIdCard : '' //身份证号码
            })
          }
          // console.log('resList',resList)
          if (resList.some(val => this.isNull(val.StrRemark))) {
            this.$message({
              type: 'warning',
              message: '请输入未入职原因'
            })
            return false
          } else {
            this.btnLoading09 = true
            // console.log('无空值，通过')  //false
            this.changeProcessRecord(resList, '未入职')
          }
        } else {
          this.$message({
            type: 'warning',
            message: '没有相应的数据'
          })
          return false
        }
      },
      // 约面和报名
      saveSigninfo(query) {
        xz.saveSigninfo(query).then(res => {
          // console.log('saveEnterHandle', res)
          if (res.status == 'ok') {
            this.registVisible = false
            this.btnLoading10 = false
            // 到面
            this.toFaceVisible = false
            this.btnLoading11 = false
            // 约面登记提示弹框
            this.confirmInfoVisible = false
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.getList()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      },
      //报名选择地址
      changeSignArea(val) {
        // console.log('ddd', val)
        if (!this.isNull(val)) {
          const checkedNode = this.$refs["cascaderSignArr"].getCheckedNodes();
          // console.log( checkedNode[0].data.Name ) ;  //获取当前点击节点的label值
          // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
          this.appointmentQuery.StrUserCityCode = val.toString()
          let labels = checkedNode[0].pathLabels
          if (val.length == 3) {
            this.appointmentQuery.StrUserCity = labels[0] + '-' + labels[1] + '-' + labels[2]
          }
          if (val.length == 2) {
            this.appointmentQuery.StrUserCity = labels[0] + '-' + labels[1]
          }
          if (val.length == 1) {
            this.appointmentQuery.StrUserCity = labels[0]
          }
        } else {
          this.appointmentQuery.StrUserCityCode = ''
        }
        this.appointCityVal = val
      },
      // 校验简历是否已被约面/被报名
      getresumestatuscheck(state, type) {
        let checkList = []
        let that = this
        if (type == 'register') {
          checkList.push({
            resumeId: this.isNullNotZero(this.appointmentQuery.ResumeId) ? '0' : this.appointmentQuery.ResumeId, // 简历id
            projectid: this.appointmentQuery.Projectid, // 项目id
            jobid: this.appointmentQuery.Jobid // 岗位id
          })
        } else {
          this.surfaceLoading = true
          if (!this.isNull(this.multipleSelection)) {
            for (let index = 0; index < this.multipleSelection.length; index++) {
              const check01 = this.multipleSelection[index];
              checkList.push({
                resumeId: this.isNullNotZero(check01.ResumeId) ? '0' : check01.ResumeId, // 简历id
                projectid: check01.Projectid, // 项目id
                jobid: check01.Jobid // 岗位id
              })
            }
          }
        }
        // console.log('check', checkList);
        xz.getresumestatuscheck(state, checkList).then(res => {
          // console.log('checkList', res)
          if (res.status == 'ok') {
            if (type == 'register') { // 报名/约面登记
              this.faceNoteTxt01 = res.msg[0].StrNeedAmount;
              this.faceNoteTxt02 = res.msg[0].Strremind;
              this.appointmentQuery.StrIdCard = res.msg[0].StrIdCard;
              // if(this.signDialogTitle == '约面登记'){
              if (res.msg[0].Isopera == '0') {
                this.isFaceAct = true
              } else {
                this.isFaceAct = false
              }
              // }
            } else { // 约面
              this.surfaceBackList = res.msg
              this.surfaceTableData = res.msg
              // console.log('kk',this.surfaceTableData)
              // 根据岗位获取面试时间列表
              let nowdate = moment().format("YYYY-MM-DD HH:mm")
              let endDate = moment().add(1, 'months').format("YYYY-MM-DD HH:mm")
              let viewTimeQuery = {
                interviewStartTime: nowdate,
                interviewEndTime: endDate
              }
              if (!this.isNull(this.surfaceTableData)) {
                for (let i = 0; i < this.surfaceTableData.length; i++) {
                  const eleFace01 = this.surfaceTableData[i];
                  let postArr = []
                  if (eleFace01.Projectid == 0) {
                    eleFace01.Projectid = null;
                    eleFace01.Jobid = '';
                  }
                  // this.getPostList(eleFace01.Projectid);
                  // if (this.activeName != '报名') {
                    if (!this.isNull(this.allPostList)) {
                      for (let k = 0; k < this.allPostList.length; k++) {
                        let element07 = this.allPostList[k];
                        if (element07.Projectid == eleFace01.Projectid) {
                          postArr.push({
                            Id: element07.Id,
                            JobCategory: element07.CustomerJobName
                          })
                        }
                      }
                      this.$set(eleFace01, 'resPostList', postArr);
                    }
                    // 终止的项目和岗位不显示
                    let objPro1 = that.resProjectList.findIndex((v) => (v.Projectid === eleFace01.Projectid));
                    if (objPro1 == -1) {
                      // console.log("不存在");
                      this.$set(eleFace01, 'Projectid', '');
                      // this.$set(eleFace01, 'Strremind', '');
                      this.$set(eleFace01, 'StrNeedAmount', '');
                    }
                    if (!this.isNull(eleFace01.resPostList)) {
                      let objPro2 = eleFace01.resPostList.findIndex((v) => (v.Id === eleFace01.Jobid));
                      if (objPro2 == -1) {
                        // console.log("不存在");
                        this.$set(eleFace01, 'Jobid', '');
                        // this.$set(eleFace01, 'Strremind', '');
                        this.$set(eleFace01, 'StrNeedAmount', '');
                      }
                    } else {
                      this.$set(eleFace01, 'Jobid', '');
                      this.$set(eleFace01, 'Strremind', '');
                      this.$set(eleFace01, 'StrNeedAmount', '');
                    }
                  // }
                  if (that.activeName == '报名' || that.activeName == '异常') { // 根据岗位获取面试时间列表
                    if (!this.isNull(eleFace01.Jobid)) {
                      xz.getjobdateappoint(eleFace01.Jobid, viewTimeQuery).then(res => {
                        // console.log('getTimeList', res)
                        if (res.status == 'ok') {
                          this.$set(eleFace01, 'viewDateList', res.data);
                        }
                      });
                    }
                  }
                  // this.getTimeList(eleFace01.Jobid);
                  if (this.activeName == '离职') { // 离职时项目 岗位默认为空
                    this.$set(eleFace01, 'ProjectidnewName', '');
                    this.$set(eleFace01, 'Jobid', '');
                    this.$set(eleFace01, 'JobName', '');
                    this.$set(eleFace01, 'ProjectName', '');
                    this.$set(eleFace01, 'Projectid', '');
                    this.$set(eleFace01, 'appDtviewDate', '');
                    this.$set(eleFace01, 'appDtviewTime', '');
                    this.$set(eleFace01, 'Dtviewtime', '');
                    this.$set(eleFace01, 'Strremind', '');
                    this.$set(eleFace01, 'StrNeedAmount', '');
                    this.$set(eleFace01, 'resPostList', []);
                    this.$set(eleFace01, 'viewDateList', []);
                    this.$set(eleFace01, 'viewTimesList', []);
                  }
                }
              }
            }
          }
          this.surfaceLoading = false
        })
      },
      // 获取分配列表
      getRecordList() {
        this.recLoading = true
        xz.getdistrecords(this.listRecordQuery).then(res => {
          // console.log('saveEnterHandle', res)
          if (res.status == 'ok') {
            this.recTableData = res.msg
            this.rectotal = res.totalcount
          }
          this.recLoading = false
        })
      },
      //分页
      recCurrentChange(val) {
        this.listRecordQuery.currpage = Number(val)
        this.getRecordList()
      },
      recSizeChange(val) {
        this.listRecordQuery.currpage = 1
        this.listRecordQuery.perpage = Number(val)
        this.getRecordList()
      },
      getRowKeys(row) { //唯一值
        // console.log(row.id)
        return row.userIds;
      },
      //参数列表（招聘来源 118）
      getdictdatalistbyid(id) {
        xz.getdictdatalistbyid(id).then(res => {
          // console.log('getdictdatalistbyid', res)
          if (res.status == 'ok') {
            if (id == '118') {
              this.originList = res.data.retList
            }
            if (id == '132') { // 黑名单标签
              this.blackLabelList = res.data.retList
            }
            if (id == '253') {
              // 民族
              this.nationList = res.data.retList
            }
          }
        })
      },
      // 获取客服/顾问列表
      getCusList(type) {
        xz.getUserInfoBytoporgancode(this.oneDepartQuery.strorgancode, this.oneDepartQuery.roletype, this.depMemberQuery).then(res => {
          // console.log('员工', res)
          if (res.status == 'ok') {
            if (type == 'customer') {
              this.memberSearchList = res.msg
            } else {
              // 客服列表
              this.memberSearchList = []
            }
          }
        })
      },
      // 到面选择项目
      tofaceProChange() {
        this.checkQuery.Jobid = ''
        this.checkQuery.qudao = ''
        this.szMember = ''
        this.depNameVal = ''
        this.checkQuery.Sctjr = ''
        this.checkQuery.Gsqd = ''
        this.checkQuery.Gsqdtjr = ''
        this.checkQuery.Wbqd = ''
        this.checkQuery.Wbqdtjr = ''
        this.njMember = ''
        this.checkQuery.Qtqk = ''
        this.getPostList(this.checkQuery.Projectid)
      },
      // 选择有权限的项目列表
      resProChange(val) {
        // console.log('333',val)
        this.appointmentQuery.Jobid = ''
        this.appointmentQuery.Dtviewtime = ''
        this.appointmentQuery.appDtviewDate = ''
        this.appointmentQuery.appDtviewTime = ''
        this.appointmentQuery.Strviewadd = ''
        this.viewAddressList = []
        this.viewDateList = []
        this.viewTimesList = []
        this.getPostList(this.appointmentQuery.Projectid)
      },
      // 选择有权限的岗位列表
      resPostChange() {
        this.viewAddressList = []
        this.viewDateList = []
        this.viewTimesList = []
        this.appointmentQuery.appDtviewDate = ''
        this.appointmentQuery.appDtviewTime = ''
        this.appointmentQuery.Strviewadd = ''
        // if(!this.isNullNotZero(this.appointmentQuery.ResumeId)){
        if (this.signDialogTitle == '报名登记') {
          // this.getresumestatuscheck('已报名', 'register')
        } else {
          this.getresumestatuscheck('约面', 'register')
          this.getTimeList(this.appointmentQuery.Jobid)
          this.getSurfaceDate(this.appointmentQuery.Jobid)
        }
        // }
      },
      // 选择面试日期
      resDateChange() {
        this.viewTimesList = []
        this.getSurfaceTime(this.appointmentQuery.Jobid, this.appointmentQuery.appDtviewDate)
      },
      viewaddChange(val) {
        // console.log('gg',val)
        this.appointmentQuery.Strviewadd = val
      },
      // 对象数组去重
      uniqueFunc(arr, uniId) {
        const res01 = new Map();
        return arr.filter((item) => !res01.has(item[uniId]) && !this.isNull(item[uniId]) && res01.set(item[uniId], 1));
      },
      // 获取有权限的项目列表和岗位列表
      getResourceJoblist() {
        xz.getresourcechangejoblist({}, localStorage.loginRoletype).then(res => {
          // console.log('项目名称列表', res)
          if (res.status == 'ok') {
            // console.log(99,res)
            this.resProjectList = res.data.retList
            // 项目列表去重
            let obj = {};
            let peon = this.resProjectList.reduce((cur, next) => {
              obj[next.StrprojectName] ? "" : obj[next.StrprojectName] = true && cur.push(next);
              return cur;
            }, []) //设置cur默认类型为数组，并且初始值为空的数组
            // 岗位列表去重
            let postArr = res.data.retList
            let peon01 = this.uniqueFunc(postArr, 'CustomerJobName')
            this.resProjectList = peon
            this.allPostList = res.data.retList
            this.qrProjectList = res.data.retList
            // console.log(33,this.qrProjectList)
            // this.searPostList = peon01
          }
        })
      },
      // 获取岗位列表
      getPostList(projectid) {
        this.resPostList = []
        if (!this.isNull(this.allPostList)) {
          for (let i = 0; i < this.allPostList.length; i++) {
            let element07 = this.allPostList[i];
            if (element07.Projectid == projectid) {
              this.resPostList.push({
                Id: element07.Id,
                JobCategory: element07.CustomerJobName
              })
            }
          }
          // console.log('项目名称列表', this.allPostList)
        }
      },
      // 根据岗位获取面试时间列表
      getTimeList(jobid) {
        let nowdate = moment().format("YYYY-MM-DD HH:mm")
        let endDate = moment().add(1, 'months').format("YYYY-MM-DD HH:mm")
        this.viewTimeQuery = {
          interviewStartTime: nowdate,
          interviewEndTime: endDate
        }
        this.viewTimeList = []
        xz.getresourceavailabletime(jobid, this.viewTimeQuery).then(res => {
          // console.log('getTimeList', res)
          if (res.status == 'ok') {
            // console.log(99,res)
            this.viewAddressList = [res.data.retList.InterviewProvinceName + res.data.retList.InterviewCityName + res.data.retList.InterviewAraeName + res.data.retList.InterviewAddress]
            this.viewTimeList = res.data.tempList
          }
        })
      },
      // 获取项目名称列表
      getProNameList() {
        xz.getProjectLists(this.proNameQuery).then(res => {
          // console.log('项目名称列表', res)
          if (res.status == 'ok') {
            this.projectList = res.msg
          } else {
            this.projectList = []
          }
        })
      },
      // 删除分配列表
      dltDivideHandle(data, index) {
        data.splice(index, 1)
      },
      // 人岗匹配列表
      getMatchList() {
        this.recommendLoading = true
        xz.wxappgetjoblist(this.roleType, this.matchQuery).then(res => {
          // console.log('getMatchList', res)
          if (res.status == 'ok') {
            this.recommendList = res.data.retList
            this.matchCount = res.data.count
          } else {
            this.recommendList = []
            this.matchCount = 0
          }
          this.recommendLoading = false
        })
      },
      recommendCurrentChange(val) {
        this.matchQuery.pageNum = Number(val)
        this.getMatchList()
      },
      recommendSizeChange(val) {
        this.matchQuery.pageNum = 1
        this.matchQuery.pageSize = Number(val)
        this.getMatchList()
      },
      // 保存录入简历
      saveEnterHandle() {
        this.enterResumeQuery.StrPsnIsType = ''
        this.enterResumeQuery.StrCategoryIds = this.enterResumeQuery.posCategoryList.toString()
        if (this.isNull(this.enterResumeQuery.salary1) && this.isNull(this.enterResumeQuery.salary2)) {
          this.enterResumeQuery.StrUserExpectSa = ''
        } else if (!this.isNull(this.enterResumeQuery.salary1) && this.isNull(this.enterResumeQuery.salary2)) {
          this.$message({
            type: 'warning',
            message: '请填写最高期望薪资'
          })
          return false
        } else if (this.isNull(this.enterResumeQuery.salary1) && !this.isNull(this.enterResumeQuery.salary2)) {
          this.$message({
            type: 'warning',
            message: '请填写最低期望薪资'
          })
          return false
        } else if (Number(this.enterResumeQuery.salary1) > Number(this.enterResumeQuery.salary2)) {
          this.$message({
            type: 'warning',
            message: '最低期望薪资不能高于最高薪资'
          })
          return false
        } else {
          this.enterResumeQuery.StrUserExpectSa = this.enterResumeQuery.salary1 + '-' + this.enterResumeQuery.salary2
        }
        this.enTagChecks = [...new Set(this.enTagChecks)]
        this.enterTagQuery = {
          resumeIds: this.enterResumeQuery.ResumeId, // 简历id (多条用,连接)
          labelIds: this.enTagChecks.toString() // 标签id (多条用,连接)
        }
        // console.log('saveEnterHandle', this.enterResumeQuery, this.enterTagQuery)
        this.$refs['enterResumeForm'].validate((valid) => {
          if (valid) {
            xz.saveResumeinfo(this.enterResumeQuery).then(res => {
              // console.log('saveEnterHandle', res)
              if (res.status == 'ok') {
                if (this.isNull(this.enTagChecks)) {
                  this.enterResumeVisible = false
                  this.$message({
                    type: 'success',
                    message: '录入成功'
                  });
                  this.getList()
                } else {
                  this.tagHandle(this.enterTagQuery, 'enter')
                }
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          } else {
            return false;
          }
        })
      },
      // 保存分配简历人员
      saveDivideHandle() {
        if (this.isNull(this.divideQuery.resumeIds)) {
          this.$message({
            type: 'warning',
            message: '请选择分配的数据'
          })
          return false
        }
        if (this.isNull(this.divideQuery.perDepartList)) {
          this.$message({
            type: 'warning',
            message: '请选择部门'
          })
          return false
        }
        if (!this.isNull(this.devUserList)) {
          this.divideQuery.userIds = this.devUserList.toString()
        }
        this.$refs['divideForm'].validate((valid) => {
          if (valid) {
            // console.log('saveEnterHandle', this.divideQuery)
            xz.distResumeinfo(this.divideQuery).then(res => {
              // console.log('saveEnterHandle', res)
              if (res.status == 'ok') {
                if (res.totalcount == 0) {
                  this.$message({
                    type: 'warning',
                    message: '简历已达到上限'
                  })
                  return false
                } else {
                  this.$message({
                    type: 'success',
                    message: '操作成功'
                  })
                  this.divideVisible = false
                  this.getRecordList()
                  this.divRecordVisible = true
                  this.getList()
                }
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败，请稍后再试'
                })
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      // 选择通知模板
      tempHandle(val) {
        // console.log('dd',val)
        for (let i = 0; i < this.noticeTempList.length; i++) {
          const elementtmp = this.noticeTempList[i];
          // let titleList = []
          if (val == elementtmp.TemplateId) {
            this.moduleInfo = elementtmp.TemplateVal
            this.tableNoteTitle = JSON.parse(elementtmp.Parameter)
          }
        }
        // this.inputNum = Number(this.sGetCharCount(this.moduleInfo, '{') - 2)
        // console.log('dd', this.tableNoteTitle)
      },
      // 提交消息通知
      saveNoticeHandle() {
        let that = this
        if (this.isNull(this.noticeData)) {
          this.$message({
            type: 'warning',
            message: '请选择要通知的数据'
          })
          return false;
        } else {
          if (this.isNull(this.noticeQuery.TemplateId)) {
            this.$message({
              type: 'warning',
              message: '请选择通知模板'
            })
            return false;
          }
          this.noticeQuery.SendList = []
          for (let i = 0; i < this.noticeData.length; i++) {
            let elementw = this.noticeData[i];
            this.$set(elementw, 'parameterList', {});
            for (let k = 0; k < this.tableNoteTitle.length; k++) {
              let element09 = this.tableNoteTitle[k];
              let eleId = element09.StrColumId
              this.$set(elementw.parameterList, eleId, elementw[element09.StrColumId])
            }
            // // 清除数组中的空值
            // let r = this.inputList.filter(function (s) {
            //     return s && s.trim(); 
            // });
            // parameterList = parameterList.concat(r)
            this.noticeQuery.SendList.push({
              strmobile: elementw.StrMobile,
              ReceiveName: elementw.StrUserName,
              Projectid: elementw.Projectid,
              Jobid: elementw.Jobid,
              StrprojectName: elementw.StrprojectName,
              GdststusId: elementw.GdststusId,
              StrRecruitname: elementw.Recruitname,
              strparam: elementw.parameterList
            })
            // 判断是否有空值
            if (Object.values(elementw.parameterList).some(v => that.isNull(v))) {
              this.$message({
                type: 'warning',
                message: '有未填项，请填写输入框'
              })
              return false;
            }
            if (Object.values(elementw.parameterList).some(v => (v.length > 12))) {
              this.$message({
                type: 'warning',
                message: '输入框填写的数据长度不能超过12'
              })
              return false;
            }
          }
          this.noteLoading = true
          // console.log('noticeQuery', this.noticeQuery)
          xz.sendnotify({
            TemplateID: this.noticeQuery.TemplateId
          }, this.noticeQuery.SendList).then(res => {
            // console.log('saveEnterHandle', res)
            if (res.status == 'ok') {
              this.noticeVisible = false
              this.multipleSelection = []
              // this.getList()
              this.$message({
                type: 'success',
                message: '操作成功'
              })
              this.$router.push({
                path: '/noteSendList?active=消息通知记录'
              })
            } else {
              this.$message({
                type: 'error',
                message: '操作失败，请稍后再试'
              })
            }
            this.noteLoading = false
          })
        }
      },
      // 保存编辑标签
      saveLabelHandle() {
        this.diaTagChecks = this.dCheckPriLabelList.concat(this.dCheckCommonLabelList)
        //去重
        this.diaTagChecks = [...new Set(this.diaTagChecks)];
        let ids = this.diaTagChecks.toString()
        // console.log('uuu',this.resumeIds,this.diaTagChecks)
        if (this.isNull(this.diaTagChecks)) {
          this.$message({
            type: 'warning',
            message: '请选择标签'
          })
          return false
        } else {
          this.tagHandle({
            resumeIds: this.resumeIds,
            labelIds: ids
          }, 'dialog')
          // this.getList()
        }
      },
      // 保存跟进
      saveFollowHandle() {
        this.$refs['followForm'].validate((valid) => {
          if (valid) {
            xz.savePsnfowrecords(this.recommendQuery).then(res => {
              // console.log('saveEnterHandle', res)
              if (res.status == 'ok') {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.getFollowList()
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败，请稍后再试'
                })
              }
            })
          } else {
            return false;
          }
        })
      },
      //分页(服务记录/跟进记录)
      handleCurrentChange1(val) {
        this.followQuery.currpage = Number(val)
        this.getFollowList()
      },
      handleSizeChange1(val) {
        this.followQuery.currpage = 1
        this.followQuery.perpage = Number(val)
        this.getFollowList()
      },
      handleCurrentChange2(val) {
        this.serviceQuery.currpage = Number(val)
        this.getServiceList()
      },
      handleSizeChange2(val) {
        this.serviceQuery.currpage = 1
        this.serviceQuery.perpage = Number(val)
        this.getServiceList()
      },
      //获取跟进记录
      getFollowList() {
        this.followLoading = true
        xz.getresumePsnfowrecords(this.followQuery).then(res => {
          // console.log('followQuery', res)
          if (res.status == 'ok') {
            this.followData = res.msg
            this.totalFollow = res.totalcount
          } else {
            this.followData = []
            this.totalFollow = 0
          }
          this.followLoading = false
        })
      },
      //获取服务记录 流程记录
      getServiceList() {
        this.serviceLoading = true
        xz.getresumePsnstatusrecords(this.serviceQuery).then(res => {
          // console.log('serviceQuery', res)
          if (res.status == 'ok') {
            this.serviceData = res.msg
            this.totalService = res.totalcount
          } else {
            this.serviceData = []
            this.totalService = 0
          }
          this.serviceLoading = false
        })
      },
      // 标签弹框 选择公有标签
      dPubEnterHandle(val) {
        this.dCheckCommonLabelList = []
        // console.log('labelEnterHandle', val)
        this.dCheckCommonLabelList = val
      },
      // 标签弹框 选择私有标签
      dPraEnterHandle(val) {
        this.dCheckPriLabelList = []
        // console.log('lPraEnterHandle', val)
        this.dCheckPriLabelList = val
      },
      // 打标签
      tagHandle(query, type) {
        // console.log('tagHandle', query)
        xz.savelabelResume(query).then(res => {
          // console.log('tagHandle', res)
          if (res.status == 'ok') {
            if (type == 'dialog') {
              this.getresumelabelLists(query.resumeIds)
              this.addlabelVisible = false
            }
            if (type == 'enter') {
              this.enterResumeVisible = false
            }
            this.$message({
              type: 'success',
              message: '操作成功'
            })
          } else {
            this.$message({
              type: 'error',
              message: '操作失败,请稍后再试'
            })
          }
        })
      },
      //选择地址
      changeArea(val) {
        // console.log('ddd', val)
        let checkedNode;
        let labels;
        if (!this.isNull(val)) {
          checkedNode = this.$refs["cascaderArr"].panel.getNodeByValue(val);
          labels = checkedNode.pathLabels;
          this.enterResumeQuery.StrUserCityCode = val.toString()
          this.enterResumeQuery.StrUserCity = labels.join('-')
        } else {
          this.enterResumeQuery.StrUserCityCode = ''
          this.enterResumeQuery.StrUserCity = ''
        }
        this.strCityCode = val
      },
      // 导入弹框
      importHandle(type) {
        this.getProNameList()
        this.importVisible = true
        this.importSignQuery.projectid = ''
        this.importSignQuery.strprojectName = ''
        this.importSignQuery.jobid = ''
        this.importSignQuery.customerJobName = ''
        this.errorTxt = ''
        this.excelpath = ''
        this.importActive = 0
        this.ExcelSrc = {
          value: '',
          check: false,
          fileName: ''
        }
        this.isUploadSuccess = true
        this.importPostList = []
        if (type == 'five') {
          this.importStrState = '到面'
          this.importName = '批量到面导入'
          this.importSignQuery.tabName = '批量到面导入表'
          this.importSignQuery.fileid = '批量到面导入表'
          this.importSignQuery.tableid = 'JB_emp_PsnStatus'
          this.downSignQuery.tableid = 'output_JB_emp_PsnStatus'
        } else if (type == 'third') {
          this.importStrState = '入职'
          this.importName = '批量入职导入'
          this.importSignQuery.tabName = '批量入职模板（简易）'
          this.importSignQuery.fileid = '批量入职模板（简易）'
          this.importSignQuery.tableid = 'JB_emp_UserBaseSimple'
          // this.downSignQuery.tableid = 'RPA_output_JB_emp_UserBase'
          this.downSignQuery.tableid = 'output_JB_emp_UserBaseSimple'
          if (window.localStorage.getItem('isJobDownload')) {
            this.calDaysBetween(window.localStorage.getItem('isJobDownload'))
          }
        } else if (type == 'first') {
          this.importStrState = '待面试'
          this.importName = '批量导入待面试模板'
          this.importSignQuery.tabName = '批量导入待面试模板'
          this.importSignQuery.fileid = '批量导入待面试模板'
          this.importSignQuery.tableid = 'JB_emp_PsnStatusDms'
          this.downSignQuery.tableid = 'output_JB_emp_PsnStatusDms'
          if (window.localStorage.getItem('isFaceDownload')) {
            this.calDaysBetween(window.localStorage.getItem('isFaceDownload'))
          }
        } else if (type == 'second') {
          this.importStrState = '待入职'
          this.importName = '批量导入待入职模板'
          this.importSignQuery.tabName = '批量导入待入职模板'
          this.importSignQuery.fileid = '批量导入待入职模板'
          this.importSignQuery.tableid = 'JB_emp_PsnStatusDrz'
          this.downSignQuery.tableid = 'output_JB_emp_PsnStatusDrz'
          if (window.localStorage.getItem('isPendingEntryDownload')) {
            this.calDaysBetween(window.localStorage.getItem('isPendingEntryDownload'))
          }
        } else if (type == 'four') {
          this.importStrState = '离职'
          this.importName = '批量离职导入'
          this.importSignQuery.tabName = '批量导入离职模板'
          this.importSignQuery.fileid = '批量导入离职模板'
          this.importSignQuery.tableid = 'JB_emp_UserBaseDepart'
          this.downSignQuery.tableid = 'output_JB_emp_UserBaseDepart'
          if (window.localStorage.getItem('isDepartDownload')) {
            this.calDaysBetween(window.localStorage.getItem('isDepartDownload'))
          }
        }
      },
      // 录入弹框
      enterHandle() {
        // 初始化-清空
        // Object.assign(this.$data, this.$options.data())
        this.enterResumeQuery = this.$options.data.call(this).enterResumeQuery
        this.includePublicChecks = []
        this.includePrivateChecks = []
        this.enterNoteTxt = false
        this.strCityCode = []
        // this.getTreestr()
        this.enterResumeVisible = true
      },
      // 分配弹框
      divideHandle() {
        this.divideQuery.userIds = ''
        this.divideQuery.perDepartList = []
        this.dividePersonList = []
        this.devUserList = []
        this.devDataList = []
        this.addDivideQuery = {
          departName: '',
          Username: '',
          userIds: []
        }
        // if(this.isNull(this.multipleSelection)){
        //   this.$message({ type: 'warning', message: '请选择分配的数据' })
        //   return false
        // }else{
        this.divideVisible = true
        // }
      },
      // 通知弹框
      noticeHandle() {
        this.noticeQuery.TemplateId = ''
        this.moduleInfo = ''
        this.inputNum = 0
        this.tableNoteTitle = []
        this.noticeQuery.SendList = []
        if (this.isNull(this.noticeData)) {
          this.$message({
            type: 'warning',
            message: '请选择要通知的数据'
          })
          return false;
        } else {
          // 获取消息模板列表
          this.getTemplateList()
          // console.log('ss',this.noticeData)
          this.noticeVisible = true
        }
      },
      // 标签弹框
      labelHandle(item) {
        this.resumeIds = item.ResumeId
        this.getresumelabelLists(item.ResumeId)
        this.labelVisible = true
      },
      // 添加标签弹框
      addLabelHandle() {
        // 全局标签
        for (let i = 0; i < this.lPubDialogList.length; i++) {
          const elementl1 = this.lPubDialogList[i];
          this.wholeCheckList.push(elementl1.LabelId)
        }
        // 私有
        for (let j = 0; j < this.lPriDialogList.length; j++) {
          const elementl2 = this.lPriDialogList[j];
          this.wholeCheckList2.push(elementl2.LabelId)
        }
        this.dCheckPriLabelList = this.wholeCheckList2
        this.dCheckCommonLabelList = this.wholeCheckList
        this.diaTagChecks = this.wholeCheckList.concat(this.wholeCheckList2)
        // console.log('rrr',this.wholeCheckList,this.wholeCheckList2)
        this.addlabelVisible = true
      },
      // 跟进弹框
      followHandle(item) {
        this.matchQuery.ResumeId = item.ResumeId
        this.followQuery.resumeId = item.ResumeId
        this.serviceQuery.resumeId = item.ResumeId
        this.recommendQuery = {
          ResumeId: item.ResumeId, // 简历id
          StrUserJobhunt: '', // 求职意愿
          StrReason: '', // 原因
          StrRemark: '', // 备注
          GduserId: Cookies.get("userid-b"), // 操作人
          GduserName: '', // 操作人姓名
          StrOther: '', // 其他
          fCheckList: []
        }
        // 人岗匹配列表
        this.getMatchList()
        this.getFollowList()
        // 服务列表
        this.getServiceList()
        this.followVisible = true
      },
      // 详情
      dtlHandle(row) {
        if (this.activeName != '在职' && this.activeName != '离职') {
          this.psnDtlInfo = row;
          this.showPsnDtl = true;
        } else {
          const routerUrl = this.$router.resolve({
            path: "/rosterEmpEdit",
            query: {
              type: 'edit',
              strExcelPath: row.StrExcelPath,
              intExcelLine: row.IntExcelLine
            }
          });
          const newWindow = window.open(routerUrl.href, "_blank");
        }
      },
      // 添加标签切换
      handleLabelClick(tab, event) {},
      // 跟进切换
      followHandleClick(tab, event) {
        // if(tab.name == '跟进记录'){
        //   this.getFollowList()
        // }else if(tab.name == '服务记录'){
        //   this.getServiceList()
        // }
      },
      // 获取简历标签详情
      getresumelabelLists(resumeId) {
        this.includePublicChecks = []
        this.includePrivateChecks = []
        xz.GetresumelabelLists({
          resumeId: resumeId
        }).then(res => {
          // console.log('getresumelabelLists', res)
          if (res.status == 'ok') {
            this.lPubDialogList = res.msgpub
            this.lPriDialogList = res.msgpri
            // 公共标签
            if (!this.isNull(res.msgpub)) {
              for (let i = 0; i < res.msgpub.length; i++) {
                const elementpub = res.msgpub[i];
                this.enTagChecks.push(elementpub.LabelId)
                this.includePublicChecks.push(elementpub.LabelId)
              }
            }
            // 私有标签
            if (!this.isNull(res.msgpri)) {
              for (let j = 0; j < res.msgpri.length; j++) {
                const elementpri = res.msgpri[j];
                this.enTagChecks.push(elementpri.LabelId)
                this.includePrivateChecks.push(elementpri.LabelId)
              }
            }
          }
        })
      },
      // 岗位类别选择
      poSectionChange(val) {
        // console.log('poSectionChange', val)
        const checkedNode = this.$refs['poSectionArr'].getCheckedNodes();
        // console.log( checkedNode[0].data.strParametername ) ;  //获取当前点击节点的label值
        // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
        let labels = checkedNode[0].pathLabels;
        if (labels.length > 1) {
          this.enterResumeQuery.StrJobInf = labels[0] + '-' + labels[1];
        } else if (labels.length == 1) {
          this.enterResumeQuery.StrJobInf = labels[0];
        }
      },
      // 搜索岗位选择
      poSearchChange() {
        const checkedNode1 = this.$refs['poSearchArr'].getCheckedNodes();
        let labels = checkedNode1[0].pathLabels;
        // console.log('33', labels)
        if (labels.length > 1) {
          this.listQuery.strJobInf = labels[0] + '-' + labels[1];
        } else if (labels.length == 1) {
          this.listQuery.strJobInf = labels[0];
        }
      },
      // 查询发送记录
      jumpSendRecord() {
        this.$router.push({
          path: '/noteSendList',
          query: {
            active: '消息通知记录'
          }
        })
      },
      // 验证手机号
      checkHandle(chkval, callback) {
        if (chkval.length > 0) {
          xz.checkResumeMobile({
            strMobile: chkval
          }).then(res => {
            // console.log('checkHandle', res)
            if (res.status == 'ok') {
              if (Number(res.msg) > 0) {
                this.enterResumeQuery.ResumeId = res.msg
                callback(true)
              } else {
                callback(false)
              }
            }
          })
        }
      },
      // 通过手机号获取简历详情
      getResumeDtl01(strMobile, type) {
        xz.getResumeDetail({
          strMobile: strMobile
        }).then(res => {
          // console.log('getResumeDtl01', res)
          if (res.status == 'ok') {
            let resMsg = res.msg
            let resMsgp = res.msgp
            if (type == 'regist') {
              // this.appointmentQuery.Jobid = '' //岗位id
              if (!this.isNullNotZero(resMsg)) {
                this.appointmentQuery.ResumeId = this.isNullNotZero(resMsg.ResumeId) ? '0' : resMsg.ResumeId //简历ID
                this.appointmentQuery.Belonguserid = Cookies.get("userid-b") //创建人
                this.appointmentQuery.StrUserName = resMsg.StrUserName //姓名
                this.appointmentQuery.StrMobile = resMsg.StrMobile //联系方式
                this.appointmentQuery.StrWorkState = resMsg.StrWorkState //当前状态
                this.appointmentQuery.BolUserSex = resMsg.BolUserSex //性别
                this.appointmentQuery.StrUserAge = resMsg.StrUserAge //年龄
                this.appointmentQuery.StrSource = resMsg.StrSource //简历来源
                this.appointmentQuery.StrUsernation = resMsg.StrUsernation //民族
                this.appointmentQuery.StrIdCard = resMsg.StrIdCard //身份证
                this.appointmentQuery.StrAccomreq = !this.isNull(resMsgp) && !this.isNull(resMsgp.StrAccomreq) ? resMsgp.StrAccomreq : '' //住宿需求
                // this.appointmentQuery.StrJobInf = resMsg.StrJobInf //意向岗位
                // StrCategoryIds: resMsg.StrCategoryIds, //意向岗位id
                // 选中的意向岗位
                this.appointmentQuery.posCategoryList = []
                this.appointmentQuery.StrUserCity = resMsg.StrUserCity //求职城市
                this.appointmentQuery.StrUserCityCode = resMsg.StrUserCityCode //求职城市code
                this.appointmentQuery.StrRemark = resMsg.StrRemark //备注
                this.appointCityVal = resMsg.StrUserCityCode ? resMsg.StrUserCityCode.split(',') : []
                this.appointmentQuery.posCategoryList = resMsg.StrCategoryIds ? resMsg.StrCategoryIds.split(',') : []
              }
            }
            if (type == 'toface') { //到面
              // this.checkQuery.Jobid = '' //岗位id
              if (!this.isNullNotZero(resMsg)) {
                this.checkQuery.ResumeId = this.isNullNotZero(resMsg.ResumeId) ? '0' : resMsg.ResumeId //简历ID
                this.checkQuery.Belonguserid = Cookies.get("userid-b") //创建人
                this.checkQuery.StrUserName = resMsg.StrUserName //姓名
                this.checkQuery.StrMobile = resMsg.StrMobile //联系方式
                this.checkQuery.BolUserSex = resMsg.BolUserSex //性别
                this.checkQuery.StrUserAge = resMsg.StrUserAge //年龄
                this.checkQuery.StrSource = resMsg.StrSource //简历来源
                this.checkQuery.StrUsernation = resMsg.StrUsernation //民族
                this.checkQuery.StrUserCity = resMsg.StrUserCity //求职城市
                this.checkQuery.StrUserCityCode = resMsg.StrUserCityCode //求职城市code
                this.checkQuery.StrRemark = resMsg.StrRemark //备注
                this.checkQuery.StrAccomreq = !this.isNull(resMsgp) && !this.isNull(resMsgp.StrAccomreq) ? resMsgp.StrAccomreq : ''
                this.checkQuery.StrIdCard = resMsg.StrIdCard //身份证
              } else {
                this.checkQuery.ResumeId = '0'
              }
            }
            // console.log('iii', this.$refs[`cascaderArr`])
            // this.$nextTick(() => {this.$refs[`cascaderSignArr`].inputValue = resMsg.StrUserCity})
          }
        })
      },
      // 获取简历详情
      getResumeDtl(id) {
        xz.getResumeDetail({
          ResumeId: id
        }).then(res => {
          // console.log('getResumeDtl', res)
          if (res.status == 'ok') {
            let resMsg = res.msg
            let resMsgp = res.msgp
            this.enterResumeQuery = {
              ResumeId: resMsg.ResumeId, //简历ID
              StrUserName: resMsg.StrUserName, //姓名
              StrMobile: resMsg.StrMobile, //联系方式
              StrWorkState: resMsg.StrWorkState, //当前状态
              BolUserSex: resMsg.BolUserSex, //性别
              StrUserAge: resMsg.StrUserAge, //年龄
              StrNativePlace: resMsg.StrNativePlace, //户籍
              StrEduLvl: resMsg.StrEduLvl, //学历
              StrJobInf: resMsg.StrJobInf, //意向岗位
              StrCategoryIds: resMsg.StrCategoryIds, //意向岗位id
              // 选中的意向岗位
              posCategoryList: [],
              StrUserCity: resMsg.StrUserCity, //求职城市
              StrUserAdd: resMsg.StrUserAdd, //居住地
              StrUserCityCode: resMsg.StrUserCityCode, //求职城市code
              StrSource: resMsg.StrSource, //来源
              StrUserExpectSa: resMsg.StrUserExpectSa, //期望薪资
              salary1: !this.isNull(resMsg.StrUserExpectSa) ? resMsg.StrUserExpectSa.split('-')[0] : '',
              salary2: !this.isNull(resMsg.StrUserExpectSa) ? resMsg.StrUserExpectSa.split('-')[1] : '',
              StrRemark: resMsg.StrRemark, //备注
              StrlateCompany: resMsg.StrlateCompany, //最近入职项目
              DtlateInducDate: !this.isNull(resMsg.DtlateInducDate) ? resMsg.DtlateInducDate : '', //最近入职时间
              DtlatequitDate: !this.isNull(resMsg.DtlatequitDate) ? resMsg.DtlatequitDate : '', //最近离职时间
              StrquitReason: resMsg.StrquitReason, //离职原因
              StrUserJobhunt: resMsg.StrUserJobhunt, //求职意向
              StrPsnIsType: resMsg.StrPsnIsType, //是否公海 1 公海 0私人StrJobType: resMsg.StrJobType, //岗位类型
              StrState: resMsg.StrState, //在离职状态
              //拓展
              StrIsBlack: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrIsBlack) ? resMsgp.StrIsBlack : '', //是否黑名单
              StrBlackReason: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrBlackReason) ? resMsgp.StrBlackReason : '', //黑名单原因
              StrUsernation: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrUsernation) ? resMsgp.StrUsernation : '', //民族
              Strskill: !this.isNull(resMsgp) && !this.isNull(resMsgp.Strskill) ? resMsgp.Strskill : '', //技能
              Strcertificate: !this.isNull(resMsgp) && !this.isNull(resMsgp.Strcertificate) ? resMsgp.Strcertificate : '', //证书
              StrAccomreq: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrAccomreq) ? resMsgp.StrAccomreq : '', //住宿要求
              StrDinreq: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrDinreq) ? resMsgp.StrDinreq : '', //吃饭要求
              StrIsqwfri: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrIsqwfri) ? resMsgp.StrIsqwfri : '', //是否企微好友
              StrCont1: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont1) ? resMsgp.StrCont1 : '', //拓展1
              StrCont2: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont2) ? resMsgp.StrCont2 : '',
              StrCont3: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont3) ? resMsgp.StrCont3 : '',
              StrCont4: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont4) ? resMsgp.StrCont4 : '',
              StrCont5: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont5) ? resMsgp.StrCont5 : '',
              StrCont6: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont6) ? resMsgp.StrCont6 : '',
              StrCont7: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont7) ? resMsgp.StrCont7 : '',
              StrCont8: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont8) ? resMsgp.StrCont8 : '',
              StrCont9: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont9) ? resMsgp.StrCont9 : '',
              StrCont10: !this.isNull(resMsgp) && !this.isNull(resMsgp.StrCont10) ? resMsgp.StrCont10 : '',
              WorkingShift: !this.isNull(resMsgp) && !this.isNull(resMsgp.WorkingShift) ? resMsgp.WorkingShift : '', // 班次
              Workingposition: !this.isNull(resMsgp) && !this.isNull(resMsgp.Workingposition) ? resMsgp.Workingposition : '', // 站班/坐班
              StrResumefile: resMsg.StrResumefile, // 简历附件名称
              StrResumefileUrl: resMsg.StrResumefileUrl // 简历附件路径
            }
            this.strCityCode = resMsg.StrUserCityCode ? resMsg.StrUserCityCode.split(',') : []
            this.getresumelabelLists(resMsg.ResumeId)
            this.enterResumeQuery.posCategoryList = resMsg.StrCategoryIds ? resMsg.StrCategoryIds.split(',') : []
            // console.log('iii', this.$refs[`cascaderArr`])
            this.$nextTick(() => {
              this.$refs[`cascaderArr`].inputValue = resMsg.StrUserCity
            })
          }
        })
      },
      //获取省份
      getprovinces() {
        xz.getAreaAll().then(res => {
          // console.log('getprovinces', res)
          this.provinces = res;
        })
      },
      //获取搜索中的岗位列表
      getresourcejobcategoryblist(id, type) {
        xz.getresourcejobcustomerlist(localStorage.loginRoletype, {
          projectid: id.toString()
        }).then(res => {
          // console.log('searPostList', res)
          if (res.status == 'ok') {
            if (type == 'search') {
              this.searPostList = res.data;
            }
            if (type == 'import') {
              this.impJobList = res.data;
            }
          } else {
            if (type == 'search') {
              this.searPostList = [];
            }
            if (type == 'import') {
              this.impJobList = res.data;
            }
          }
        })
      },
      // 意向岗位 岗位类别
      getTreestr() {
        let data = {
          currpage: 1,
          perpage: 10000,
          strIsDisable: '', // 传1 禁用的看不到了  不传就全显示
          keyword: ''
        }
        xz.getTreestr('JB_base_Jobcategory', data).then(res => {
          if (res) {
            this.intendedPost = res.msg.parent
          } else {
            this.intendedPost = []
          }
        })
      },
      // 批量投放公海
      launchAllHandle() {
        if (this.isNull(this.multipleSelection)) {
          this.$message({
            type: 'warning',
            message: '请选择简历投放公海'
          })
          return false
        } else {
          this.$confirm('是否投放公海?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.saveLaunchHandle(this.injectQuery.resumeIds)
          }).catch(() => {
            console.log('已取消')
          })
        }
      },
      // 投放公海
      launchHandle(item) {
        this.$confirm('是否投放公海?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.saveLaunchHandle(item.ResumeId)
        }).catch(() => {
          console.log('已取消')
        })
      },
      // 保存投放公海
      saveLaunchHandle(id) {
        // console.log('saveLaunchHandle', id)
        if (this.isNull(id)) {
          this.$message({
            type: 'warning',
            message: '请选择简历投放公海'
          })
          return false
        } else {
          xz.LaunchResumepublic({
            resumeIds: id
          }).then(res => {
            // console.log('saveLaunchHandle', res)
            if (res.status == 'ok') {
              this.getList()
              this.$message({
                type: 'success',
                message: '操作成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: '操作失败，请稍后再试'
              })
            }
          })
        }
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      // 表格多选
      handleSelectionChange(val) {
        // console.log('yyy',val)
        this.noticeData = []
        let noteVal = JSON.parse(JSON.stringify(val))
        let noteList = noteVal.filter((ele) => {
          return ele.sendtype != 1;
        });
        this.noticeData = noteList
        let resumeIdList = []
        let ids = []
        this.multipleSelection = val;
        if (!this.isNull(val)) {
          for (let i = 0; i < val.length; i++) {
            const elementval = val[i];
            resumeIdList.push(elementval.ResumeId)
            ids.push(elementval.StrMobile)
          }
          this.injectQuery.resumeIds = resumeIdList.toString() // 简历id (多条用,连接)
          this.divideQuery.resumeIds = resumeIdList.toString()
        }
      },
      //数组去重
      unique(arr) {
        for (let i = 0; i < arr.length; i++) {
          for (let j = i + 1; j < arr.length; j++) {
            if (arr[i].toString() == arr[j].toString()) {
              arr.splice(j, 1);
              j--;
            }
          }
        }
        return arr;
      },
      changeDataHandle(departNum, departList, val) {
        for (let i = 0; i < departNum.length; i++) {
          let val01 = departNum[i]
          let devUserNum = 0 //每个部门的人数
          for (let j = 0; j < val.length; j++) {
            let val02 = val[j]
            if (val02[Number(val02.length) - 1].length < 20) {
              if (val01.toString() == val02.toString()) {
                departList.push(val01)
              }
            } else {
              // 同一个部门时
              if (val01.toString() == val02.slice(0, val02.length - 1).toString()) {
                if (devUserNum < 5) {
                  departList.push(val02)
                  devUserNum = devUserNum + 1
                  // console.log(111,devUserNum)
                  this.isCheckDepart = false
                } else {
                  this.isCheckDepart = true
                }
              }
            }
          }
        }
        departList = this.unique(departList)
        return departList;
      },
      // 选择部门
      perSectionChange(val) {
        // console.log('perSectionChange', val)
        let departList = []
        let departNum = [] //选中的部门
        this.devUserList = []
        let checkedNode = this.$refs["departLabel"].getCheckedNodes();
        if (this.isNull(val)) {
          this.divideQuery.perDepartList = []
        } else {
          for (let i = 0; i < val.length; i++) {
            let elementdepart = val[i];
            // 如果选的是部门 最多分配给五个部门
            if (elementdepart[Number(elementdepart.length) - 1].length < 20) {
              departNum.push(elementdepart)
            } else {
              // 如果选了员工
              elementdepart = elementdepart.slice(0, elementdepart.length - 1)
              departNum.push(elementdepart)
            }
            // 去重
            departNum = this.unique(departNum)
          }
          if (departNum.length > 5) {
            this.isCheckDepart = true
            departNum = departNum.splice(0, 5)
          } else {
            this.isCheckDepart = false
          }
          departList = this.changeDataHandle(departNum, departList, val)
          // console.log( '111',departList)
          this.divideQuery.perDepartList = departList
          // 父节点选中，那么所有子孙节点必然是选中的，则反推出：如果节点有父节点且父节点被选中了 过滤掉(全选和不选)
          checkedNode = checkedNode.filter(item => !(item.parent && item.parent.checked)); // 核心
          this['departLabel'] = checkedNode;
          for (let k = 0; k < this.divideQuery.perDepartList.length; k++) {
            const elementkk = this.divideQuery.perDepartList[k];
            this.devUserList.push(elementkk[Number(elementkk.length) - 1])
          }
          // console.log( 'userList',val )
          // console.log( 'checkedNode',checkedNode[0],checkedNode[0].data.strType ) ;  //获取当前点击节点的label值
          // console.log( checkedNode[0].pathLabels) ;  //获取由label组成的数组
        }
      },
      // 选择招聘顾问
      // partnerSelChange(val){
      //     // console.log('partnerSelChange', val)
      //     this.addDivideQuery.Username = ''
      //     let obj = [];
      //     if(!this.isNull(val)){
      //       this.memberList.find((item)=>{
      //           for (let i = 0; i < val.length; i++) {
      //             const elementU = val[i];
      //             if(item.Userid === elementU){
      //               obj.push(item.Username)
      //             }
      //           }
      //       });
      //       // console.log('obj',obj);
      //       //去重
      //       obj = [...new Set(obj)];
      //       this.addDivideQuery.Username = obj.toString()
      //       // this.addDivideQuery.userIds = this.addDivideQuery.userIds.concat(val)
      //       this.addDivideQuery.userIds = val
      //     }else{
      //       this.addDivideQuery.Username = ''
      //     }
      //     // this.divideQuery.userIds = val.toString()
      // },
      // 复制链接
      repeatHandle() {
        // 后台传回的链接
        let url = 'https://dev.joball.net'
        navigator.clipboard.writeText(url).then(() => {
          this.$message.success('复制成功')
        })
      },
      //生成二维码
      cerateQCode(item) {
        if ((this.activeName == '待面试' || this.activeName == '通过') && this.isNullDate(this.qrProQuery.projectid)) {
          this.$message({
            type: 'warning',
            message: '请选择项目'
          })
          return false;
        } else {
          this.getCode()
        }
      },
      xjzProChange(val) {
        let item = this.proNameList.find(item => item.Projectid == val)
        this.xjzprojectname = item.StrprojectName
      },
      cerateJXZQCode() {
        if (!this.xjzprojectid) {
          this.$message({
            type: 'warning',
            message: '请选择项目'
          })
          return false;
        } else {
          let d = {
            Type: 'Jbx',
            Path: `packageJxz/pages/chatNew/chatNew?projectid=${this.xjzprojectid}&userid=${Cookies.get("userid-b")}`,
            Width: 200,
          }
          xz.AIbasicFun(d, 'WxGenerierenQr').then(res => {
            if (res.statusCode == '200') {
              this.JXZQCode = 'data:image/png;base64,' + res.message
            } else {
              this.$message.error(res.message)
            }
          })
        }
      },
      //分页
      handleCurrentChange(val) {
        this.listQuery.currpage = Number(val)
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.currpage = 1
        this.listQuery.perpage = Number(val)
        this.getList()
      },
      // 获取消息模板列表
      getTemplateList() {
        let that = this
        //strTemplateType 1短信 2微信
        xz.gettemplatelist(this.roleType, {
          pageNum: 1,
          pageSize: 1000,
          strTemplateType: '1'
        }).then(res => {
          // console.log('gettemplatelist', res)
          if (res.status == 'ok') {
            this.noticeTempList = res.data
            if (that.activeName == '已约面') {
              that.noticeQuery.TemplateId = '1936288'
              that.tempHandle(that.noticeQuery.TemplateId)
            }
            if (that.activeName == '通过') {
              that.noticeQuery.TemplateId = '1936295'
              that.tempHandle(that.noticeQuery.TemplateId)
            }
          } else {
            this.noticeTempList = []
          }
        })
      },
      // 查询字符的数量
      sGetCharCount(str, char) {
        let regex = new RegExp(char, 'g');
        let result = str.match(regex);
        let count = !result ? 0 : result.length;
        return count;
      },
      // 获取列表
      getList() {
        let that = this;
        this.tableLoading = true
        this.isSearchHandle = true
        if (this.activeName == '在职' || this.activeName == '离职') {

        } else {
          xz.getsignResumeLists(this.listQuery).then(res => {
            // console.log('getList', res)
            if (res.status == 'ok') {
              this.tableData = res.msg
              this.total = res.totalcount
            } else {
              this.tableData = []
              this.total = 0
            }
            this.tableLoading = false
            this.isSearchHandle = false
            this.$refs.child.getSignNum();
            // this.noteNum = Number(this.$refs['child'].getNumVal());
            this.$store.commit("setResourceComTabsIsover", true);
          })
        }
      },
      policyChange(val) {
        this.declareForm.Insurance.OrderNum = val.OrderCode;
        this.declareForm.Insurance.InsuranceStartTime = val.CoverStartTime;
        this.declareForm.Insurance.InsuranceEndTime = val.CoverEndTime;
      },
      // 搜索
      searchHandle() {
        this.listQuery.currpage = 1
        // this.listQuery.strJobInf = !this.isNull(this.listQuery.posCategoryList)?this.listQuery.posCategoryList.toString():''
        // 人岗匹配岗位
        // this.listQuery.strpsnJob = !this.isNull(this.listQuery.jobList)?this.listQuery.jobList.toString():''
        // console.log('ttt',this.listQuery)
        // this.showDropScreen = -1
        // this.$refs.child.getSignNum();
        this.getList()
      },
      // 录入简历 选择公有标签
      lPubEnterHandle(val) {
        this.enTagChecks = []
        // console.log('labelEnterHandle', val)
        for (let i = 0; i < val.length; i++) {
          const elementval1 = val[i];
          this.enTagChecks.push(elementval1)
        }
      },
      // 录入简历 选择私有标签
      lPraEnterHandle(val) {
        // console.log('lPraEnterHandle', val)
        for (let i = 0; i < val.length; i++) {
          const elementval2 = val[i];
          this.enTagChecks.push(elementval2)
        }
      },
      // 简历导出
      exportHandle() {
        this.exportQuery = JSON.parse(JSON.stringify(this.listQuery))
        this.exportQuery.perpage = 1000000
        this.exportQuery.currpage = 1
        this.exportQuery.ststus = this.titleQuery.ststus
        // if (this.isNull(this.multipleSelection)) {
        //   this.$message({
        //     message: "请选择要导出的数据",
        //     type: "warning"
        //   })
        //   return false
        // } else {
        this.btnLoading = true
        this.exportQuery.stroutid = this.injectQuery.resumeIds
        // console.log('kk',this.exportQuery)
        // type 0 个人资源  1 公海资源  2报名
        xz.outputResumeList('2', this.exportQuery).then(res => {
          if (res.status == 'ok') {
            this.$router.push({
              path: "/resImportList",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                active: '导入导出记录',
                //qStstus=1时查看最后一条导出记录
                qStstus: 1
              }
            })
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error"
            })
          }
          this.btnLoading = false
        })
        // }
      },
      H5OutExcel() {
        let d = JSON.parse(JSON.stringify(this.$options.data.call(this).listQuery));
        d.StrnowState = '待入职';
        d.StrOtherSource = '是';
        d.perpage = 100000;
        this.btnLoading = true;
        xz.H5OutExcel(d, this.roleType).then(res => {
          if (res.status == 'ok') {
            this.$router.push({
              path: "/resImportList",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                active: '导入导出记录',
                qStstus: 1
              }
            })
          } else {
            this.$message({
              message: "导出失败，请稍后再试",
              type: "error"
            })
          }
        })
      },
      //获取所有标签列表
      GetLabelManagement() {
        this.laloading = true;
        this.publicList = []
        this.privateList = []
        this.allLabelList = []
        let labelList = []
        xz.GetLabelManagement(this.roleType).then(res => {
          // console.log('所有', res)
          if (res.status == 'ok') {
            this.publicList = res.data.PublicPersonList;
            this.privateList = res.data.PrivatelyList;
          }
          this.laloading = false;
        })
      },
      //获取人员列表
      getauthUserInfoByorgancode() {
        xz.getauthUserInfoByorgancode(this.departMemberQuery).then(res => {
          // console.log('gg',res)
          if (res.status == 'ok') {
            this.memberList = res.msg
          } else {
            this.memberList = []
          }
        })
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr(this.departQuery.strorgancode, this.departQuery.roletype, {
          strIsDisable: '1'
        }).then(res => {
          // console.log('部门', res)
          if (res.status == 'ok') {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children
            } else {
              this.departList = []
            }
          }
        })
      },
      // 获取表头
      getTableTitleLists() {
        if (this.activeName == '在职' && this.listQuery.SignatureStatus == '4') {
          xz.getJbbasePageColumnList('JB_busi_Statusright', '').then(res => {
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            } else {
              this.tableTitle = []
            }
          })
        } else {
          xz.getProcessColumnList(this.titleQuery.ststus).then(res => {
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            } else {
              this.tableTitle = []
            }
            // console.log('getList', this.tableTitle)
          })
        }
      },
      // 清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery
      },
      // 分配记录
      divideDtlHandle() {
        let routeUrl = this.$router.resolve({
          path: '/divideList'
        });
        window.open(routeUrl.href, '_blank');
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight)
        //   console.log('height',this.tableHeight)
      },
      // 列表搜索选择项目
      proSearChange(val) {
        this.listQuery.strJobInf = ''
        let obj = {};
        let that = this;
        // console.log('ff',obj.Projectid);
        if (!this.isNull(val)) {
          obj = this.proNameList.find((item) => {
            return item.StrprojectName === val;
          });
          this.listQuery.projectid = obj.Projectid;
          this.getresourcejobcategoryblist(obj.Projectid, 'search')
        } else {
          this.searPostList = [];
        }
        this.getList();
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
      },
      // (不包含0)
      isNullNotZero(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
      },
      isNullDate(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //签约状态筛选
      handleClick(tab) {
        // console.log('33',tab)
        this.listQuery.currpage = 1
        if (tab.name == '4') {
          this.getTableTitleLists()
        } else {
          this.getTableTitleLists()
        }
      },
      //取签约主体列表
      getLegalSubjectList() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
            this.legList = [];
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist2() {
        // let str = `?pageNum=${1}&pageSize=${10000}`
        // xz.ArdCurStatGetFun('GetLegalSubjectsList', str).then(res => {
        //   if (res.status == 'ok') {
        //     const excludedCompanies = [
        //       "无锡杰博人力资源有限公司",
        //       "杰博人力资源(西安)有限公司",
        //       "上海才服企业管理咨询有限公司",
        //       "杰博(重庆)人力资源服务有限公司",
        //       "南通市杰博人力资源有限公司"
        //     ];
        //     // 过滤掉 companyName 在 excludedCompanies 中的数据
        //     this.legList2 = res.data.date.filter(item => !excludedCompanies.includes(item.companyName));
        //   } else {
        //     this.legList2 = [];
        //   }
        // })
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            const excludedCompanies = [
              "无锡杰博人力资源有限公司",
              "杰博人力资源(西安)有限公司",
              "上海才服企业管理咨询有限公司",
              "杰博(重庆)人力资源服务有限公司",
              "南通市杰博人力资源有限公司"
            ];
            // 过滤掉 companyName 在 excludedCompanies 中的数据
            this.legList2 = res.data.date.filter(item => !excludedCompanies.includes(item.name));
          } else {
            this.legList = [];
          }
        })
      },
      //电子签约
      eleSigning() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          //判断是否选择了不同项目的人员
          let name = this.multipleSelection[0].StrprojectName;
          let hasDifferent = this.multipleSelection.some(val => val.StrprojectName != name)
          if (hasDifferent) {
            this.$message.warning('请选择同项目的人员')
          } else {
            this.clearEleForm();
            this.templatesByProjectList();
            let list = []
            this.multipleSelection.forEach((element, index) => {
              let data = {
                name: element.StrUserName,
                StrExcelPath: element.StrExcelPath,
                IntExcelLine: element.IntExcelLine,
                JobName: element.SignJob,
                DtEntryBdate: element.DtEntryBdate,
                PhoneNum: element.StrPhoneNum,
                StrIdCard: element.StrIdCard,
                EmergencyPhone: element.StrContTel,
                EmergencyContact: element.StrContName,
                StrEduLvl: element.StrEduLvl,
                Bankcard: element.StrBankCard,
                DepositBank: element.StrBankName,
                EmpContactAddress: element.StrNativeAddr,
                ClientFullName: '',
                StrDep: '', //部门
                TrialPeriodDec: '', ///试用期工资 金额
                StrReasonzh: '', //暂缓缴纳原因
                SubsidyAmount: '', //补贴金额
                SubsidyInstru: '',
              }
              list.push(data)
              if (this.multipleSelection.length == index + 1) {
                this.$set(this.eleForm, 'list', list)
                console.log(this.eleForm.list)
                this.eleForm.ObjName = this.multipleSelection[0].StrprojectName
              }
            });
            this.no = '';
            this.showEleInfo = true;
          }
        }
      },
      //根据项目查已配置好的模板列表
      templatesByProjectList() {
        xz.templatesByProjectList(this.multipleSelection[0].StrprojectName, this.roleType).then(res => {
          if (res.status == 'ok') {
            this.tempList = res.data.tempList;
            this.StrCustName = res.data.StrCustName;
          }
        })
      },
      //选择签约模板
      changeTemp(val) {
        console.log(val)
        this.eleForm.tempid = val.TempId;
        this.tempType = val.TempType;
        this.TempName = val.TempName;
      },
      //入职登记
      entryHandel() {
        const routerUrl = this.$router.resolve({
          path: "/rosterEmpEdit",
          query: {
            type: 'entry'
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      //去电子签约
      confirmToEle() {
        this.$refs["eleForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.submitESigningInfo(this.eleForm, this.roleType).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！')
                this.isBtnLoading = false;
                this.multipleSelection = []
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg)
              }
              this.showEleInfo = false;
            })
            let arr = [];
            this.eleForm.list.forEach(e => {
              let d = {
                StrExcelPath: e.StrExcelPath,
                IntExcelLine: e.IntExcelLine,
                SignJob: e.JobName,
                StrEduLv: e.StrEduLvl,
                StrBankCard: e.Bankcard,
                StrBankName: e.DepositBank,
              }
              arr.push(d)
            });
            xz.UpdateSignInfo(arr, this.roleType)
          }
        })
      },
      //初始化电子签约信息表单
      clearEleForm() {
        this.tempType = '';
        this.TempName = '';
        this.StrCustName = '';
        this.contractType = '';
        this.no = '';
        this.eleForm = {
          tempid: '', //模板id
          ContractSubject: '', //员工签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          ClientFullName: '',
          ContractStartTime: '', //合同开始时间
          ContractEndTime: '', //合同结束时间
          TrialPeriodStartTime: '', //试用期开始时间
          TrialPeriodEndTime: '', //试用期结束时间
          TrialMonth: '', //试用期时长
          ProtocolType: '', //合同/协议类型
          JobName: '', //岗位
          WorkSite: '', //工作地点
          SchoolName: '', //学校
          Bankcard: '', //银行卡号
          DepositBank: '', //开户银行
          WorkingYear: '', //工作时长(年)
          WorkingMonth: '', //工作时长(月)
          WorkingDay: '', //工作时长(天)
          TimeLaborContract: '', //终止（解除）劳动合同时间
          TimeLaborContractStaff: '', //终止（解除）劳动合同时间（员工联）
          StrEduLvl: '', //文化程度
          EmpContactAddress: '', //联系地址
          list: [], //选中的在职人员列表
        }
      },
      //选择员工签约主体
      changeLeg(val) {
        if (val) {
          xz.getLegalSubjec(val).then(res => {
            if (res.status == 'ok') {
              this.$set(this.eleForm, 'LegalPer', res.data.LegalPerson)
              this.$set(this.eleForm, 'RegisterAddress', res.data.RegisteredAddress.indexOf('$$') > -1 ? res.data.RegisteredAddress.replace('$$', '') : res.data.RegisteredAddress)
            }
          })
        } else {
          this.$set(this.eleForm, 'LegalPer', '')
          this.$set(this.eleForm, 'RegisterAddress', '')
        }
      },
      //限制input输入类型
      limitInput(val, type, item) {
        if (val >= 10000) {
          this.$message.warning(type + '不能超过1万');
          this.$nextTick(() => {
            this.eleForm[item] = undefined
          })
        }
      },
      //线下签约导入
      offSign() {
        this.ExcelSrc = {
          value: '',
          check: false,
          fileName: ''
        }
        this.showOffSign = true;
        if (this.$refs['upload2'] != undefined) {
          this.$refs['upload2'].value = null;
        }
      },
      //下载导入模板
      downImportTemp() {
        xz.getImportTemplate('线下签约导入模板', this.roleType).then(res => {
          if (res.status == 'ok') {
            var path = this.$store.state.EMP.tablePath + res.data;
            const aTag = document.createElement('a')
            aTag.href = path
            aTag.click();
          } else {
            this.$message.error('获取模板失败')
          }
        })
      },
      //文件读取
      async importf2() {
        const fileInput = this.$refs.upload2;
        FUN.returnExcelSrc(fileInput).then((src) => {
          if (src) {
            this.$set(this.ExcelSrc, "value", src.src);
            this.$set(this.ExcelSrc, "check", false);
            this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
            const excelFile = FUN.base64ToFile(
              this.ExcelSrc.value,
              this.ExcelSrc.fileName
            );
            const formData = new FormData();
            formData.append("pagename", "empexcel");
            formData.append("action", "save");
            formData.append("userid", Cookies.get("userid-b"));
            formData.append("entid", this.entid);
            formData.append("excel", excelFile, this.ExcelSrc.fileName);
            console.log("formData", formData);
            xz.uploadCert(formData).then((res) => {
              if (this.isNull(res) || res == false) {
                this.$message("上传Excel失败!");
                this.impUrl = '';
                this.isUploadSuccess2 = false;
                this.$refs['upload2'].value = null;
              } else {
                this.isUploadSuccess2 = true;
                this.impUrl = res;
              }
            });
          } else {
            this.$message("上传Excel失败!");
            this.impUrl = '';
            this.isUploadSuccess2 = false;
            this.$refs['upload2'].value = null;
          }
        });
      },
      //确认导入excel
      confirmImport() {
        if (this.impUrl) {
          xz.offlineSigningImportTemplate(this.impUrl, this.roleType).then(res => {
            if (res.status == 'ok') {
              this.$message.success('导入成功！');
            } else {
              this.$message.error(res.msg)
            }
            this.showOffSign = false;
          })
        } else {
          this.$message.warning('请上传Excel')
        }
      },
      //算试用期结束时间
      getEndDate() {
        this.eleForm.TrialMonth = Number(this.eleForm.TrialMonth)
        if (this.eleForm.TrialMonth > 0 && Number.isInteger(this.eleForm.TrialMonth)) {
          this.eleForm.TrialPeriodEndTime = moment(this.eleForm.TrialPeriodStartTime).add(this.eleForm.TrialMonth, 'months').format('YYYY-MM-DD');
          this.eleForm.TrialPeriodEndTime = moment(this.eleForm.TrialPeriodEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        }
        if (this.eleForm.TrialMonth > 6) {
          this.$message.warning('当前试用期已超过6个月，请核对！');
        }
      },
      //算合同结束时间
      getContractEndDate() {
        if (this.ContractTime >= 1) {
          this.eleForm.ContractEndTime = moment(this.eleForm.ContractStartTime).add(this.ContractTime, 'years').format('YYYY-MM-DD');
          this.eleForm.ContractEndTime = moment(this.eleForm.ContractEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        }
      },
      //选择合同/协议
      changeCont(val) {
        console.log(val)
        this.eleForm.ProtocolType = val.name;
        this.contractType = val.val;
        this.no = val.no;
      },
      //计算工作时长
      changeTimeLaborContract(val) {
        let m1 = this.eleForm.ContractStartTime + ' 00:00:00';
        let m2 = this.eleForm.TimeLaborContract + ' 00:00:00';
        let diff = moment.preciseDiff(m1, m2, true);
        console.log(diff)
        this.eleForm.WorkingYear = diff.years;
        this.eleForm.WorkingMonth = diff.months;
        this.eleForm.WorkingDay = diff.days + 1;
      },
      //取自己可取到险种
      getInsurancManageByUserid() {
        let data = {
          pageNum: 1,
          pageSize: 10000
        }
        xz.getInsurancManageByUserid(data, this.roleType).then(res => {
          if (res.status == 'ok') {
            this.planList = res.data.list;
          } else {
            // this.$message("获取险种列表出错!");
            this.planList = []
          }
        })
      },
      //取职业类别
      getInsurancCategory(Id) {
        xz.getInsurancManage(Id, this.roleType).then(res => {
          if (res.status == 'ok') {
            this.JobClasssList = res.data.InsuranceManage.EmployeeAttribute.split(',');
          } else {
            // this.$message("获取险种列表出错!");
            this.JobClasssList = []
          }
        })
      },
      //批量商保报增
      handleInsure() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          //判断是否选择了不同项目的人员
          let name = this.multipleSelection[0].StrprojectName;
          let hasDifferent = this.multipleSelection.some(val => val.StrprojectName != name)
          let hasInsurance = this.multipleSelection.some(val => val.Insurance != '未参保'); //判断是否有已参保的 
          if (hasDifferent) {
            this.$message.warning('请选择同项目的人员')
          } else if (hasInsurance) {
            this.$message.warning('已参保的人员不能报增')
          } else {
            if (this.planList.length == 0) {
              this.getInsurancManageByUserid();
            }
            this.clearEleForm();
            let list = []
            this.multipleSelection.forEach((element, index) => {
              let data = {
                MainlinsuredName: element.StrUserName,
                MainlinsuredCardId: element.StrIdCard,
                Idtype: '身份证', //证件类型
                MainlinsuredPhone: element.StrPhoneNum,
                JobName: element.InsureJob, //商保岗位
                EmployeeAttribute: '', //员工属性
                JobClasss: '', //职业类别
                LaborContractUnit: '',
              }
              list.push(data)
              if (this.multipleSelection.length == index + 1) {
                this.$set(this.declareForm, 'userList', list)
                console.log(this.declareForm)
                this.declareForm.Insurance.ProjectName = this.multipleSelection[0].StrprojectName
                this.declareForm.Insurance.Projectid = this.multipleSelection[0].Projectid
              }
            });
            this.showDeclare = true;
          }
        }
      },
      confirmToInsure() {
        this.$refs["declareForm"].validate((valid) => {
          if (valid) {
            xz.reportAddApprov(this.declareForm, this.roleType).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！');
                this.showDeclare = false;
              } else {
                this.$message.error(res.msg);
                this.showDeclare = false;
              }
            })
          }
        })
      },
      reduction(list) {
        if (this[list].length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          let arr = [];
          let canReduct = true;
          this[list].forEach((e, index) => {
            if (e.Insurance == '否') {
              canReduct = false;
            }
            if (e.InsureId) {
              let d = {
                Id: e.InsureId,
                ProjectName: e.StrprojectName
              }
              arr.push(d)
            }
            if (index == this[list].length - 1) {
              if (!canReduct) {
                this.$message.warning('请选择在保的人员报减')
              } else if (canReduct) {
                this.tableLoading = true;
                this.btnLoading08 = true;
                console.log(arr)
                xz.ReportReduce(arr, localStorage.loginRoletype).then(res => {
                  if (res.status == 'ok') {
                    this.$message.success('报减成功！');
                    this.tableLoading = false;
                    this.btnLoading08 = false;
                    this.getList();
                    this.showReduction = false;
                    if (res.warnMsg) {
                      this.warnMsg = res.warnMsg;
                      this.showWarnMsg = true;
                    }
                  } else {
                    this.tableLoading = false;
                    this.btnLoading08 = false;
                    this.showReduction = false;
                    this.$message.error(res.msg);
                  }
                })
              }
            }
          })
        }
      },
      // 身份证校验
      checkIdcard(row) {
        let val = row.StrIdCard;
        try {
          if (val != null && val.length == 18) {
            const idcode = val;
            const weight_factor = [
              7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,
            ];
            const check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2", ];
            const code = idcode + "";
            const last = idcode[17].toUpperCase(); // 最后一个
            const seventeen = code.substring(0, 17);
            // ISO 7064:1983.MOD 11-2
            // 判断最后一位校验码是否正确
            const arr = seventeen.split("");
            const len = arr.length;
            let num = 0;
            for (let i = 0; i < len; i++) {
              num = num + arr[i] * weight_factor[i];
            }
            // 获取余数
            var resisue = num % 11;
            var last_no = check_code[resisue];
            // 格式的正则
            // 正则思路
            var idcard_patter =
              /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
            // 判断格式是否正确
            var format = idcard_patter.test(idcode);
            console.log(last === last_no && format == true)
            if (last === last_no && format == true) {
              this.$set(row, 'judge', true)
            } else {
              this.$set(row, 'judge', false)
            }
          } else if (val == null) {
            this.$set(row, 'StrIdCard', '')
            this.$set(row, 'judge', false)
          } else {
            this.$set(row, 'judge', false)
          }
        } catch (e) {
          console.log('11', e)
          this.$set(row, 'judge', false)
        }
      },
      signHandle(type) {
        this.signType = type
        this.showEntrySign = true;
        setTimeout(() => {
          this.$refs.entrySignRef.reset()
        }, 100)
      },
      //关闭登记弹窗
      close() {
        this.showEntrySign = false;
        this.getList();
      },
      delRow(i) {
        this.passInterTableData.splice(i, 1)
      },
      closePrint() {
        this.showPrint = false;
      },
      printHandel(row) {
        let dd = {
          type: 1, //类型1：流程2：花名册
          processIds: [row.GdststusId],
          baseKeys: []
        }
        this.GetPrintData(dd)
      },
      batchPrint() {
        if (this.multipleSelection.length > 0) {
          let ids = [];
          this.multipleSelection.forEach(e => {
            ids.push(e.GdststusId)
          });
          let dd = {
            type: 1, //类型1：流程2：花名册
            processIds: ids,
            baseKeys: []
          }
          this.GetPrintData(dd)
        } else {
          this.$message.warning('请至少选择一条数据打印')
        }
      },
      GetPrintData(d) {
        xz.rcFun(d, 'InterviewOnboarding/GetPrintData').then(res => {
          if (res.status == 'ok') {
            res.data.forEach(ee => {
              ee.checked = false;
              ee.checked2 = false;
              if (ee.householdFoodSupply == '农') {
                ee.checked = true;
              } else if (ee.householdFoodSupply == '居') {
                ee.checked2 = true;
              }
              ee.checkList = [];
              if (ee.politicalAffiliation) {
                ee.checkList.push(ee.politicalAffiliation)
              }
              if (ee.educational.length < 3) {
                // 修复：每次都创建新对象而不是复用同一个对象
                while (ee.educational.length < 3) {
                  ee.educational.push({
                    startEndTime: '',
                    schoolName: '',
                    professional: '',
                    remark: ''
                  });
                }
              }
              if (ee.work.length < 3) {
                // 修复：每次都创建新对象而不是复用同一个对象
                while (ee.work.length < 3) {
                  ee.work.push({
                    startingWorkDate: '',
                    resignationDate: '',
                    organization: '',
                    position: '',
                    resignationReason: ''
                  });
                }
              }
              if (ee.member.length < 3) {
                // 修复：每次都创建新对象而不是复用同一个对象
                while (ee.member.length < 3) {
                  ee.member.push({
                    relationship: '',
                    name: '',
                    birthDate: '',
                    workplace: '',
                    position: '',
                    telephone: ''
                  });
                }
              }
            });
            this.printList = res.data;
            this.showPrint = true;
          } else {
            this.$message.error(res.msg);
          }
        });
      },
      getBirthFromIdCard(idCard) {
        if (idCard && idCard.length === 18) {
          const year = idCard.substring(6, 10);
          const month = idCard.substring(10, 12);
          const day = idCard.substring(12, 14);
          return `${year}-${month}-${day}`;
        }
        return '';
      },
      changeDtEntry(val) {
        this.passInterTableData.forEach(e => {
          e.DtEntryBdate = val
        });
        // console.log('11',this.passInterTableData,val)
      },
      changeWorkState(val) {
        this.passInterTableData.forEach(e => {
          e.StrWorkState = val
        });
      },
      changeStrBlCmp(val) {
        this.passInterTableData.forEach(e => {
          e.StrBlCmp = val
        });
      },
      //修改手机号
      editPhone(row) {
        this.insLoading = false;
        this.phoneInfo = {
          StrExcelPath: row.StrExcelPath,
          IntExcelLine: row.IntExcelLine,
          StrPhoneNum: row.StrMobile
        }
        this.showEditPhone = true;
      },
      confirmEditPhone() {
        const regex = /^1[3-9]\d{9}$/;
        if (!regex.test(this.phoneInfo.StrPhoneNum)) {
          this.$toast.fail('请填写正确的手机号码')
        } else {
          xz.updateEmpPhone(this.phoneInfo).then(res => {
            if (res.status == 'ok') {
              this.$message.success('修改成功！');
              this.showEditPhone = false;
              this.insLoading = false;
            } else {
              this.$message.error(res.msg);
              this.insLoading = false;
            }
          })
        }
      },
      iulHandle() {
        this.iulForm = {
          start: '',
          end: '',
          userid: Cookies.get("userid-b"),
          filename: '使用人数导出.xlsx',
        }
        this.showImportUserList = true;
      },
      confirmImportUserList() {
        if (this.iulForm.start && this.iulForm.end) {
          this.isBtnLoading = true;
          xz.rcFun(this.iulForm, 'InterviewOnboarding/ReportUseNumberData/download').then(res => {
            if (res.status == 'ok') {
              this.$message.success('下载任务创建成功！');
              this.isBtnLoading = false;
              this.showImportUserList = false;
              this.$store.dispatch('triggerRefresh')
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          })
        } else {
          this.$message.warning('请选择开始时间和结束时间！')
        }
      },
      changebJob(val) {
        this.passInterTableData.forEach(e => {
          e.CustomerJobName = val
        });
      },
      changeRecruitdep(val) {
        this.passInterTableData.forEach(e => {
          e.Recruitdep = val
        });
      },
      // 打开发送通知弹框
      openSendNoticeDialog() {
        this.sendNoticeLoading = false;
        this.channels = {
          sms: false,
          wx: false
        };
        this.sendNoticeForm = {
          channelType: '',
          channelId: '',
          templateId: '',
          customVariableValues: {},
          recipients: [],
          sendTime: null,
          sendType: 1,
          SenderId: Cookies.get("userid-b")
        }
        this.smsCategory = '';
        this.selectedNoticeRows = JSON.parse(JSON.stringify(this.multipleSelection));
        this.sendNoticeForm.recipients = [];
        this.selectedNoticeRows.forEach(element => {
          let arr = {
            businessId: element.GdststusId,
            recipient: element.StrMobile,
            recipientName: element.StrUserName
          }
          this.sendNoticeForm.recipients.push(arr)
        });
        this.previewTab = 'sms'
        if (this.activeName == '报名') {
          this.smsCategoryList = [{
            Name: '面试',
            Id: 1
          }];
        } else if (this.activeName == '待面试') {
          this.smsCategoryList = [{
            Name: '面试通过',
            Id: 2
          }];
        } else if (this.activeName == '待入职') {
          this.smsCategoryList = [{
            Name: '录用/报道',
            Id: 3
          }];
        }
        this.smsCategory = this.smsCategoryList[0].Id
        this.sendNoticeVisible = true
      },
      // 渠道切换
      onChannelChange() {
        if (!this.channels.sms) {
          this.sendNoticeForm.templateId = ''
          this.smsCategory = ''
        }
        if (this.channels.sms && !this.channels.wx) {
          this.previewTab = 'sms'
        } else if (!this.channels.sms && this.channels.wx) {
          this.previewTab = 'wx'
        }
      },
      onSmsSignChange(val) {
        let item = this.smsSignList.find(e => {
          return e.Id == val
        })
        this.signName = item.Name;
        let d = {
          senderSubjectId: val,
          sceneType: this.smsCategory
        }
        xz.messageFun(d, 'GetSendTemplateOptions').then(res => {
          if (res.status == 'ok') {
            this.smsTemplateList = res.data
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      smsTemplateChange(val) {
        let item = this.smsTemplateList.find(e => {
          return e.templateId == val
        })
        this.sendNoticeForm.channelId = item.channelId;
        let str = `GetDetail?TemplateId=${val}`;
        xz.messageGetFun(str, 'get').then(res => {
          if (res.status == 'ok') {
            this.filedList = res.data.channels[0].variables;
            this.filedList.sort((a, b) => (a.sortNo || 0) - (b.sortNo || 0));
            this.smsTemplateContent = res.data.channels[0].content;
            // 根据返回的变量列表动态生成 customVariableValues
            let customVarValues = {};
            this.filedList.forEach(item => {
              customVarValues[item.variableName] = item.customValue || '';
            });
            this.sendNoticeForm.customVariableValues = customVarValues;
            this.getSmsPreviewText();
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 短信类别切换
      onSmsCategoryChange() {
        this.sendNoticeForm.templateId = ''
      },
      // 公众号类别切换
      onWxCategoryChange() {
        this.sendNoticeForm.wxTemplate = ''
      },
      getRemark(val) {
        if (!val) {
          this.sendNoticeForm.customVariableValues.备注 = ''
          return
        }
        let result = val.replace(/,/g, '，')
        if (result.charAt(0) !== '，') {
          result = '，' + result
        }
        this.sendNoticeForm.customVariableValues.备注 = result
        this.getSmsPreviewText();
      },
      getSmsPreviewText() {
        let template = this.smsTemplateContent || '';
        if (!template) {
          this.smsPreviewText = '';
          return;
        }
        this.filedList.forEach(item => {
          let val = this.sendNoticeForm.customVariableValues[item.variableName];
          let placeholder = '{' + item.variableName + '}';
          if (val) {
            template = template.split(placeholder).join(val);
          }
        });
        this.smsPreviewText = template;
      },
      // 预览Tab切换
      onPreviewTabChange() {},
      // 确认发送通知
      confirmSendNotice() {
        if (this.selectedNoticeRows.length === 0) {
          this.$message.warning('请选择接收人')
          return
        }
        if (!this.channels.sms && !this.channels.wx) {
          this.$message.warning('请选择至少一种发送渠道')
          return
        }
        if (this.channels.sms && !this.sendNoticeForm.templateId) {
          this.$message.warning('请选择短信模板')
          return
        }
        // if (this.channels.wx && !this.sendNoticeForm.wxTemplate) {
        //   this.$message.warning('请选择公众号模板')
        //   return
        // }
        this.$confirm('发送录用通知后将产生法律效力，确认发送？', '法律提示', {
          confirmButtonText: '确认发送',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.sendNoticeLoading = true;
          xz.messageFun(this.sendNoticeForm, 'Send').then(res => {
            if (res.status == 'ok') {
              this.$message.success('发送成功')
              this.sendNoticeVisible = false
              this.sendNoticeLoading = false
              this.selectedNoticeRows = []
            } else {
              this.sendNoticeLoading = false
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {})
      },
      sendModelSet() {
        const routerUrl = this.$router.resolve({
          path: "/sendModelSet"
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
    }
  }
</script>

<style scoped>
  .dia_flex_item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    margin-right: 10px;
  }

  .ml10 {
    margin-left: 10px;
  }

  .dia_flex_box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 8px;
  }

  .flex_cen {
    justify-content: center;
  }

  .dia_flex_box p {
    width: 100px;
    font-size: 14px;
    color: #333;
    margin-top: 0;
  }

  .send_icon {
    position: relative;
  }

  i.el-icon-s-comment {
    position: absolute;
    right: 20px;
    top: 0;
    z-index: 10;
    color: #E6A23C;
    font-size: 18px;
  }

  .n_txt_box {
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    margin: 10px 0;
  }

  .n_txt_box .txts {
    color: #F56C6C;
    font-weight: bold;
  }

  /* .n_txt_box .n_txt_content p{
  color:#000;
} */
  .res_dialog .interview_title {
    font-size: 13px;
    color: #F56C6C;
    font-weight: bold;
    padding-left: 30px;
    margin-bottom: 22px;
  }

  /* 导入样式 */
  .import_basic_box {
    display: flex;
    flex-wrap: wrap;
  }

  .face_line_box {
    display: flex;
    flex-wrap: wrap;
  }

  .face_line_box .txts {
    margin-left: 3px;
    font-size: 14px;
  }

  .face_txt {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 5px;
    color: #F56C6C;
  }

  .b_txt_com {
    color: #F56C6C;
    font-weight: bold;
  }

  .com_empty {
    width: 100%;
    padding: 10px;
    color: #666;
    font-size: 14px;
    text-align: center;
  }

  .s_tabs_box {
    position: relative;
  }

  .s_badge {
    position: absolute;
    right: 0;
    top: 0;
    background-color: #F56C6C;
    border-radius: 10px;
    color: #FFF;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #FFF;
  }

  .com_date_box {
    display: flex;
    align-items: center;
  }

  .com_date_content {
    width: 380px;
  }

  .r_dropDownScreen {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    padding-left: 28px;
  }

  .f_table {
    padding-bottom: 40px;
  }

  .c_dlt_icon {
    cursor: pointer;
    font-size: 18px;
    color: #F56C6C;
  }

  .r_label_search .labGroup {
    margin-bottom: 0;
  }

  .groupname {
    font-size: 14px;
    margin-right: 10px;
  }

  .banlabel {
    color: #c0c4cc;
  }

  .r_l_title {
    font-size: 14px;
    color: #333;
    line-height: 25px;
    font-weight: bold;
    border-bottom: 1px dashed #ddd;
  }

  .form-item input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #ccc;
    padding-left: 14px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 10px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput,
  #templateInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  /* 这是主要的，文件上传按钮的样式 */
  .file-btn {
    display: inline-block;
    width: 54px;
    height: 31px;
    background: #fff;
    border: 1px solid #ccc;
    /* border-radius:2px; */
    text-align: center !important;
    line-height: 32px;
    color: #333333;
    /* position: relative;
  top: 5px;
  left: 0; */
    margin-left: 8px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 5px;
  }

  .f_btns {
    display: flex;
    justify-content: flex-end;
  }

  .f_list_item {
    margin-bottom: 10px;
  }

  .f_list_item span {
    margin-right: 10px;
  }

  .r_label_title {
    font-size: 15px;
    color: #409eff;
    font-weight: 500;
    padding-bottom: 10px;
    border-bottom: 1px solid #EBEEF5;
  }

  .r_label_list {
    margin-top: 10px;
  }

  .labGroup {
    margin-bottom: 10px;
    flex-wrap: wrap;
  }

  .ftabs {
    background: #fff;
    width: 99%;
  }

  .r_line_box {
    display: flex;
    align-items: center;
  }

  .r_line_txt {
    width: 20px;
    height: 1px;
    background-color: #DCDFE6;
    margin: 0 5px;
  }

  .r_more_box {
    display: flex;
  }

  .r_more_txt {
    display: inline-block;
    width: 60px;
    margin-right: 5px;
    margin-left: 30px;
    font-size: 13px;
    cursor: pointer;
    color: #409eff;
  }

  .r_more_txt i {
    font-size: 14px;
    color: #409eff;
    transition: all 0.3s;
  }

  .rotate-img {
    transform: rotate(270deg);
  }

  .res_dialog_popover {
    display: flex;
    justify-content: flex-end;
  }

  .divide_item {
    margin-bottom: 10px;
    font-size: 14px;
    color: #333
  }

  .pop_list_box .d_txt02,
  .pop_list_box .d_txt03 {
    margin-right: 5px;
  }

  .pop_list_box .d_txt04 {
    color: #409eff;
    font-size: 13px;
    text-decoration: underline;
  }

  .notice_title {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: #409eff;
    font-size: 14px;
  }

  .notice_title span {
    cursor: pointer;
  }

  .notice_title i {
    font-size: 16px;
  }

  .eleTltle {
    font-weight: 600;
    font-size: 16px;
    text-transform: capitalize;
    width: 100%;
    padding: 5px 0;
    background: #fff;
    text-align: center;
  }

  .eleTltle2 {
    font-size: 14px;
    text-transform: capitalize;
    width: 100%;
    padding: 5px 0;
    background: #fff;
    text-align: center;
  }


  .psnDtlItem {
    width: 180px;
    /* 固定宽度 */
    font-size: 14px;
    /* 字体大小 */
    color: #333;
    /* 文字颜色 */
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 文本溢出时显示省略号 */
    box-sizing: border-box;
    /* 保证宽高包含边框与padding */
  }

  .quitTips {
    font-size: 14px;
  }

  .send_notice_dialog .notice_section {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
  }

  .send_notice_dialog .notice_label {
    width: 100px;
    flex-shrink: 0;
    font-size: 14px;
    color: #333;
    text-align: right;
    padding-right: 10px;
    line-height: 32px;
  }

  .send_notice_dialog .notice_content {
    flex: 1;
    font-size: 14px;
    color: #333;
  }

  .radio_group {
    height: 32px;
    line-height: 32px;
  }

  .send_notice_dialog .count_num {
    font-weight: bold;
    color: #409EFF;
    margin-right: 6px;
  }

  .send_notice_dialog .recipient_names {
    color: #666;
    line-height: 1.6;
  }

  .send_notice_dialog .channel_box .el-checkbox {
    margin-right: 20px;
  }

  .send_notice_dialog .optional_fields .optional_item {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .send_notice_dialog .optional_fields .optional_item .el-checkbox {
    margin-right: 0;
  }

  .send_notice_dialog .optional_fields .optional_item .el-radio {
    margin-right: 10px;
    margin-left: 10px;
  }

  .send_notice_dialog .preview_box {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 12px;
    background: #f5f7fa;
    min-height: 60px;
    font-size: 13px;
    line-height: 1.6;
    color: #606266;
  }

  .send_notice_dialog .wx_preview .wx_card {
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    padding: 14px;
  }

  .send_notice_dialog .wx_preview .wx_card_title {
    font-weight: bold;
    margin-bottom: 8px;
    font-size: 14px;
  }

  .send_notice_dialog .wx_preview .wx_card_pos,
  .send_notice_dialog .wx_preview .wx_card_time,
  .send_notice_dialog .wx_preview .wx_card_remark {
    margin-bottom: 4px;
    font-size: 13px;
    color: #606266;
  }

  .send_notice_dialog .wx_preview .wx_card_btns {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #dcdfe6;
  }

  .send_notice_dialog .wx_preview .wx_link {
    color: #409EFF;
    cursor: pointer;
    margin-right: 20px;
    font-size: 13px;
  }

  .send_notice_dialog .wx_preview .wx_link:hover {
    text-decoration: underline;
  }

  .send_notice_dialog .clock_icon {
    margin-left: 6px;
    color: #909399;
    font-size: 16px;
  }

  .send_notice_dialog .notice_warning {
    text-align: center;
    padding: 10px 0 5px;
  }

  .send_notice_dialog .warning_text {
    color: red;
    font-size: 13px;
    font-weight: bold;
  }
</style>

<style>
  .p_resource_sign .choose-row {
    background-color: rgb(255, 199, 206) !important;
  }

  .ins_dialog_box .el-table .el-table__cell {
    padding: 3px 0;
  }

  .note_dialog .el-table .el-table__cell {
    padding: 5px 0;
  }

  .note_dialog .el-form-item {
    margin-bottom: 5px;
  }

  .note_dialog .n_temp_form.el-form-item {
    margin-bottom: 17px;
  }

  .note_dialog .el-dialog__body {
    padding: 5px 20px;
  }

  .p_resource_sign .ftabs .el-tabs__header {
    margin-bottom: 10px;
  }

  .com_import_box .storageInput .el-input--small .el-input__inner,
  .com_import_box .storageInput .el-input--small {
    width: 240px;
  }

  .re_down_form .s_date_box .s_date_box01.el-select {
    width: 115px;
    margin-right: 10px;
  }

  .re_down_form .s_date_box .s_date_box02.el-select {
    width: 100px;
  }

  .face_note_txt .el-form-item__label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

  .s_sel_box.el-select {
    width: 180px;
  }

  .p_resource_sign .el-table .cell {
    padding-left: 5px;
    padding-right: 5px;
  }

  .pass_check .el-checkbox__label {
    font-size: 13px;
    padding-left: 5px;
  }

  .r_act_item .com_btn {
    background-color: #19bd92;
    border-color: #19bd92;
    color: #fff;
  }

  .res_dialog .act_date.el-input {
    width: 130px;
  }

  .sur_dialog .act_time.el-date-editor.el-input {
    width: 110px;
  }

  .sur_dialog .act_date_time.el-date-editor.el-input {
    width: 160px;
  }

  .sur_dialog .el-date-editor.el-input {
    width: 130px;
  }

  .sur_dialog .el-dialog__body,
  .res_dialog01 .el-dialog__body {
    max-height: 400px;
    overflow-y: auto;
  }

  .sur_dialog .el-table .el-table__cell {
    padding: 3px;
  }

  .re_down_form .com_date_content .el-form-item__content {
    width: 280px !important;
  }

  .r_more_box .dia_label_box {
    flex: 1;
    max-height: 200px;
  }

  .dia_label_box .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0;
  }

  .dia_label_box .el-checkbox.is-bordered.is-checked,
  .dia_label_box .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #19BD92;
  }

  .dia_label_box {
    max-height: 400px;
    overflow-y: auto;
  }

  .r_more_box .dia_label_box .dia_groupname {
    font-weight: normal;
  }

  .dia_label_box .dia_groupname {
    font-size: 14px;
    line-height: 25px;
    color: #333;
    font-weight: bold;
    margin-top: 5px;
    /* border-bottom: 1px solid #ddd; */
  }

  .dia_label_box .el-checkbox {
    border: 1px solid #ddd;
    padding: 2px 3px;
    border-radius: 3px;
    height: auto;
    margin: 5px 20px 0 0;
  }

  .p_resource_module1 .r_dropDownScreen .el-checkbox__label,
  .dia_label_box .el-checkbox__label {
    padding-left: 3px;
  }

  .disableFirstLevel .el-cascader-panel .el-cascader-menu:first-child .el-cascader-node .el-checkbox {
    display: none;
  }

  .msgerror {
    color: #F56C6C;
  }

  .d_rule_txt01 {
    font-size: 13px;
    color: #F56C6C;
    margin-bottom: 10px;
  }

  .com_dialog_btn.el-button {
    background-color: #ebfaf5;
    border: 1px solid #62d2b4;
    color: #19BD92;
    font-weight: bold;
  }

  .com_dialog_btn.el-button:hover {
    background-color: #19BD92;
    border: 1px solid #62d2b4;
    color: #fff;
  }

  .el-tabs__item.is-active {
    color: #19bd92 !important;
  }

  .d_rule_box {
    margin-top: 3px;
    margin-bottom: 8px;
  }

  .d_rule_box .txt01 {
    font-weight: bold;
    font-size: 14px;
    color: #333;
  }

  .d_rule_box .txt02 {
    font-size: 13px;
    color: #666;
  }

  .re_dialog_form02 .el-cascader {
    width: 100%;
  }

  .re_act_box .el-button {
    padding: 4px 8px;
  }

  .p_resource_module1 .el-table .com_Selection.cell {
    padding: 0 25px 0 5px;
  }

  .p_resource_module1 .el-table .com_Selection.cell .el-checkbox__inner {
    position: relative;
  }

  .p_resource_module1 .el-table .com_Selection.cell:before {
    content: "全选";
    position: absolute;
    right: 2px;
    top: 1px;
  }

  .re_table.el-table .cell {
    padding: 0 5px;
  }

  .p_resource_module1 .screenInput .el-select .el-input__inner {
    width: 100%;
  }


  .re_table.el-table td.el-table__cell {
    padding: 3px 0;
  }

  .re_table th.el-table__cell {
    padding: 5px 0;
  }

  .res_dialog .el-dialog__body {
    padding: 5px 20px 20px 20px;
  }

  .divide_dialog .el-table .el-table__cell {
    padding: 0;
  }

  .note_label .el-form-item__label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }

  .enter_dialog .el-dialog__body {
    padding: 5px 20px 10px 20px;
  }

  .labGroup .el-checkbox__label {
    padding-left: 5px;
  }

  .labGroup .el-checkbox {
    margin-right: 20px;
  }

  .qrBox1 {
    display: flex;
    align-items: center;
    padding-left: 30px;
    margin-bottom: 15px;
  }

  .qrItem {
    display: flex;
    align-items: center;
  }

  .qrItem .qrcode_img01 {
    width: 25px;
    height: 25px;
    margin-left: 5px;
  }

  .qrcode_img02 {
    width: 200px;
    height: 200px;
    margin-bottom: 5px;
  }

  .qrcode_img03 {
    width: 200px;
    height: 230px;
    margin-bottom: 5px;
  }

  .r_act_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    margin-bottom: 10px;
  }

  .e_txt_box {
    font-size: 14px;
    color: #409eff;
    text-align: right;
  }

  .r_act_item .r_txt01 {
    font-size: 14px;
    color: #333;
    margin-right: 5px;
  }

  .qrItem .r_txt02 {
    font-size: 14px;
    color: #409eff;
    margin-left: 8px;
  }

  .qrcode_box {
    width: 200px;
    /* height: 200px; */
  }

  .qrcode_box .r_txt03 {
    font-size: 14px;
    color: #333;
    text-align: center;
  }

  .r_act_left {
    display: flex;
    align-items: center;
  }

  .r_act_item {
    display: flex;
    align-items: center;
    margin-right: 8px;
  }

  .f_all_width {
    width: 100%;
    align-items: center;
  }

  .f_checks_box {
    /* line-height: 25px; */
    /* height: 45px; */
    /* overflow: hidden; */
    flex-wrap: wrap;
    flex: 1;
  }

  .res_dialog .r_more_txt {
    margin-left: 0;
  }

  .re_down_form.el-form--inline .f_all_width .el-form-item__content {
    width: calc(100% - 100px);
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .enter_dialog .re_down_form .el-form-item {
    margin-bottom: 20px;
    margin-right: 0;
  }

  .eleForm .el-dialog__body {
    padding: 20px
  }

  .p_resource_sign .eleForm .el-input-number__increase,
  .p_resource_sign .eleForm .el-input-number__decrease {
    display: none;
  }

  .p_resource_sign .eleForm .el-input-number .el-input__inner {
    padding-left: 15px;
    padding-right: 15px;
    text-align: left;
  }

  .p_resource_sign .eleForm .el-input-number {
    width: 200px;
  }

  .p_resource_sign .el-input__icon {
    height: 32px;
  }

  .p_resource_sign .entryTable .el-input__icon {
    height: 28px;
  }

  .p_resource_sign .eleForm .el-form-item {
    margin-bottom: 2px;
  }

  .p_resource_sign .eleForm .el-form-item__error {
    top: 34px;
  }

  .p_resource_sign .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .p_resource_sign .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }
</style>